var Nd = Object.defineProperty;
var pi = (e) => {
  throw TypeError(e);
};
var Dd = (e, t, r) => t in e ? Nd(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var Te = (e, t, r) => Dd(e, typeof t != "symbol" ? t + "" : t, r), yi = (e, t, r) => t.has(e) || pi("Cannot " + r);
var _ = (e, t, r) => (yi(e, t, "read from private field"), r ? r.call(e) : t.get(e)), ke = (e, t, r) => t.has(e) ? pi("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, r), Pe = (e, t, r, n) => (yi(e, t, "write to private field"), n ? n.call(e, r) : t.set(e, r), r);
var jd = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, a = t.length, s; n < a; n++)
    (s || !(n in t)) && (s || (s = Array.prototype.slice.call(t, 0, n)), s[n] = t[n]);
  return e.concat(s || Array.prototype.slice.call(t));
};
function Hd(e) {
  return e;
}
function $e(e, t, r, n, a, s, i, o, c) {
  switch (arguments.length) {
    case 1:
      return e;
    case 2:
      return function() {
        return t(e.apply(this, arguments));
      };
    case 3:
      return function() {
        return r(t(e.apply(this, arguments)));
      };
    case 4:
      return function() {
        return n(r(t(e.apply(this, arguments))));
      };
    case 5:
      return function() {
        return a(n(r(t(e.apply(this, arguments)))));
      };
    case 6:
      return function() {
        return s(a(n(r(t(e.apply(this, arguments))))));
      };
    case 7:
      return function() {
        return i(s(a(n(r(t(e.apply(this, arguments)))))));
      };
    case 8:
      return function() {
        return o(i(s(a(n(r(t(e.apply(this, arguments))))))));
      };
    case 9:
      return function() {
        return c(o(i(s(a(n(r(t(e.apply(this, arguments)))))))));
      };
  }
}
function S(e, t, r, n, a, s, i, o, c) {
  switch (arguments.length) {
    case 1:
      return e;
    case 2:
      return t(e);
    case 3:
      return r(t(e));
    case 4:
      return n(r(t(e)));
    case 5:
      return a(n(r(t(e))));
    case 6:
      return s(a(n(r(t(e)))));
    case 7:
      return i(s(a(n(r(t(e))))));
    case 8:
      return o(i(s(a(n(r(t(e)))))));
    case 9:
      return c(o(i(s(a(n(r(t(e))))))));
    default: {
      for (var l = arguments[0], h = 1; h < arguments.length; h++)
        l = arguments[h](l);
      return l;
    }
  }
}
var Ld = function(e, t) {
  var r = function(n) {
    return n.length >= e;
  };
  return function() {
    var n = Array.from(arguments);
    return r(arguments) ? t.apply(this, n) : function(a) {
      return t.apply(void 0, jd([a], n, !1));
    };
  };
}, Ud = function(e) {
  return {
    equals: function(t, r) {
      return t === r || e(t, r);
    }
  };
}, Kd = function(e) {
  return Ud(function(t, r) {
    for (var n in e)
      if (!e[n].equals(t[n], r[n]))
        return !1;
    return !0;
  });
}, tc = function(e) {
  return e._tag === "Some";
}, rc = { _tag: "None" }, nc = function(e) {
  return { _tag: "Some", value: e };
}, Bd = function(e) {
  return e._tag === "Left";
}, Gd = function(e) {
  return e._tag === "Right";
}, Fd = function(e) {
  return { _tag: "Left", left: e };
}, Zd = function(e) {
  return { _tag: "Right", right: e };
}, Wd = function(e) {
  return [e];
}, Jd = [], zd = Object.prototype.hasOwnProperty, Qd = function(e) {
  return function(t) {
    return function(r) {
      return r.reduce(function(n, a) {
        return e.concat(n, a);
      }, t);
    };
  };
}, Yd = function(e) {
  return {
    concat: function(t, r) {
      var n = {};
      for (var a in e)
        zd.call(e, a) && (n[a] = e[a].concat(t[a], r[a]));
      return n;
    }
  };
}, Gr = function() {
  return { concat: Hd };
}, Xd = function() {
  return { concat: function(e, t) {
    return t;
  } };
}, ef = Qd, mi = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, a = t.length, s; n < a; n++)
    (s || !(n in t)) && (s || (s = Array.prototype.slice.call(t, 0, n)), s[n] = t[n]);
  return e.concat(s || Array.prototype.slice.call(t));
}, tf = Jd, rf = function(e, t) {
  return e < 0 || e >= t.length;
}, nf = function(e) {
  return function(t) {
    return mi(mi([], t, !0), [e], !1);
  };
}, af = nf, sf = Wd, Ee = {
  equals: function(e, t) {
    return e === t;
  }
}, of = {
  concat: function(e, t) {
    return e + t;
  }
}, uf = "", bs = {
  concat: of.concat,
  empty: uf
};
Ee.equals;
var ac = function(e) {
  return e.trim();
}, sc = function(e) {
  return e.length === 0;
}, tr = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ic(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Fr, vi;
function cf() {
  if (vi) return Fr;
  vi = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return Fr = e, Fr;
}
var Zr, gi;
function Ss() {
  if (gi) return Zr;
  gi = 1;
  function e(t, r) {
    return t === r || t !== t && r !== r;
  }
  return Zr = e, Zr;
}
var Wr, _i;
function gr() {
  if (_i) return Wr;
  _i = 1;
  var e = Ss();
  function t(r, n) {
    for (var a = r.length; a--; )
      if (e(r[a][0], n))
        return a;
    return -1;
  }
  return Wr = t, Wr;
}
var Jr, bi;
function lf() {
  if (bi) return Jr;
  bi = 1;
  var e = gr(), t = Array.prototype, r = t.splice;
  function n(a) {
    var s = this.__data__, i = e(s, a);
    if (i < 0)
      return !1;
    var o = s.length - 1;
    return i == o ? s.pop() : r.call(s, i, 1), --this.size, !0;
  }
  return Jr = n, Jr;
}
var zr, Si;
function df() {
  if (Si) return zr;
  Si = 1;
  var e = gr();
  function t(r) {
    var n = this.__data__, a = e(n, r);
    return a < 0 ? void 0 : n[a][1];
  }
  return zr = t, zr;
}
var Qr, Ai;
function ff() {
  if (Ai) return Qr;
  Ai = 1;
  var e = gr();
  function t(r) {
    return e(this.__data__, r) > -1;
  }
  return Qr = t, Qr;
}
var Yr, Ti;
function hf() {
  if (Ti) return Yr;
  Ti = 1;
  var e = gr();
  function t(r, n) {
    var a = this.__data__, s = e(a, r);
    return s < 0 ? (++this.size, a.push([r, n])) : a[s][1] = n, this;
  }
  return Yr = t, Yr;
}
var Xr, Ei;
function _r() {
  if (Ei) return Xr;
  Ei = 1;
  var e = cf(), t = lf(), r = df(), n = ff(), a = hf();
  function s(i) {
    var o = -1, c = i == null ? 0 : i.length;
    for (this.clear(); ++o < c; ) {
      var l = i[o];
      this.set(l[0], l[1]);
    }
  }
  return s.prototype.clear = e, s.prototype.delete = t, s.prototype.get = r, s.prototype.has = n, s.prototype.set = a, Xr = s, Xr;
}
var en, Ri;
function pf() {
  if (Ri) return en;
  Ri = 1;
  var e = _r();
  function t() {
    this.__data__ = new e(), this.size = 0;
  }
  return en = t, en;
}
var tn, wi;
function yf() {
  if (wi) return tn;
  wi = 1;
  function e(t) {
    var r = this.__data__, n = r.delete(t);
    return this.size = r.size, n;
  }
  return tn = e, tn;
}
var rn, Ci;
function mf() {
  if (Ci) return rn;
  Ci = 1;
  function e(t) {
    return this.__data__.get(t);
  }
  return rn = e, rn;
}
var nn, Ii;
function vf() {
  if (Ii) return nn;
  Ii = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return nn = e, nn;
}
var an, xi;
function oc() {
  if (xi) return an;
  xi = 1;
  var e = typeof tr == "object" && tr && tr.Object === Object && tr;
  return an = e, an;
}
var sn, Oi;
function ve() {
  if (Oi) return sn;
  Oi = 1;
  var e = oc(), t = typeof self == "object" && self && self.Object === Object && self, r = e || t || Function("return this")();
  return sn = r, sn;
}
var on, ki;
function br() {
  if (ki) return on;
  ki = 1;
  var e = ve(), t = e.Symbol;
  return on = t, on;
}
var un, Pi;
function gf() {
  if (Pi) return un;
  Pi = 1;
  var e = br(), t = Object.prototype, r = t.hasOwnProperty, n = t.toString, a = e ? e.toStringTag : void 0;
  function s(i) {
    var o = r.call(i, a), c = i[a];
    try {
      i[a] = void 0;
      var l = !0;
    } catch {
    }
    var h = n.call(i);
    return l && (o ? i[a] = c : delete i[a]), h;
  }
  return un = s, un;
}
var cn, qi;
function _f() {
  if (qi) return cn;
  qi = 1;
  var e = Object.prototype, t = e.toString;
  function r(n) {
    return t.call(n);
  }
  return cn = r, cn;
}
var ln, Vi;
function Sr() {
  if (Vi) return ln;
  Vi = 1;
  var e = br(), t = gf(), r = _f(), n = "[object Null]", a = "[object Undefined]", s = e ? e.toStringTag : void 0;
  function i(o) {
    return o == null ? o === void 0 ? a : n : s && s in Object(o) ? t(o) : r(o);
  }
  return ln = i, ln;
}
var dn, Mi;
function Lt() {
  if (Mi) return dn;
  Mi = 1;
  function e(t) {
    var r = typeof t;
    return t != null && (r == "object" || r == "function");
  }
  return dn = e, dn;
}
var fn, $i;
function uc() {
  if ($i) return fn;
  $i = 1;
  var e = Sr(), t = Lt(), r = "[object AsyncFunction]", n = "[object Function]", a = "[object GeneratorFunction]", s = "[object Proxy]";
  function i(o) {
    if (!t(o))
      return !1;
    var c = e(o);
    return c == n || c == a || c == r || c == s;
  }
  return fn = i, fn;
}
var hn, Ni;
function bf() {
  if (Ni) return hn;
  Ni = 1;
  var e = ve(), t = e["__core-js_shared__"];
  return hn = t, hn;
}
var pn, Di;
function Sf() {
  if (Di) return pn;
  Di = 1;
  var e = bf(), t = (function() {
    var n = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return n ? "Symbol(src)_1." + n : "";
  })();
  function r(n) {
    return !!t && t in n;
  }
  return pn = r, pn;
}
var yn, ji;
function cc() {
  if (ji) return yn;
  ji = 1;
  var e = Function.prototype, t = e.toString;
  function r(n) {
    if (n != null) {
      try {
        return t.call(n);
      } catch {
      }
      try {
        return n + "";
      } catch {
      }
    }
    return "";
  }
  return yn = r, yn;
}
var mn, Hi;
function Af() {
  if (Hi) return mn;
  Hi = 1;
  var e = uc(), t = Sf(), r = Lt(), n = cc(), a = /[\\^$.*+?()[\]{}|]/g, s = /^\[object .+?Constructor\]$/, i = Function.prototype, o = Object.prototype, c = i.toString, l = o.hasOwnProperty, h = RegExp(
    "^" + c.call(l).replace(a, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function m(E) {
    if (!r(E) || t(E))
      return !1;
    var D = e(E) ? h : s;
    return D.test(n(E));
  }
  return mn = m, mn;
}
var vn, Li;
function Tf() {
  if (Li) return vn;
  Li = 1;
  function e(t, r) {
    return t == null ? void 0 : t[r];
  }
  return vn = e, vn;
}
var gn, Ui;
function et() {
  if (Ui) return gn;
  Ui = 1;
  var e = Af(), t = Tf();
  function r(n, a) {
    var s = t(n, a);
    return e(s) ? s : void 0;
  }
  return gn = r, gn;
}
var _n, Ki;
function As() {
  if (Ki) return _n;
  Ki = 1;
  var e = et(), t = ve(), r = e(t, "Map");
  return _n = r, _n;
}
var bn, Bi;
function Ar() {
  if (Bi) return bn;
  Bi = 1;
  var e = et(), t = e(Object, "create");
  return bn = t, bn;
}
var Sn, Gi;
function Ef() {
  if (Gi) return Sn;
  Gi = 1;
  var e = Ar();
  function t() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return Sn = t, Sn;
}
var An, Fi;
function Rf() {
  if (Fi) return An;
  Fi = 1;
  function e(t) {
    var r = this.has(t) && delete this.__data__[t];
    return this.size -= r ? 1 : 0, r;
  }
  return An = e, An;
}
var Tn, Zi;
function wf() {
  if (Zi) return Tn;
  Zi = 1;
  var e = Ar(), t = "__lodash_hash_undefined__", r = Object.prototype, n = r.hasOwnProperty;
  function a(s) {
    var i = this.__data__;
    if (e) {
      var o = i[s];
      return o === t ? void 0 : o;
    }
    return n.call(i, s) ? i[s] : void 0;
  }
  return Tn = a, Tn;
}
var En, Wi;
function Cf() {
  if (Wi) return En;
  Wi = 1;
  var e = Ar(), t = Object.prototype, r = t.hasOwnProperty;
  function n(a) {
    var s = this.__data__;
    return e ? s[a] !== void 0 : r.call(s, a);
  }
  return En = n, En;
}
var Rn, Ji;
function If() {
  if (Ji) return Rn;
  Ji = 1;
  var e = Ar(), t = "__lodash_hash_undefined__";
  function r(n, a) {
    var s = this.__data__;
    return this.size += this.has(n) ? 0 : 1, s[n] = e && a === void 0 ? t : a, this;
  }
  return Rn = r, Rn;
}
var wn, zi;
function xf() {
  if (zi) return wn;
  zi = 1;
  var e = Ef(), t = Rf(), r = wf(), n = Cf(), a = If();
  function s(i) {
    var o = -1, c = i == null ? 0 : i.length;
    for (this.clear(); ++o < c; ) {
      var l = i[o];
      this.set(l[0], l[1]);
    }
  }
  return s.prototype.clear = e, s.prototype.delete = t, s.prototype.get = r, s.prototype.has = n, s.prototype.set = a, wn = s, wn;
}
var Cn, Qi;
function Of() {
  if (Qi) return Cn;
  Qi = 1;
  var e = xf(), t = _r(), r = As();
  function n() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (r || t)(),
      string: new e()
    };
  }
  return Cn = n, Cn;
}
var In, Yi;
function kf() {
  if (Yi) return In;
  Yi = 1;
  function e(t) {
    var r = typeof t;
    return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? t !== "__proto__" : t === null;
  }
  return In = e, In;
}
var xn, Xi;
function Tr() {
  if (Xi) return xn;
  Xi = 1;
  var e = kf();
  function t(r, n) {
    var a = r.__data__;
    return e(n) ? a[typeof n == "string" ? "string" : "hash"] : a.map;
  }
  return xn = t, xn;
}
var On, eo;
function Pf() {
  if (eo) return On;
  eo = 1;
  var e = Tr();
  function t(r) {
    var n = e(this, r).delete(r);
    return this.size -= n ? 1 : 0, n;
  }
  return On = t, On;
}
var kn, to;
function qf() {
  if (to) return kn;
  to = 1;
  var e = Tr();
  function t(r) {
    return e(this, r).get(r);
  }
  return kn = t, kn;
}
var Pn, ro;
function Vf() {
  if (ro) return Pn;
  ro = 1;
  var e = Tr();
  function t(r) {
    return e(this, r).has(r);
  }
  return Pn = t, Pn;
}
var qn, no;
function Mf() {
  if (no) return qn;
  no = 1;
  var e = Tr();
  function t(r, n) {
    var a = e(this, r), s = a.size;
    return a.set(r, n), this.size += a.size == s ? 0 : 1, this;
  }
  return qn = t, qn;
}
var Vn, ao;
function lc() {
  if (ao) return Vn;
  ao = 1;
  var e = Of(), t = Pf(), r = qf(), n = Vf(), a = Mf();
  function s(i) {
    var o = -1, c = i == null ? 0 : i.length;
    for (this.clear(); ++o < c; ) {
      var l = i[o];
      this.set(l[0], l[1]);
    }
  }
  return s.prototype.clear = e, s.prototype.delete = t, s.prototype.get = r, s.prototype.has = n, s.prototype.set = a, Vn = s, Vn;
}
var Mn, so;
function $f() {
  if (so) return Mn;
  so = 1;
  var e = _r(), t = As(), r = lc(), n = 200;
  function a(s, i) {
    var o = this.__data__;
    if (o instanceof e) {
      var c = o.__data__;
      if (!t || c.length < n - 1)
        return c.push([s, i]), this.size = ++o.size, this;
      o = this.__data__ = new r(c);
    }
    return o.set(s, i), this.size = o.size, this;
  }
  return Mn = a, Mn;
}
var $n, io;
function dc() {
  if (io) return $n;
  io = 1;
  var e = _r(), t = pf(), r = yf(), n = mf(), a = vf(), s = $f();
  function i(o) {
    var c = this.__data__ = new e(o);
    this.size = c.size;
  }
  return i.prototype.clear = t, i.prototype.delete = r, i.prototype.get = n, i.prototype.has = a, i.prototype.set = s, $n = i, $n;
}
var Nn, oo;
function Nf() {
  if (oo) return Nn;
  oo = 1;
  function e(t, r) {
    for (var n = -1, a = t == null ? 0 : t.length; ++n < a && r(t[n], n, t) !== !1; )
      ;
    return t;
  }
  return Nn = e, Nn;
}
var Dn, uo;
function Df() {
  if (uo) return Dn;
  uo = 1;
  var e = et(), t = (function() {
    try {
      var r = e(Object, "defineProperty");
      return r({}, "", {}), r;
    } catch {
    }
  })();
  return Dn = t, Dn;
}
var jn, co;
function fc() {
  if (co) return jn;
  co = 1;
  var e = Df();
  function t(r, n, a) {
    n == "__proto__" && e ? e(r, n, {
      configurable: !0,
      enumerable: !0,
      value: a,
      writable: !0
    }) : r[n] = a;
  }
  return jn = t, jn;
}
var Hn, lo;
function hc() {
  if (lo) return Hn;
  lo = 1;
  var e = fc(), t = Ss(), r = Object.prototype, n = r.hasOwnProperty;
  function a(s, i, o) {
    var c = s[i];
    (!(n.call(s, i) && t(c, o)) || o === void 0 && !(i in s)) && e(s, i, o);
  }
  return Hn = a, Hn;
}
var Ln, fo;
function Er() {
  if (fo) return Ln;
  fo = 1;
  var e = hc(), t = fc();
  function r(n, a, s, i) {
    var o = !s;
    s || (s = {});
    for (var c = -1, l = a.length; ++c < l; ) {
      var h = a[c], m = i ? i(s[h], n[h], h, s, n) : void 0;
      m === void 0 && (m = n[h]), o ? t(s, h, m) : e(s, h, m);
    }
    return s;
  }
  return Ln = r, Ln;
}
var Un, ho;
function jf() {
  if (ho) return Un;
  ho = 1;
  function e(t, r) {
    for (var n = -1, a = Array(t); ++n < t; )
      a[n] = r(n);
    return a;
  }
  return Un = e, Un;
}
var Kn, po;
function Ct() {
  if (po) return Kn;
  po = 1;
  function e(t) {
    return t != null && typeof t == "object";
  }
  return Kn = e, Kn;
}
var Bn, yo;
function Hf() {
  if (yo) return Bn;
  yo = 1;
  var e = Sr(), t = Ct(), r = "[object Arguments]";
  function n(a) {
    return t(a) && e(a) == r;
  }
  return Bn = n, Bn;
}
var Gn, mo;
function Lf() {
  if (mo) return Gn;
  mo = 1;
  var e = Hf(), t = Ct(), r = Object.prototype, n = r.hasOwnProperty, a = r.propertyIsEnumerable, s = e(/* @__PURE__ */ (function() {
    return arguments;
  })()) ? e : function(i) {
    return t(i) && n.call(i, "callee") && !a.call(i, "callee");
  };
  return Gn = s, Gn;
}
var Fn, vo;
function Rr() {
  if (vo) return Fn;
  vo = 1;
  var e = Array.isArray;
  return Fn = e, Fn;
}
var Ot = { exports: {} }, Zn, go;
function Uf() {
  if (go) return Zn;
  go = 1;
  function e() {
    return !1;
  }
  return Zn = e, Zn;
}
Ot.exports;
var _o;
function Ts() {
  return _o || (_o = 1, (function(e, t) {
    var r = ve(), n = Uf(), a = t && !t.nodeType && t, s = a && !0 && e && !e.nodeType && e, i = s && s.exports === a, o = i ? r.Buffer : void 0, c = o ? o.isBuffer : void 0, l = c || n;
    e.exports = l;
  })(Ot, Ot.exports)), Ot.exports;
}
var Wn, bo;
function Kf() {
  if (bo) return Wn;
  bo = 1;
  var e = 9007199254740991, t = /^(?:0|[1-9]\d*)$/;
  function r(n, a) {
    var s = typeof n;
    return a = a ?? e, !!a && (s == "number" || s != "symbol" && t.test(n)) && n > -1 && n % 1 == 0 && n < a;
  }
  return Wn = r, Wn;
}
var Jn, So;
function pc() {
  if (So) return Jn;
  So = 1;
  var e = 9007199254740991;
  function t(r) {
    return typeof r == "number" && r > -1 && r % 1 == 0 && r <= e;
  }
  return Jn = t, Jn;
}
var zn, Ao;
function Bf() {
  if (Ao) return zn;
  Ao = 1;
  var e = Sr(), t = pc(), r = Ct(), n = "[object Arguments]", a = "[object Array]", s = "[object Boolean]", i = "[object Date]", o = "[object Error]", c = "[object Function]", l = "[object Map]", h = "[object Number]", m = "[object Object]", E = "[object RegExp]", D = "[object Set]", Z = "[object String]", j = "[object WeakMap]", $ = "[object ArrayBuffer]", M = "[object DataView]", I = "[object Float32Array]", B = "[object Float64Array]", P = "[object Int8Array]", G = "[object Int16Array]", q = "[object Int32Array]", O = "[object Uint8Array]", J = "[object Uint8ClampedArray]", H = "[object Uint16Array]", ae = "[object Uint32Array]", x = {};
  x[I] = x[B] = x[P] = x[G] = x[q] = x[O] = x[J] = x[H] = x[ae] = !0, x[n] = x[a] = x[$] = x[s] = x[M] = x[i] = x[o] = x[c] = x[l] = x[h] = x[m] = x[E] = x[D] = x[Z] = x[j] = !1;
  function te(ie) {
    return r(ie) && t(ie.length) && !!x[e(ie)];
  }
  return zn = te, zn;
}
var Qn, To;
function Es() {
  if (To) return Qn;
  To = 1;
  function e(t) {
    return function(r) {
      return t(r);
    };
  }
  return Qn = e, Qn;
}
var kt = { exports: {} };
kt.exports;
var Eo;
function Rs() {
  return Eo || (Eo = 1, (function(e, t) {
    var r = oc(), n = t && !t.nodeType && t, a = n && !0 && e && !e.nodeType && e, s = a && a.exports === n, i = s && r.process, o = (function() {
      try {
        var c = a && a.require && a.require("util").types;
        return c || i && i.binding && i.binding("util");
      } catch {
      }
    })();
    e.exports = o;
  })(kt, kt.exports)), kt.exports;
}
var Yn, Ro;
function yc() {
  if (Ro) return Yn;
  Ro = 1;
  var e = Bf(), t = Es(), r = Rs(), n = r && r.isTypedArray, a = n ? t(n) : e;
  return Yn = a, Yn;
}
var Xn, wo;
function mc() {
  if (wo) return Xn;
  wo = 1;
  var e = jf(), t = Lf(), r = Rr(), n = Ts(), a = Kf(), s = yc(), i = Object.prototype, o = i.hasOwnProperty;
  function c(l, h) {
    var m = r(l), E = !m && t(l), D = !m && !E && n(l), Z = !m && !E && !D && s(l), j = m || E || D || Z, $ = j ? e(l.length, String) : [], M = $.length;
    for (var I in l)
      (h || o.call(l, I)) && !(j && // Safari 9 has enumerable `arguments.length` in strict mode.
      (I == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      D && (I == "offset" || I == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      Z && (I == "buffer" || I == "byteLength" || I == "byteOffset") || // Skip index properties.
      a(I, M))) && $.push(I);
    return $;
  }
  return Xn = c, Xn;
}
var ea, Co;
function ws() {
  if (Co) return ea;
  Co = 1;
  var e = Object.prototype;
  function t(r) {
    var n = r && r.constructor, a = typeof n == "function" && n.prototype || e;
    return r === a;
  }
  return ea = t, ea;
}
var ta, Io;
function vc() {
  if (Io) return ta;
  Io = 1;
  function e(t, r) {
    return function(n) {
      return t(r(n));
    };
  }
  return ta = e, ta;
}
var ra, xo;
function Gf() {
  if (xo) return ra;
  xo = 1;
  var e = vc(), t = e(Object.keys, Object);
  return ra = t, ra;
}
var na, Oo;
function Ff() {
  if (Oo) return na;
  Oo = 1;
  var e = ws(), t = Gf(), r = Object.prototype, n = r.hasOwnProperty;
  function a(s) {
    if (!e(s))
      return t(s);
    var i = [];
    for (var o in Object(s))
      n.call(s, o) && o != "constructor" && i.push(o);
    return i;
  }
  return na = a, na;
}
var aa, ko;
function gc() {
  if (ko) return aa;
  ko = 1;
  var e = uc(), t = pc();
  function r(n) {
    return n != null && t(n.length) && !e(n);
  }
  return aa = r, aa;
}
var sa, Po;
function Cs() {
  if (Po) return sa;
  Po = 1;
  var e = mc(), t = Ff(), r = gc();
  function n(a) {
    return r(a) ? e(a) : t(a);
  }
  return sa = n, sa;
}
var ia, qo;
function Zf() {
  if (qo) return ia;
  qo = 1;
  var e = Er(), t = Cs();
  function r(n, a) {
    return n && e(a, t(a), n);
  }
  return ia = r, ia;
}
var oa, Vo;
function Wf() {
  if (Vo) return oa;
  Vo = 1;
  function e(t) {
    var r = [];
    if (t != null)
      for (var n in Object(t))
        r.push(n);
    return r;
  }
  return oa = e, oa;
}
var ua, Mo;
function Jf() {
  if (Mo) return ua;
  Mo = 1;
  var e = Lt(), t = ws(), r = Wf(), n = Object.prototype, a = n.hasOwnProperty;
  function s(i) {
    if (!e(i))
      return r(i);
    var o = t(i), c = [];
    for (var l in i)
      l == "constructor" && (o || !a.call(i, l)) || c.push(l);
    return c;
  }
  return ua = s, ua;
}
var ca, $o;
function Is() {
  if ($o) return ca;
  $o = 1;
  var e = mc(), t = Jf(), r = gc();
  function n(a) {
    return r(a) ? e(a, !0) : t(a);
  }
  return ca = n, ca;
}
var la, No;
function zf() {
  if (No) return la;
  No = 1;
  var e = Er(), t = Is();
  function r(n, a) {
    return n && e(a, t(a), n);
  }
  return la = r, la;
}
var Pt = { exports: {} };
Pt.exports;
var Do;
function Qf() {
  return Do || (Do = 1, (function(e, t) {
    var r = ve(), n = t && !t.nodeType && t, a = n && !0 && e && !e.nodeType && e, s = a && a.exports === n, i = s ? r.Buffer : void 0, o = i ? i.allocUnsafe : void 0;
    function c(l, h) {
      if (h)
        return l.slice();
      var m = l.length, E = o ? o(m) : new l.constructor(m);
      return l.copy(E), E;
    }
    e.exports = c;
  })(Pt, Pt.exports)), Pt.exports;
}
var da, jo;
function Yf() {
  if (jo) return da;
  jo = 1;
  function e(t, r) {
    var n = -1, a = t.length;
    for (r || (r = Array(a)); ++n < a; )
      r[n] = t[n];
    return r;
  }
  return da = e, da;
}
var fa, Ho;
function Xf() {
  if (Ho) return fa;
  Ho = 1;
  function e(t, r) {
    for (var n = -1, a = t == null ? 0 : t.length, s = 0, i = []; ++n < a; ) {
      var o = t[n];
      r(o, n, t) && (i[s++] = o);
    }
    return i;
  }
  return fa = e, fa;
}
var ha, Lo;
function _c() {
  if (Lo) return ha;
  Lo = 1;
  function e() {
    return [];
  }
  return ha = e, ha;
}
var pa, Uo;
function xs() {
  if (Uo) return pa;
  Uo = 1;
  var e = Xf(), t = _c(), r = Object.prototype, n = r.propertyIsEnumerable, a = Object.getOwnPropertySymbols, s = a ? function(i) {
    return i == null ? [] : (i = Object(i), e(a(i), function(o) {
      return n.call(i, o);
    }));
  } : t;
  return pa = s, pa;
}
var ya, Ko;
function eh() {
  if (Ko) return ya;
  Ko = 1;
  var e = Er(), t = xs();
  function r(n, a) {
    return e(n, t(n), a);
  }
  return ya = r, ya;
}
var ma, Bo;
function bc() {
  if (Bo) return ma;
  Bo = 1;
  function e(t, r) {
    for (var n = -1, a = r.length, s = t.length; ++n < a; )
      t[s + n] = r[n];
    return t;
  }
  return ma = e, ma;
}
var va, Go;
function Sc() {
  if (Go) return va;
  Go = 1;
  var e = vc(), t = e(Object.getPrototypeOf, Object);
  return va = t, va;
}
var ga, Fo;
function Ac() {
  if (Fo) return ga;
  Fo = 1;
  var e = bc(), t = Sc(), r = xs(), n = _c(), a = Object.getOwnPropertySymbols, s = a ? function(i) {
    for (var o = []; i; )
      e(o, r(i)), i = t(i);
    return o;
  } : n;
  return ga = s, ga;
}
var _a, Zo;
function th() {
  if (Zo) return _a;
  Zo = 1;
  var e = Er(), t = Ac();
  function r(n, a) {
    return e(n, t(n), a);
  }
  return _a = r, _a;
}
var ba, Wo;
function Tc() {
  if (Wo) return ba;
  Wo = 1;
  var e = bc(), t = Rr();
  function r(n, a, s) {
    var i = a(n);
    return t(n) ? i : e(i, s(n));
  }
  return ba = r, ba;
}
var Sa, Jo;
function Ec() {
  if (Jo) return Sa;
  Jo = 1;
  var e = Tc(), t = xs(), r = Cs();
  function n(a) {
    return e(a, r, t);
  }
  return Sa = n, Sa;
}
var Aa, zo;
function rh() {
  if (zo) return Aa;
  zo = 1;
  var e = Tc(), t = Ac(), r = Is();
  function n(a) {
    return e(a, r, t);
  }
  return Aa = n, Aa;
}
var Ta, Qo;
function nh() {
  if (Qo) return Ta;
  Qo = 1;
  var e = et(), t = ve(), r = e(t, "DataView");
  return Ta = r, Ta;
}
var Ea, Yo;
function ah() {
  if (Yo) return Ea;
  Yo = 1;
  var e = et(), t = ve(), r = e(t, "Promise");
  return Ea = r, Ea;
}
var Ra, Xo;
function sh() {
  if (Xo) return Ra;
  Xo = 1;
  var e = et(), t = ve(), r = e(t, "Set");
  return Ra = r, Ra;
}
var wa, eu;
function ih() {
  if (eu) return wa;
  eu = 1;
  var e = et(), t = ve(), r = e(t, "WeakMap");
  return wa = r, wa;
}
var Ca, tu;
function wr() {
  if (tu) return Ca;
  tu = 1;
  var e = nh(), t = As(), r = ah(), n = sh(), a = ih(), s = Sr(), i = cc(), o = "[object Map]", c = "[object Object]", l = "[object Promise]", h = "[object Set]", m = "[object WeakMap]", E = "[object DataView]", D = i(e), Z = i(t), j = i(r), $ = i(n), M = i(a), I = s;
  return (e && I(new e(new ArrayBuffer(1))) != E || t && I(new t()) != o || r && I(r.resolve()) != l || n && I(new n()) != h || a && I(new a()) != m) && (I = function(B) {
    var P = s(B), G = P == c ? B.constructor : void 0, q = G ? i(G) : "";
    if (q)
      switch (q) {
        case D:
          return E;
        case Z:
          return o;
        case j:
          return l;
        case $:
          return h;
        case M:
          return m;
      }
    return P;
  }), Ca = I, Ca;
}
var Ia, ru;
function oh() {
  if (ru) return Ia;
  ru = 1;
  var e = Object.prototype, t = e.hasOwnProperty;
  function r(n) {
    var a = n.length, s = new n.constructor(a);
    return a && typeof n[0] == "string" && t.call(n, "index") && (s.index = n.index, s.input = n.input), s;
  }
  return Ia = r, Ia;
}
var xa, nu;
function Rc() {
  if (nu) return xa;
  nu = 1;
  var e = ve(), t = e.Uint8Array;
  return xa = t, xa;
}
var Oa, au;
function Os() {
  if (au) return Oa;
  au = 1;
  var e = Rc();
  function t(r) {
    var n = new r.constructor(r.byteLength);
    return new e(n).set(new e(r)), n;
  }
  return Oa = t, Oa;
}
var ka, su;
function uh() {
  if (su) return ka;
  su = 1;
  var e = Os();
  function t(r, n) {
    var a = n ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.byteLength);
  }
  return ka = t, ka;
}
var Pa, iu;
function ch() {
  if (iu) return Pa;
  iu = 1;
  var e = /\w*$/;
  function t(r) {
    var n = new r.constructor(r.source, e.exec(r));
    return n.lastIndex = r.lastIndex, n;
  }
  return Pa = t, Pa;
}
var qa, ou;
function lh() {
  if (ou) return qa;
  ou = 1;
  var e = br(), t = e ? e.prototype : void 0, r = t ? t.valueOf : void 0;
  function n(a) {
    return r ? Object(r.call(a)) : {};
  }
  return qa = n, qa;
}
var Va, uu;
function dh() {
  if (uu) return Va;
  uu = 1;
  var e = Os();
  function t(r, n) {
    var a = n ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.length);
  }
  return Va = t, Va;
}
var Ma, cu;
function fh() {
  if (cu) return Ma;
  cu = 1;
  var e = Os(), t = uh(), r = ch(), n = lh(), a = dh(), s = "[object Boolean]", i = "[object Date]", o = "[object Map]", c = "[object Number]", l = "[object RegExp]", h = "[object Set]", m = "[object String]", E = "[object Symbol]", D = "[object ArrayBuffer]", Z = "[object DataView]", j = "[object Float32Array]", $ = "[object Float64Array]", M = "[object Int8Array]", I = "[object Int16Array]", B = "[object Int32Array]", P = "[object Uint8Array]", G = "[object Uint8ClampedArray]", q = "[object Uint16Array]", O = "[object Uint32Array]";
  function J(H, ae, x) {
    var te = H.constructor;
    switch (ae) {
      case D:
        return e(H);
      case s:
      case i:
        return new te(+H);
      case Z:
        return t(H, x);
      case j:
      case $:
      case M:
      case I:
      case B:
      case P:
      case G:
      case q:
      case O:
        return a(H, x);
      case o:
        return new te();
      case c:
      case m:
        return new te(H);
      case l:
        return r(H);
      case h:
        return new te();
      case E:
        return n(H);
    }
  }
  return Ma = J, Ma;
}
var $a, lu;
function hh() {
  if (lu) return $a;
  lu = 1;
  var e = Lt(), t = Object.create, r = /* @__PURE__ */ (function() {
    function n() {
    }
    return function(a) {
      if (!e(a))
        return {};
      if (t)
        return t(a);
      n.prototype = a;
      var s = new n();
      return n.prototype = void 0, s;
    };
  })();
  return $a = r, $a;
}
var Na, du;
function ph() {
  if (du) return Na;
  du = 1;
  var e = hh(), t = Sc(), r = ws();
  function n(a) {
    return typeof a.constructor == "function" && !r(a) ? e(t(a)) : {};
  }
  return Na = n, Na;
}
var Da, fu;
function yh() {
  if (fu) return Da;
  fu = 1;
  var e = wr(), t = Ct(), r = "[object Map]";
  function n(a) {
    return t(a) && e(a) == r;
  }
  return Da = n, Da;
}
var ja, hu;
function mh() {
  if (hu) return ja;
  hu = 1;
  var e = yh(), t = Es(), r = Rs(), n = r && r.isMap, a = n ? t(n) : e;
  return ja = a, ja;
}
var Ha, pu;
function vh() {
  if (pu) return Ha;
  pu = 1;
  var e = wr(), t = Ct(), r = "[object Set]";
  function n(a) {
    return t(a) && e(a) == r;
  }
  return Ha = n, Ha;
}
var La, yu;
function gh() {
  if (yu) return La;
  yu = 1;
  var e = vh(), t = Es(), r = Rs(), n = r && r.isSet, a = n ? t(n) : e;
  return La = a, La;
}
var Ua, mu;
function _h() {
  if (mu) return Ua;
  mu = 1;
  var e = dc(), t = Nf(), r = hc(), n = Zf(), a = zf(), s = Qf(), i = Yf(), o = eh(), c = th(), l = Ec(), h = rh(), m = wr(), E = oh(), D = fh(), Z = ph(), j = Rr(), $ = Ts(), M = mh(), I = Lt(), B = gh(), P = Cs(), G = Is(), q = 1, O = 2, J = 4, H = "[object Arguments]", ae = "[object Array]", x = "[object Boolean]", te = "[object Date]", ie = "[object Error]", it = "[object Function]", ot = "[object GeneratorFunction]", Br = "[object Map]", vd = "[object Number]", ci = "[object Object]", gd = "[object RegExp]", _d = "[object Set]", bd = "[object String]", Sd = "[object Symbol]", Ad = "[object WeakMap]", Td = "[object ArrayBuffer]", Ed = "[object DataView]", Rd = "[object Float32Array]", wd = "[object Float64Array]", Cd = "[object Int8Array]", Id = "[object Int16Array]", xd = "[object Int32Array]", Od = "[object Uint8Array]", kd = "[object Uint8ClampedArray]", Pd = "[object Uint16Array]", qd = "[object Uint32Array]", L = {};
  L[H] = L[ae] = L[Td] = L[Ed] = L[x] = L[te] = L[Rd] = L[wd] = L[Cd] = L[Id] = L[xd] = L[Br] = L[vd] = L[ci] = L[gd] = L[_d] = L[bd] = L[Sd] = L[Od] = L[kd] = L[Pd] = L[qd] = !0, L[ie] = L[it] = L[Ad] = !1;
  function Qt(N, ut, ct, Vd, Yt, xe) {
    var se, Xt = ut & q, er = ut & O, Md = ut & J;
    if (ct && (se = Yt ? ct(N, Vd, Yt, xe) : ct(N)), se !== void 0)
      return se;
    if (!I(N))
      return N;
    var li = j(N);
    if (li) {
      if (se = E(N), !Xt)
        return i(N, se);
    } else {
      var lt = m(N), di = lt == it || lt == ot;
      if ($(N))
        return s(N, Xt);
      if (lt == ci || lt == H || di && !Yt) {
        if (se = er || di ? {} : Z(N), !Xt)
          return er ? c(N, a(se, N)) : o(N, n(se, N));
      } else {
        if (!L[lt])
          return Yt ? N : {};
        se = D(N, lt, Xt);
      }
    }
    xe || (xe = new e());
    var fi = xe.get(N);
    if (fi)
      return fi;
    xe.set(N, se), B(N) ? N.forEach(function(Oe) {
      se.add(Qt(Oe, ut, ct, Oe, N, xe));
    }) : M(N) && N.forEach(function(Oe, Ze) {
      se.set(Ze, Qt(Oe, ut, ct, Ze, N, xe));
    });
    var $d = Md ? er ? h : l : er ? G : P, hi = li ? void 0 : $d(N);
    return t(hi || N, function(Oe, Ze) {
      hi && (Ze = Oe, Oe = N[Ze]), r(se, Ze, Qt(Oe, ut, ct, Ze, N, xe));
    }), se;
  }
  return Ua = Qt, Ua;
}
var Ka, vu;
function bh() {
  if (vu) return Ka;
  vu = 1;
  var e = _h(), t = 1, r = 4;
  function n(a) {
    return e(a, t | r);
  }
  return Ka = n, Ka;
}
var Sh = bh();
const Ah = /* @__PURE__ */ ic(Sh);
var V;
(function(e) {
  e.assertEqual = (a) => {
  };
  function t(a) {
  }
  e.assertIs = t;
  function r(a) {
    throw new Error();
  }
  e.assertNever = r, e.arrayToEnum = (a) => {
    const s = {};
    for (const i of a)
      s[i] = i;
    return s;
  }, e.getValidEnumValues = (a) => {
    const s = e.objectKeys(a).filter((o) => typeof a[a[o]] != "number"), i = {};
    for (const o of s)
      i[o] = a[o];
    return e.objectValues(i);
  }, e.objectValues = (a) => e.objectKeys(a).map(function(s) {
    return a[s];
  }), e.objectKeys = typeof Object.keys == "function" ? (a) => Object.keys(a) : (a) => {
    const s = [];
    for (const i in a)
      Object.prototype.hasOwnProperty.call(a, i) && s.push(i);
    return s;
  }, e.find = (a, s) => {
    for (const i of a)
      if (s(i))
        return i;
  }, e.isInteger = typeof Number.isInteger == "function" ? (a) => Number.isInteger(a) : (a) => typeof a == "number" && Number.isFinite(a) && Math.floor(a) === a;
  function n(a, s = " | ") {
    return a.map((i) => typeof i == "string" ? `'${i}'` : i).join(s);
  }
  e.joinValues = n, e.jsonStringifyReplacer = (a, s) => typeof s == "bigint" ? s.toString() : s;
})(V || (V = {}));
var gu;
(function(e) {
  e.mergeShapes = (t, r) => ({
    ...t,
    ...r
    // second overwrites first
  });
})(gu || (gu = {}));
const v = V.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), qe = (e) => {
  switch (typeof e) {
    case "undefined":
      return v.undefined;
    case "string":
      return v.string;
    case "number":
      return Number.isNaN(e) ? v.nan : v.number;
    case "boolean":
      return v.boolean;
    case "function":
      return v.function;
    case "bigint":
      return v.bigint;
    case "symbol":
      return v.symbol;
    case "object":
      return Array.isArray(e) ? v.array : e === null ? v.null : e.then && typeof e.then == "function" && e.catch && typeof e.catch == "function" ? v.promise : typeof Map < "u" && e instanceof Map ? v.map : typeof Set < "u" && e instanceof Set ? v.set : typeof Date < "u" && e instanceof Date ? v.date : v.object;
    default:
      return v.unknown;
  }
}, p = V.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]);
class Ie extends Error {
  get errors() {
    return this.issues;
  }
  constructor(t) {
    super(), this.issues = [], this.addIssue = (n) => {
      this.issues = [...this.issues, n];
    }, this.addIssues = (n = []) => {
      this.issues = [...this.issues, ...n];
    };
    const r = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, r) : this.__proto__ = r, this.name = "ZodError", this.issues = t;
  }
  format(t) {
    const r = t || function(s) {
      return s.message;
    }, n = { _errors: [] }, a = (s) => {
      for (const i of s.issues)
        if (i.code === "invalid_union")
          i.unionErrors.map(a);
        else if (i.code === "invalid_return_type")
          a(i.returnTypeError);
        else if (i.code === "invalid_arguments")
          a(i.argumentsError);
        else if (i.path.length === 0)
          n._errors.push(r(i));
        else {
          let o = n, c = 0;
          for (; c < i.path.length; ) {
            const l = i.path[c];
            c === i.path.length - 1 ? (o[l] = o[l] || { _errors: [] }, o[l]._errors.push(r(i))) : o[l] = o[l] || { _errors: [] }, o = o[l], c++;
          }
        }
    };
    return a(this), n;
  }
  static assert(t) {
    if (!(t instanceof Ie))
      throw new Error(`Not a ZodError: ${t}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, V.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(t = (r) => r.message) {
    const r = {}, n = [];
    for (const a of this.issues)
      a.path.length > 0 ? (r[a.path[0]] = r[a.path[0]] || [], r[a.path[0]].push(t(a))) : n.push(t(a));
    return { formErrors: n, fieldErrors: r };
  }
  get formErrors() {
    return this.flatten();
  }
}
Ie.create = (e) => new Ie(e);
const cs = (e, t) => {
  let r;
  switch (e.code) {
    case p.invalid_type:
      e.received === v.undefined ? r = "Required" : r = `Expected ${e.expected}, received ${e.received}`;
      break;
    case p.invalid_literal:
      r = `Invalid literal value, expected ${JSON.stringify(e.expected, V.jsonStringifyReplacer)}`;
      break;
    case p.unrecognized_keys:
      r = `Unrecognized key(s) in object: ${V.joinValues(e.keys, ", ")}`;
      break;
    case p.invalid_union:
      r = "Invalid input";
      break;
    case p.invalid_union_discriminator:
      r = `Invalid discriminator value. Expected ${V.joinValues(e.options)}`;
      break;
    case p.invalid_enum_value:
      r = `Invalid enum value. Expected ${V.joinValues(e.options)}, received '${e.received}'`;
      break;
    case p.invalid_arguments:
      r = "Invalid function arguments";
      break;
    case p.invalid_return_type:
      r = "Invalid function return type";
      break;
    case p.invalid_date:
      r = "Invalid date";
      break;
    case p.invalid_string:
      typeof e.validation == "object" ? "includes" in e.validation ? (r = `Invalid input: must include "${e.validation.includes}"`, typeof e.validation.position == "number" && (r = `${r} at one or more positions greater than or equal to ${e.validation.position}`)) : "startsWith" in e.validation ? r = `Invalid input: must start with "${e.validation.startsWith}"` : "endsWith" in e.validation ? r = `Invalid input: must end with "${e.validation.endsWith}"` : V.assertNever(e.validation) : e.validation !== "regex" ? r = `Invalid ${e.validation}` : r = "Invalid";
      break;
    case p.too_small:
      e.type === "array" ? r = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "more than"} ${e.minimum} element(s)` : e.type === "string" ? r = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "over"} ${e.minimum} character(s)` : e.type === "number" ? r = `Number must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${e.minimum}` : e.type === "date" ? r = `Date must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(e.minimum))}` : r = "Invalid input";
      break;
    case p.too_big:
      e.type === "array" ? r = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "less than"} ${e.maximum} element(s)` : e.type === "string" ? r = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "under"} ${e.maximum} character(s)` : e.type === "number" ? r = `Number must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "bigint" ? r = `BigInt must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "date" ? r = `Date must be ${e.exact ? "exactly" : e.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(e.maximum))}` : r = "Invalid input";
      break;
    case p.custom:
      r = "Invalid input";
      break;
    case p.invalid_intersection_types:
      r = "Intersection results could not be merged";
      break;
    case p.not_multiple_of:
      r = `Number must be a multiple of ${e.multipleOf}`;
      break;
    case p.not_finite:
      r = "Number must be finite";
      break;
    default:
      r = t.defaultError, V.assertNever(e);
  }
  return { message: r };
};
let Th = cs;
function Eh() {
  return Th;
}
const Rh = (e) => {
  const { data: t, path: r, errorMaps: n, issueData: a } = e, s = [...r, ...a.path || []], i = {
    ...a,
    path: s
  };
  if (a.message !== void 0)
    return {
      ...a,
      path: s,
      message: a.message
    };
  let o = "";
  const c = n.filter((l) => !!l).slice().reverse();
  for (const l of c)
    o = l(i, { data: t, defaultError: o }).message;
  return {
    ...a,
    path: s,
    message: o
  };
};
function y(e, t) {
  const r = Eh(), n = Rh({
    issueData: t,
    data: e.data,
    path: e.path,
    errorMaps: [
      e.common.contextualErrorMap,
      // contextual error map is first priority
      e.schemaErrorMap,
      // then schema-bound map if available
      r,
      // then global override map
      r === cs ? void 0 : cs
      // then global default map
    ].filter((a) => !!a)
  });
  e.common.issues.push(n);
}
class ne {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(t, r) {
    const n = [];
    for (const a of r) {
      if (a.status === "aborted")
        return R;
      a.status === "dirty" && t.dirty(), n.push(a.value);
    }
    return { status: t.value, value: n };
  }
  static async mergeObjectAsync(t, r) {
    const n = [];
    for (const a of r) {
      const s = await a.key, i = await a.value;
      n.push({
        key: s,
        value: i
      });
    }
    return ne.mergeObjectSync(t, n);
  }
  static mergeObjectSync(t, r) {
    const n = {};
    for (const a of r) {
      const { key: s, value: i } = a;
      if (s.status === "aborted" || i.status === "aborted")
        return R;
      s.status === "dirty" && t.dirty(), i.status === "dirty" && t.dirty(), s.value !== "__proto__" && (typeof i.value < "u" || a.alwaysSet) && (n[s.value] = i.value);
    }
    return { status: t.value, value: n };
  }
}
const R = Object.freeze({
  status: "aborted"
}), qt = (e) => ({ status: "dirty", value: e }), le = (e) => ({ status: "valid", value: e }), _u = (e) => e.status === "aborted", bu = (e) => e.status === "dirty", bt = (e) => e.status === "valid", rr = (e) => typeof Promise < "u" && e instanceof Promise;
var g;
(function(e) {
  e.errToObj = (t) => typeof t == "string" ? { message: t } : t || {}, e.toString = (t) => typeof t == "string" ? t : t == null ? void 0 : t.message;
})(g || (g = {}));
var nr = function(e, t, r, n) {
  if (r === "a" && !n) throw new TypeError("Private accessor was defined without a getter");
  if (typeof t == "function" ? e !== t || !n : !t.has(e)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return r === "m" ? n : r === "a" ? n.call(e) : n ? n.value : t.get(e);
}, wc = function(e, t, r, n, a) {
  if (n === "m") throw new TypeError("Private method is not writable");
  if (n === "a" && !a) throw new TypeError("Private accessor was defined without a setter");
  if (typeof t == "function" ? e !== t || !a : !t.has(e)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return n === "a" ? a.call(e, r) : a ? a.value = r : t.set(e, r), r;
}, Vt, Mt;
class ye {
  constructor(t, r, n, a) {
    this._cachedPath = [], this.parent = t, this.data = r, this._path = n, this._key = a;
  }
  get path() {
    return this._cachedPath.length || (Array.isArray(this._key) ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const Su = (e, t) => {
  if (bt(t))
    return { success: !0, data: t.value };
  if (!e.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const r = new Ie(e.common.issues);
      return this._error = r, this._error;
    }
  };
};
function C(e) {
  if (!e)
    return {};
  const { errorMap: t, invalid_type_error: r, required_error: n, description: a } = e;
  if (t && (r || n))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return t ? { errorMap: t, description: a } : { errorMap: (i, o) => {
    const { message: c } = e;
    return i.code === "invalid_enum_value" ? { message: c ?? o.defaultError } : typeof o.data > "u" ? { message: c ?? n ?? o.defaultError } : i.code !== "invalid_type" ? { message: o.defaultError } : { message: c ?? r ?? o.defaultError };
  }, description: a };
}
class k {
  get description() {
    return this._def.description;
  }
  _getType(t) {
    return qe(t.data);
  }
  _getOrReturnCtx(t, r) {
    return r || {
      common: t.parent.common,
      data: t.data,
      parsedType: qe(t.data),
      schemaErrorMap: this._def.errorMap,
      path: t.path,
      parent: t.parent
    };
  }
  _processInputParams(t) {
    return {
      status: new ne(),
      ctx: {
        common: t.parent.common,
        data: t.data,
        parsedType: qe(t.data),
        schemaErrorMap: this._def.errorMap,
        path: t.path,
        parent: t.parent
      }
    };
  }
  _parseSync(t) {
    const r = this._parse(t);
    if (rr(r))
      throw new Error("Synchronous parse encountered promise.");
    return r;
  }
  _parseAsync(t) {
    const r = this._parse(t);
    return Promise.resolve(r);
  }
  parse(t, r) {
    const n = this.safeParse(t, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  safeParse(t, r) {
    const n = {
      common: {
        issues: [],
        async: (r == null ? void 0 : r.async) ?? !1,
        contextualErrorMap: r == null ? void 0 : r.errorMap
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: qe(t)
    }, a = this._parseSync({ data: t, path: n.path, parent: n });
    return Su(n, a);
  }
  "~validate"(t) {
    var n, a;
    const r = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: qe(t)
    };
    if (!this["~standard"].async)
      try {
        const s = this._parseSync({ data: t, path: [], parent: r });
        return bt(s) ? {
          value: s.value
        } : {
          issues: r.common.issues
        };
      } catch (s) {
        (a = (n = s == null ? void 0 : s.message) == null ? void 0 : n.toLowerCase()) != null && a.includes("encountered") && (this["~standard"].async = !0), r.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: t, path: [], parent: r }).then((s) => bt(s) ? {
      value: s.value
    } : {
      issues: r.common.issues
    });
  }
  async parseAsync(t, r) {
    const n = await this.safeParseAsync(t, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  async safeParseAsync(t, r) {
    const n = {
      common: {
        issues: [],
        contextualErrorMap: r == null ? void 0 : r.errorMap,
        async: !0
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: qe(t)
    }, a = this._parse({ data: t, path: n.path, parent: n }), s = await (rr(a) ? a : Promise.resolve(a));
    return Su(n, s);
  }
  refine(t, r) {
    const n = (a) => typeof r == "string" || typeof r > "u" ? { message: r } : typeof r == "function" ? r(a) : r;
    return this._refinement((a, s) => {
      const i = t(a), o = () => s.addIssue({
        code: p.custom,
        ...n(a)
      });
      return typeof Promise < "u" && i instanceof Promise ? i.then((c) => c ? !0 : (o(), !1)) : i ? !0 : (o(), !1);
    });
  }
  refinement(t, r) {
    return this._refinement((n, a) => t(n) ? !0 : (a.addIssue(typeof r == "function" ? r(n, a) : r), !1));
  }
  _refinement(t) {
    return new Ye({
      schema: this,
      typeName: T.ZodEffects,
      effect: { type: "refinement", refinement: t }
    });
  }
  superRefine(t) {
    return this._refinement(t);
  }
  constructor(t) {
    this.spa = this.safeParseAsync, this._def = t, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (r) => this["~validate"](r)
    };
  }
  optional() {
    return Ce.create(this, this._def);
  }
  nullable() {
    return Xe.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return pe.create(this);
  }
  promise() {
    return lr.create(this, this._def);
  }
  or(t) {
    return sr.create([this, t], this._def);
  }
  and(t) {
    return ir.create(this, t, this._def);
  }
  transform(t) {
    return new Ye({
      ...C(this._def),
      schema: this,
      typeName: T.ZodEffects,
      effect: { type: "transform", transform: t }
    });
  }
  default(t) {
    const r = typeof t == "function" ? t : () => t;
    return new dr({
      ...C(this._def),
      innerType: this,
      defaultValue: r,
      typeName: T.ZodDefault
    });
  }
  brand() {
    return new Oc({
      typeName: T.ZodBranded,
      type: this,
      ...C(this._def)
    });
  }
  catch(t) {
    const r = typeof t == "function" ? t : () => t;
    return new fr({
      ...C(this._def),
      innerType: this,
      catchValue: r,
      typeName: T.ZodCatch
    });
  }
  describe(t) {
    const r = this.constructor;
    return new r({
      ...this._def,
      description: t
    });
  }
  pipe(t) {
    return Ps.create(this, t);
  }
  readonly() {
    return hr.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const wh = /^c[^\s-]{8,}$/i, Ch = /^[0-9a-z]+$/, Ih = /^[0-9A-HJKMNP-TV-Z]{26}$/i, xh = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, Oh = /^[a-z0-9_-]{21}$/i, kh = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, Ph = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, qh = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, Vh = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let Ba;
const Mh = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, $h = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, Nh = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, Dh = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, jh = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, Hh = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, Cc = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", Lh = new RegExp(`^${Cc}$`);
function Ic(e) {
  let t = "[0-5]\\d";
  e.precision ? t = `${t}\\.\\d{${e.precision}}` : e.precision == null && (t = `${t}(\\.\\d+)?`);
  const r = e.precision ? "+" : "?";
  return `([01]\\d|2[0-3]):[0-5]\\d(:${t})${r}`;
}
function Uh(e) {
  return new RegExp(`^${Ic(e)}$`);
}
function Kh(e) {
  let t = `${Cc}T${Ic(e)}`;
  const r = [];
  return r.push(e.local ? "Z?" : "Z"), e.offset && r.push("([+-]\\d{2}:?\\d{2})"), t = `${t}(${r.join("|")})`, new RegExp(`^${t}$`);
}
function Bh(e, t) {
  return !!((t === "v4" || !t) && Mh.test(e) || (t === "v6" || !t) && Nh.test(e));
}
function Gh(e, t) {
  if (!kh.test(e))
    return !1;
  try {
    const [r] = e.split("."), n = r.replace(/-/g, "+").replace(/_/g, "/").padEnd(r.length + (4 - r.length % 4) % 4, "="), a = JSON.parse(atob(n));
    return !(typeof a != "object" || a === null || "typ" in a && (a == null ? void 0 : a.typ) !== "JWT" || !a.alg || t && a.alg !== t);
  } catch {
    return !1;
  }
}
function Fh(e, t) {
  return !!((t === "v4" || !t) && $h.test(e) || (t === "v6" || !t) && Dh.test(e));
}
class we extends k {
  _parse(t) {
    if (this._def.coerce && (t.data = String(t.data)), this._getType(t) !== v.string) {
      const s = this._getOrReturnCtx(t);
      return y(s, {
        code: p.invalid_type,
        expected: v.string,
        received: s.parsedType
      }), R;
    }
    const n = new ne();
    let a;
    for (const s of this._def.checks)
      if (s.kind === "min")
        t.data.length < s.value && (a = this._getOrReturnCtx(t, a), y(a, {
          code: p.too_small,
          minimum: s.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: s.message
        }), n.dirty());
      else if (s.kind === "max")
        t.data.length > s.value && (a = this._getOrReturnCtx(t, a), y(a, {
          code: p.too_big,
          maximum: s.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: s.message
        }), n.dirty());
      else if (s.kind === "length") {
        const i = t.data.length > s.value, o = t.data.length < s.value;
        (i || o) && (a = this._getOrReturnCtx(t, a), i ? y(a, {
          code: p.too_big,
          maximum: s.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: s.message
        }) : o && y(a, {
          code: p.too_small,
          minimum: s.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: s.message
        }), n.dirty());
      } else if (s.kind === "email")
        qh.test(t.data) || (a = this._getOrReturnCtx(t, a), y(a, {
          validation: "email",
          code: p.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "emoji")
        Ba || (Ba = new RegExp(Vh, "u")), Ba.test(t.data) || (a = this._getOrReturnCtx(t, a), y(a, {
          validation: "emoji",
          code: p.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "uuid")
        xh.test(t.data) || (a = this._getOrReturnCtx(t, a), y(a, {
          validation: "uuid",
          code: p.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "nanoid")
        Oh.test(t.data) || (a = this._getOrReturnCtx(t, a), y(a, {
          validation: "nanoid",
          code: p.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "cuid")
        wh.test(t.data) || (a = this._getOrReturnCtx(t, a), y(a, {
          validation: "cuid",
          code: p.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "cuid2")
        Ch.test(t.data) || (a = this._getOrReturnCtx(t, a), y(a, {
          validation: "cuid2",
          code: p.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "ulid")
        Ih.test(t.data) || (a = this._getOrReturnCtx(t, a), y(a, {
          validation: "ulid",
          code: p.invalid_string,
          message: s.message
        }), n.dirty());
      else if (s.kind === "url")
        try {
          new URL(t.data);
        } catch {
          a = this._getOrReturnCtx(t, a), y(a, {
            validation: "url",
            code: p.invalid_string,
            message: s.message
          }), n.dirty();
        }
      else s.kind === "regex" ? (s.regex.lastIndex = 0, s.regex.test(t.data) || (a = this._getOrReturnCtx(t, a), y(a, {
        validation: "regex",
        code: p.invalid_string,
        message: s.message
      }), n.dirty())) : s.kind === "trim" ? t.data = t.data.trim() : s.kind === "includes" ? t.data.includes(s.value, s.position) || (a = this._getOrReturnCtx(t, a), y(a, {
        code: p.invalid_string,
        validation: { includes: s.value, position: s.position },
        message: s.message
      }), n.dirty()) : s.kind === "toLowerCase" ? t.data = t.data.toLowerCase() : s.kind === "toUpperCase" ? t.data = t.data.toUpperCase() : s.kind === "startsWith" ? t.data.startsWith(s.value) || (a = this._getOrReturnCtx(t, a), y(a, {
        code: p.invalid_string,
        validation: { startsWith: s.value },
        message: s.message
      }), n.dirty()) : s.kind === "endsWith" ? t.data.endsWith(s.value) || (a = this._getOrReturnCtx(t, a), y(a, {
        code: p.invalid_string,
        validation: { endsWith: s.value },
        message: s.message
      }), n.dirty()) : s.kind === "datetime" ? Kh(s).test(t.data) || (a = this._getOrReturnCtx(t, a), y(a, {
        code: p.invalid_string,
        validation: "datetime",
        message: s.message
      }), n.dirty()) : s.kind === "date" ? Lh.test(t.data) || (a = this._getOrReturnCtx(t, a), y(a, {
        code: p.invalid_string,
        validation: "date",
        message: s.message
      }), n.dirty()) : s.kind === "time" ? Uh(s).test(t.data) || (a = this._getOrReturnCtx(t, a), y(a, {
        code: p.invalid_string,
        validation: "time",
        message: s.message
      }), n.dirty()) : s.kind === "duration" ? Ph.test(t.data) || (a = this._getOrReturnCtx(t, a), y(a, {
        validation: "duration",
        code: p.invalid_string,
        message: s.message
      }), n.dirty()) : s.kind === "ip" ? Bh(t.data, s.version) || (a = this._getOrReturnCtx(t, a), y(a, {
        validation: "ip",
        code: p.invalid_string,
        message: s.message
      }), n.dirty()) : s.kind === "jwt" ? Gh(t.data, s.alg) || (a = this._getOrReturnCtx(t, a), y(a, {
        validation: "jwt",
        code: p.invalid_string,
        message: s.message
      }), n.dirty()) : s.kind === "cidr" ? Fh(t.data, s.version) || (a = this._getOrReturnCtx(t, a), y(a, {
        validation: "cidr",
        code: p.invalid_string,
        message: s.message
      }), n.dirty()) : s.kind === "base64" ? jh.test(t.data) || (a = this._getOrReturnCtx(t, a), y(a, {
        validation: "base64",
        code: p.invalid_string,
        message: s.message
      }), n.dirty()) : s.kind === "base64url" ? Hh.test(t.data) || (a = this._getOrReturnCtx(t, a), y(a, {
        validation: "base64url",
        code: p.invalid_string,
        message: s.message
      }), n.dirty()) : V.assertNever(s);
    return { status: n.value, value: t.data };
  }
  _regex(t, r, n) {
    return this.refinement((a) => t.test(a), {
      validation: r,
      code: p.invalid_string,
      ...g.errToObj(n)
    });
  }
  _addCheck(t) {
    return new we({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  email(t) {
    return this._addCheck({ kind: "email", ...g.errToObj(t) });
  }
  url(t) {
    return this._addCheck({ kind: "url", ...g.errToObj(t) });
  }
  emoji(t) {
    return this._addCheck({ kind: "emoji", ...g.errToObj(t) });
  }
  uuid(t) {
    return this._addCheck({ kind: "uuid", ...g.errToObj(t) });
  }
  nanoid(t) {
    return this._addCheck({ kind: "nanoid", ...g.errToObj(t) });
  }
  cuid(t) {
    return this._addCheck({ kind: "cuid", ...g.errToObj(t) });
  }
  cuid2(t) {
    return this._addCheck({ kind: "cuid2", ...g.errToObj(t) });
  }
  ulid(t) {
    return this._addCheck({ kind: "ulid", ...g.errToObj(t) });
  }
  base64(t) {
    return this._addCheck({ kind: "base64", ...g.errToObj(t) });
  }
  base64url(t) {
    return this._addCheck({
      kind: "base64url",
      ...g.errToObj(t)
    });
  }
  jwt(t) {
    return this._addCheck({ kind: "jwt", ...g.errToObj(t) });
  }
  ip(t) {
    return this._addCheck({ kind: "ip", ...g.errToObj(t) });
  }
  cidr(t) {
    return this._addCheck({ kind: "cidr", ...g.errToObj(t) });
  }
  datetime(t) {
    return typeof t == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: t
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (t == null ? void 0 : t.precision) > "u" ? null : t == null ? void 0 : t.precision,
      offset: (t == null ? void 0 : t.offset) ?? !1,
      local: (t == null ? void 0 : t.local) ?? !1,
      ...g.errToObj(t == null ? void 0 : t.message)
    });
  }
  date(t) {
    return this._addCheck({ kind: "date", message: t });
  }
  time(t) {
    return typeof t == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: t
    }) : this._addCheck({
      kind: "time",
      precision: typeof (t == null ? void 0 : t.precision) > "u" ? null : t == null ? void 0 : t.precision,
      ...g.errToObj(t == null ? void 0 : t.message)
    });
  }
  duration(t) {
    return this._addCheck({ kind: "duration", ...g.errToObj(t) });
  }
  regex(t, r) {
    return this._addCheck({
      kind: "regex",
      regex: t,
      ...g.errToObj(r)
    });
  }
  includes(t, r) {
    return this._addCheck({
      kind: "includes",
      value: t,
      position: r == null ? void 0 : r.position,
      ...g.errToObj(r == null ? void 0 : r.message)
    });
  }
  startsWith(t, r) {
    return this._addCheck({
      kind: "startsWith",
      value: t,
      ...g.errToObj(r)
    });
  }
  endsWith(t, r) {
    return this._addCheck({
      kind: "endsWith",
      value: t,
      ...g.errToObj(r)
    });
  }
  min(t, r) {
    return this._addCheck({
      kind: "min",
      value: t,
      ...g.errToObj(r)
    });
  }
  max(t, r) {
    return this._addCheck({
      kind: "max",
      value: t,
      ...g.errToObj(r)
    });
  }
  length(t, r) {
    return this._addCheck({
      kind: "length",
      value: t,
      ...g.errToObj(r)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(t) {
    return this.min(1, g.errToObj(t));
  }
  trim() {
    return new we({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new we({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new we({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((t) => t.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((t) => t.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((t) => t.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((t) => t.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((t) => t.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((t) => t.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((t) => t.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((t) => t.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((t) => t.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((t) => t.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((t) => t.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((t) => t.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((t) => t.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((t) => t.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((t) => t.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((t) => t.kind === "base64url");
  }
  get minLength() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxLength() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
}
we.create = (e) => new we({
  checks: [],
  typeName: T.ZodString,
  coerce: (e == null ? void 0 : e.coerce) ?? !1,
  ...C(e)
});
function Zh(e, t) {
  const r = (e.toString().split(".")[1] || "").length, n = (t.toString().split(".")[1] || "").length, a = r > n ? r : n, s = Number.parseInt(e.toFixed(a).replace(".", "")), i = Number.parseInt(t.toFixed(a).replace(".", ""));
  return s % i / 10 ** a;
}
class St extends k {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(t) {
    if (this._def.coerce && (t.data = Number(t.data)), this._getType(t) !== v.number) {
      const s = this._getOrReturnCtx(t);
      return y(s, {
        code: p.invalid_type,
        expected: v.number,
        received: s.parsedType
      }), R;
    }
    let n;
    const a = new ne();
    for (const s of this._def.checks)
      s.kind === "int" ? V.isInteger(t.data) || (n = this._getOrReturnCtx(t, n), y(n, {
        code: p.invalid_type,
        expected: "integer",
        received: "float",
        message: s.message
      }), a.dirty()) : s.kind === "min" ? (s.inclusive ? t.data < s.value : t.data <= s.value) && (n = this._getOrReturnCtx(t, n), y(n, {
        code: p.too_small,
        minimum: s.value,
        type: "number",
        inclusive: s.inclusive,
        exact: !1,
        message: s.message
      }), a.dirty()) : s.kind === "max" ? (s.inclusive ? t.data > s.value : t.data >= s.value) && (n = this._getOrReturnCtx(t, n), y(n, {
        code: p.too_big,
        maximum: s.value,
        type: "number",
        inclusive: s.inclusive,
        exact: !1,
        message: s.message
      }), a.dirty()) : s.kind === "multipleOf" ? Zh(t.data, s.value) !== 0 && (n = this._getOrReturnCtx(t, n), y(n, {
        code: p.not_multiple_of,
        multipleOf: s.value,
        message: s.message
      }), a.dirty()) : s.kind === "finite" ? Number.isFinite(t.data) || (n = this._getOrReturnCtx(t, n), y(n, {
        code: p.not_finite,
        message: s.message
      }), a.dirty()) : V.assertNever(s);
    return { status: a.value, value: t.data };
  }
  gte(t, r) {
    return this.setLimit("min", t, !0, g.toString(r));
  }
  gt(t, r) {
    return this.setLimit("min", t, !1, g.toString(r));
  }
  lte(t, r) {
    return this.setLimit("max", t, !0, g.toString(r));
  }
  lt(t, r) {
    return this.setLimit("max", t, !1, g.toString(r));
  }
  setLimit(t, r, n, a) {
    return new St({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: r,
          inclusive: n,
          message: g.toString(a)
        }
      ]
    });
  }
  _addCheck(t) {
    return new St({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  int(t) {
    return this._addCheck({
      kind: "int",
      message: g.toString(t)
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: g.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: g.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: g.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: g.toString(t)
    });
  }
  multipleOf(t, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: g.toString(r)
    });
  }
  finite(t) {
    return this._addCheck({
      kind: "finite",
      message: g.toString(t)
    });
  }
  safe(t) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: g.toString(t)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: g.toString(t)
    });
  }
  get minValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
  get isInt() {
    return !!this._def.checks.find((t) => t.kind === "int" || t.kind === "multipleOf" && V.isInteger(t.value));
  }
  get isFinite() {
    let t = null, r = null;
    for (const n of this._def.checks) {
      if (n.kind === "finite" || n.kind === "int" || n.kind === "multipleOf")
        return !0;
      n.kind === "min" ? (r === null || n.value > r) && (r = n.value) : n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    }
    return Number.isFinite(r) && Number.isFinite(t);
  }
}
St.create = (e) => new St({
  checks: [],
  typeName: T.ZodNumber,
  coerce: (e == null ? void 0 : e.coerce) || !1,
  ...C(e)
});
class $t extends k {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(t) {
    if (this._def.coerce)
      try {
        t.data = BigInt(t.data);
      } catch {
        return this._getInvalidInput(t);
      }
    if (this._getType(t) !== v.bigint)
      return this._getInvalidInput(t);
    let n;
    const a = new ne();
    for (const s of this._def.checks)
      s.kind === "min" ? (s.inclusive ? t.data < s.value : t.data <= s.value) && (n = this._getOrReturnCtx(t, n), y(n, {
        code: p.too_small,
        type: "bigint",
        minimum: s.value,
        inclusive: s.inclusive,
        message: s.message
      }), a.dirty()) : s.kind === "max" ? (s.inclusive ? t.data > s.value : t.data >= s.value) && (n = this._getOrReturnCtx(t, n), y(n, {
        code: p.too_big,
        type: "bigint",
        maximum: s.value,
        inclusive: s.inclusive,
        message: s.message
      }), a.dirty()) : s.kind === "multipleOf" ? t.data % s.value !== BigInt(0) && (n = this._getOrReturnCtx(t, n), y(n, {
        code: p.not_multiple_of,
        multipleOf: s.value,
        message: s.message
      }), a.dirty()) : V.assertNever(s);
    return { status: a.value, value: t.data };
  }
  _getInvalidInput(t) {
    const r = this._getOrReturnCtx(t);
    return y(r, {
      code: p.invalid_type,
      expected: v.bigint,
      received: r.parsedType
    }), R;
  }
  gte(t, r) {
    return this.setLimit("min", t, !0, g.toString(r));
  }
  gt(t, r) {
    return this.setLimit("min", t, !1, g.toString(r));
  }
  lte(t, r) {
    return this.setLimit("max", t, !0, g.toString(r));
  }
  lt(t, r) {
    return this.setLimit("max", t, !1, g.toString(r));
  }
  setLimit(t, r, n, a) {
    return new $t({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: r,
          inclusive: n,
          message: g.toString(a)
        }
      ]
    });
  }
  _addCheck(t) {
    return new $t({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: g.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: g.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: g.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: g.toString(t)
    });
  }
  multipleOf(t, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: g.toString(r)
    });
  }
  get minValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t;
  }
}
$t.create = (e) => new $t({
  checks: [],
  typeName: T.ZodBigInt,
  coerce: (e == null ? void 0 : e.coerce) ?? !1,
  ...C(e)
});
class ls extends k {
  _parse(t) {
    if (this._def.coerce && (t.data = !!t.data), this._getType(t) !== v.boolean) {
      const n = this._getOrReturnCtx(t);
      return y(n, {
        code: p.invalid_type,
        expected: v.boolean,
        received: n.parsedType
      }), R;
    }
    return le(t.data);
  }
}
ls.create = (e) => new ls({
  typeName: T.ZodBoolean,
  coerce: (e == null ? void 0 : e.coerce) || !1,
  ...C(e)
});
class ar extends k {
  _parse(t) {
    if (this._def.coerce && (t.data = new Date(t.data)), this._getType(t) !== v.date) {
      const s = this._getOrReturnCtx(t);
      return y(s, {
        code: p.invalid_type,
        expected: v.date,
        received: s.parsedType
      }), R;
    }
    if (Number.isNaN(t.data.getTime())) {
      const s = this._getOrReturnCtx(t);
      return y(s, {
        code: p.invalid_date
      }), R;
    }
    const n = new ne();
    let a;
    for (const s of this._def.checks)
      s.kind === "min" ? t.data.getTime() < s.value && (a = this._getOrReturnCtx(t, a), y(a, {
        code: p.too_small,
        message: s.message,
        inclusive: !0,
        exact: !1,
        minimum: s.value,
        type: "date"
      }), n.dirty()) : s.kind === "max" ? t.data.getTime() > s.value && (a = this._getOrReturnCtx(t, a), y(a, {
        code: p.too_big,
        message: s.message,
        inclusive: !0,
        exact: !1,
        maximum: s.value,
        type: "date"
      }), n.dirty()) : V.assertNever(s);
    return {
      status: n.value,
      value: new Date(t.data.getTime())
    };
  }
  _addCheck(t) {
    return new ar({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  min(t, r) {
    return this._addCheck({
      kind: "min",
      value: t.getTime(),
      message: g.toString(r)
    });
  }
  max(t, r) {
    return this._addCheck({
      kind: "max",
      value: t.getTime(),
      message: g.toString(r)
    });
  }
  get minDate() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "min" && (t === null || r.value > t) && (t = r.value);
    return t != null ? new Date(t) : null;
  }
  get maxDate() {
    let t = null;
    for (const r of this._def.checks)
      r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    return t != null ? new Date(t) : null;
  }
}
ar.create = (e) => new ar({
  checks: [],
  coerce: (e == null ? void 0 : e.coerce) || !1,
  typeName: T.ZodDate,
  ...C(e)
});
class Au extends k {
  _parse(t) {
    if (this._getType(t) !== v.symbol) {
      const n = this._getOrReturnCtx(t);
      return y(n, {
        code: p.invalid_type,
        expected: v.symbol,
        received: n.parsedType
      }), R;
    }
    return le(t.data);
  }
}
Au.create = (e) => new Au({
  typeName: T.ZodSymbol,
  ...C(e)
});
class ds extends k {
  _parse(t) {
    if (this._getType(t) !== v.undefined) {
      const n = this._getOrReturnCtx(t);
      return y(n, {
        code: p.invalid_type,
        expected: v.undefined,
        received: n.parsedType
      }), R;
    }
    return le(t.data);
  }
}
ds.create = (e) => new ds({
  typeName: T.ZodUndefined,
  ...C(e)
});
class fs extends k {
  _parse(t) {
    if (this._getType(t) !== v.null) {
      const n = this._getOrReturnCtx(t);
      return y(n, {
        code: p.invalid_type,
        expected: v.null,
        received: n.parsedType
      }), R;
    }
    return le(t.data);
  }
}
fs.create = (e) => new fs({
  typeName: T.ZodNull,
  ...C(e)
});
class Nt extends k {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(t) {
    return le(t.data);
  }
}
Nt.create = (e) => new Nt({
  typeName: T.ZodAny,
  ...C(e)
});
class Tu extends k {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(t) {
    return le(t.data);
  }
}
Tu.create = (e) => new Tu({
  typeName: T.ZodUnknown,
  ...C(e)
});
class Ne extends k {
  _parse(t) {
    const r = this._getOrReturnCtx(t);
    return y(r, {
      code: p.invalid_type,
      expected: v.never,
      received: r.parsedType
    }), R;
  }
}
Ne.create = (e) => new Ne({
  typeName: T.ZodNever,
  ...C(e)
});
class Eu extends k {
  _parse(t) {
    if (this._getType(t) !== v.undefined) {
      const n = this._getOrReturnCtx(t);
      return y(n, {
        code: p.invalid_type,
        expected: v.void,
        received: n.parsedType
      }), R;
    }
    return le(t.data);
  }
}
Eu.create = (e) => new Eu({
  typeName: T.ZodVoid,
  ...C(e)
});
class pe extends k {
  _parse(t) {
    const { ctx: r, status: n } = this._processInputParams(t), a = this._def;
    if (r.parsedType !== v.array)
      return y(r, {
        code: p.invalid_type,
        expected: v.array,
        received: r.parsedType
      }), R;
    if (a.exactLength !== null) {
      const i = r.data.length > a.exactLength.value, o = r.data.length < a.exactLength.value;
      (i || o) && (y(r, {
        code: i ? p.too_big : p.too_small,
        minimum: o ? a.exactLength.value : void 0,
        maximum: i ? a.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: a.exactLength.message
      }), n.dirty());
    }
    if (a.minLength !== null && r.data.length < a.minLength.value && (y(r, {
      code: p.too_small,
      minimum: a.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: a.minLength.message
    }), n.dirty()), a.maxLength !== null && r.data.length > a.maxLength.value && (y(r, {
      code: p.too_big,
      maximum: a.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: a.maxLength.message
    }), n.dirty()), r.common.async)
      return Promise.all([...r.data].map((i, o) => a.type._parseAsync(new ye(r, i, r.path, o)))).then((i) => ne.mergeArray(n, i));
    const s = [...r.data].map((i, o) => a.type._parseSync(new ye(r, i, r.path, o)));
    return ne.mergeArray(n, s);
  }
  get element() {
    return this._def.type;
  }
  min(t, r) {
    return new pe({
      ...this._def,
      minLength: { value: t, message: g.toString(r) }
    });
  }
  max(t, r) {
    return new pe({
      ...this._def,
      maxLength: { value: t, message: g.toString(r) }
    });
  }
  length(t, r) {
    return new pe({
      ...this._def,
      exactLength: { value: t, message: g.toString(r) }
    });
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
pe.create = (e, t) => new pe({
  type: e,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: T.ZodArray,
  ...C(t)
});
function pt(e) {
  if (e instanceof W) {
    const t = {};
    for (const r in e.shape) {
      const n = e.shape[r];
      t[r] = Ce.create(pt(n));
    }
    return new W({
      ...e._def,
      shape: () => t
    });
  } else return e instanceof pe ? new pe({
    ...e._def,
    type: pt(e.element)
  }) : e instanceof Ce ? Ce.create(pt(e.unwrap())) : e instanceof Xe ? Xe.create(pt(e.unwrap())) : e instanceof ze ? ze.create(e.items.map((t) => pt(t))) : e;
}
class W extends k {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const t = this._def.shape(), r = V.objectKeys(t);
    return this._cached = { shape: t, keys: r }, this._cached;
  }
  _parse(t) {
    if (this._getType(t) !== v.object) {
      const l = this._getOrReturnCtx(t);
      return y(l, {
        code: p.invalid_type,
        expected: v.object,
        received: l.parsedType
      }), R;
    }
    const { status: n, ctx: a } = this._processInputParams(t), { shape: s, keys: i } = this._getCached(), o = [];
    if (!(this._def.catchall instanceof Ne && this._def.unknownKeys === "strip"))
      for (const l in a.data)
        i.includes(l) || o.push(l);
    const c = [];
    for (const l of i) {
      const h = s[l], m = a.data[l];
      c.push({
        key: { status: "valid", value: l },
        value: h._parse(new ye(a, m, a.path, l)),
        alwaysSet: l in a.data
      });
    }
    if (this._def.catchall instanceof Ne) {
      const l = this._def.unknownKeys;
      if (l === "passthrough")
        for (const h of o)
          c.push({
            key: { status: "valid", value: h },
            value: { status: "valid", value: a.data[h] }
          });
      else if (l === "strict")
        o.length > 0 && (y(a, {
          code: p.unrecognized_keys,
          keys: o
        }), n.dirty());
      else if (l !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const l = this._def.catchall;
      for (const h of o) {
        const m = a.data[h];
        c.push({
          key: { status: "valid", value: h },
          value: l._parse(
            new ye(a, m, a.path, h)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: h in a.data
        });
      }
    }
    return a.common.async ? Promise.resolve().then(async () => {
      const l = [];
      for (const h of c) {
        const m = await h.key, E = await h.value;
        l.push({
          key: m,
          value: E,
          alwaysSet: h.alwaysSet
        });
      }
      return l;
    }).then((l) => ne.mergeObjectSync(n, l)) : ne.mergeObjectSync(n, c);
  }
  get shape() {
    return this._def.shape();
  }
  strict(t) {
    return g.errToObj, new W({
      ...this._def,
      unknownKeys: "strict",
      ...t !== void 0 ? {
        errorMap: (r, n) => {
          var s, i;
          const a = ((i = (s = this._def).errorMap) == null ? void 0 : i.call(s, r, n).message) ?? n.defaultError;
          return r.code === "unrecognized_keys" ? {
            message: g.errToObj(t).message ?? a
          } : {
            message: a
          };
        }
      } : {}
    });
  }
  strip() {
    return new W({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new W({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(t) {
    return new W({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...t
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(t) {
    return new W({
      unknownKeys: t._def.unknownKeys,
      catchall: t._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...t._def.shape()
      }),
      typeName: T.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(t, r) {
    return this.augment({ [t]: r });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(t) {
    return new W({
      ...this._def,
      catchall: t
    });
  }
  pick(t) {
    const r = {};
    for (const n of V.objectKeys(t))
      t[n] && this.shape[n] && (r[n] = this.shape[n]);
    return new W({
      ...this._def,
      shape: () => r
    });
  }
  omit(t) {
    const r = {};
    for (const n of V.objectKeys(this.shape))
      t[n] || (r[n] = this.shape[n]);
    return new W({
      ...this._def,
      shape: () => r
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return pt(this);
  }
  partial(t) {
    const r = {};
    for (const n of V.objectKeys(this.shape)) {
      const a = this.shape[n];
      t && !t[n] ? r[n] = a : r[n] = a.optional();
    }
    return new W({
      ...this._def,
      shape: () => r
    });
  }
  required(t) {
    const r = {};
    for (const n of V.objectKeys(this.shape))
      if (t && !t[n])
        r[n] = this.shape[n];
      else {
        let s = this.shape[n];
        for (; s instanceof Ce; )
          s = s._def.innerType;
        r[n] = s;
      }
    return new W({
      ...this._def,
      shape: () => r
    });
  }
  keyof() {
    return xc(V.objectKeys(this.shape));
  }
}
W.create = (e, t) => new W({
  shape: () => e,
  unknownKeys: "strip",
  catchall: Ne.create(),
  typeName: T.ZodObject,
  ...C(t)
});
W.strictCreate = (e, t) => new W({
  shape: () => e,
  unknownKeys: "strict",
  catchall: Ne.create(),
  typeName: T.ZodObject,
  ...C(t)
});
W.lazycreate = (e, t) => new W({
  shape: e,
  unknownKeys: "strip",
  catchall: Ne.create(),
  typeName: T.ZodObject,
  ...C(t)
});
class sr extends k {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), n = this._def.options;
    function a(s) {
      for (const o of s)
        if (o.result.status === "valid")
          return o.result;
      for (const o of s)
        if (o.result.status === "dirty")
          return r.common.issues.push(...o.ctx.common.issues), o.result;
      const i = s.map((o) => new Ie(o.ctx.common.issues));
      return y(r, {
        code: p.invalid_union,
        unionErrors: i
      }), R;
    }
    if (r.common.async)
      return Promise.all(n.map(async (s) => {
        const i = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await s._parseAsync({
            data: r.data,
            path: r.path,
            parent: i
          }),
          ctx: i
        };
      })).then(a);
    {
      let s;
      const i = [];
      for (const c of n) {
        const l = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        }, h = c._parseSync({
          data: r.data,
          path: r.path,
          parent: l
        });
        if (h.status === "valid")
          return h;
        h.status === "dirty" && !s && (s = { result: h, ctx: l }), l.common.issues.length && i.push(l.common.issues);
      }
      if (s)
        return r.common.issues.push(...s.ctx.common.issues), s.result;
      const o = i.map((c) => new Ie(c));
      return y(r, {
        code: p.invalid_union,
        unionErrors: o
      }), R;
    }
  }
  get options() {
    return this._def.options;
  }
}
sr.create = (e, t) => new sr({
  options: e,
  typeName: T.ZodUnion,
  ...C(t)
});
const Re = (e) => e instanceof ur ? Re(e.schema) : e instanceof Ye ? Re(e.innerType()) : e instanceof cr ? [e.value] : e instanceof Qe ? e.options : e instanceof ps ? V.objectValues(e.enum) : e instanceof dr ? Re(e._def.innerType) : e instanceof ds ? [void 0] : e instanceof fs ? [null] : e instanceof Ce ? [void 0, ...Re(e.unwrap())] : e instanceof Xe ? [null, ...Re(e.unwrap())] : e instanceof Oc || e instanceof hr ? Re(e.unwrap()) : e instanceof fr ? Re(e._def.innerType) : [];
class ks extends k {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    if (r.parsedType !== v.object)
      return y(r, {
        code: p.invalid_type,
        expected: v.object,
        received: r.parsedType
      }), R;
    const n = this.discriminator, a = r.data[n], s = this.optionsMap.get(a);
    return s ? r.common.async ? s._parseAsync({
      data: r.data,
      path: r.path,
      parent: r
    }) : s._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }) : (y(r, {
      code: p.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [n]
    }), R);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(t, r, n) {
    const a = /* @__PURE__ */ new Map();
    for (const s of r) {
      const i = Re(s.shape[t]);
      if (!i.length)
        throw new Error(`A discriminator value for key \`${t}\` could not be extracted from all schema options`);
      for (const o of i) {
        if (a.has(o))
          throw new Error(`Discriminator property ${String(t)} has duplicate value ${String(o)}`);
        a.set(o, s);
      }
    }
    return new ks({
      typeName: T.ZodDiscriminatedUnion,
      discriminator: t,
      options: r,
      optionsMap: a,
      ...C(n)
    });
  }
}
function hs(e, t) {
  const r = qe(e), n = qe(t);
  if (e === t)
    return { valid: !0, data: e };
  if (r === v.object && n === v.object) {
    const a = V.objectKeys(t), s = V.objectKeys(e).filter((o) => a.indexOf(o) !== -1), i = { ...e, ...t };
    for (const o of s) {
      const c = hs(e[o], t[o]);
      if (!c.valid)
        return { valid: !1 };
      i[o] = c.data;
    }
    return { valid: !0, data: i };
  } else if (r === v.array && n === v.array) {
    if (e.length !== t.length)
      return { valid: !1 };
    const a = [];
    for (let s = 0; s < e.length; s++) {
      const i = e[s], o = t[s], c = hs(i, o);
      if (!c.valid)
        return { valid: !1 };
      a.push(c.data);
    }
    return { valid: !0, data: a };
  } else return r === v.date && n === v.date && +e == +t ? { valid: !0, data: e } : { valid: !1 };
}
class ir extends k {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t), a = (s, i) => {
      if (_u(s) || _u(i))
        return R;
      const o = hs(s.value, i.value);
      return o.valid ? ((bu(s) || bu(i)) && r.dirty(), { status: r.value, value: o.data }) : (y(n, {
        code: p.invalid_intersection_types
      }), R);
    };
    return n.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      }),
      this._def.right._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      })
    ]).then(([s, i]) => a(s, i)) : a(this._def.left._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }), this._def.right._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }));
  }
}
ir.create = (e, t, r) => new ir({
  left: e,
  right: t,
  typeName: T.ZodIntersection,
  ...C(r)
});
class ze extends k {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== v.array)
      return y(n, {
        code: p.invalid_type,
        expected: v.array,
        received: n.parsedType
      }), R;
    if (n.data.length < this._def.items.length)
      return y(n, {
        code: p.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), R;
    !this._def.rest && n.data.length > this._def.items.length && (y(n, {
      code: p.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), r.dirty());
    const s = [...n.data].map((i, o) => {
      const c = this._def.items[o] || this._def.rest;
      return c ? c._parse(new ye(n, i, n.path, o)) : null;
    }).filter((i) => !!i);
    return n.common.async ? Promise.all(s).then((i) => ne.mergeArray(r, i)) : ne.mergeArray(r, s);
  }
  get items() {
    return this._def.items;
  }
  rest(t) {
    return new ze({
      ...this._def,
      rest: t
    });
  }
}
ze.create = (e, t) => {
  if (!Array.isArray(e))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new ze({
    items: e,
    typeName: T.ZodTuple,
    rest: null,
    ...C(t)
  });
};
class or extends k {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== v.object)
      return y(n, {
        code: p.invalid_type,
        expected: v.object,
        received: n.parsedType
      }), R;
    const a = [], s = this._def.keyType, i = this._def.valueType;
    for (const o in n.data)
      a.push({
        key: s._parse(new ye(n, o, n.path, o)),
        value: i._parse(new ye(n, n.data[o], n.path, o)),
        alwaysSet: o in n.data
      });
    return n.common.async ? ne.mergeObjectAsync(r, a) : ne.mergeObjectSync(r, a);
  }
  get element() {
    return this._def.valueType;
  }
  static create(t, r, n) {
    return r instanceof k ? new or({
      keyType: t,
      valueType: r,
      typeName: T.ZodRecord,
      ...C(n)
    }) : new or({
      keyType: we.create(),
      valueType: t,
      typeName: T.ZodRecord,
      ...C(r)
    });
  }
}
class Ru extends k {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== v.map)
      return y(n, {
        code: p.invalid_type,
        expected: v.map,
        received: n.parsedType
      }), R;
    const a = this._def.keyType, s = this._def.valueType, i = [...n.data.entries()].map(([o, c], l) => ({
      key: a._parse(new ye(n, o, n.path, [l, "key"])),
      value: s._parse(new ye(n, c, n.path, [l, "value"]))
    }));
    if (n.common.async) {
      const o = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const c of i) {
          const l = await c.key, h = await c.value;
          if (l.status === "aborted" || h.status === "aborted")
            return R;
          (l.status === "dirty" || h.status === "dirty") && r.dirty(), o.set(l.value, h.value);
        }
        return { status: r.value, value: o };
      });
    } else {
      const o = /* @__PURE__ */ new Map();
      for (const c of i) {
        const l = c.key, h = c.value;
        if (l.status === "aborted" || h.status === "aborted")
          return R;
        (l.status === "dirty" || h.status === "dirty") && r.dirty(), o.set(l.value, h.value);
      }
      return { status: r.value, value: o };
    }
  }
}
Ru.create = (e, t, r) => new Ru({
  valueType: t,
  keyType: e,
  typeName: T.ZodMap,
  ...C(r)
});
class Dt extends k {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.parsedType !== v.set)
      return y(n, {
        code: p.invalid_type,
        expected: v.set,
        received: n.parsedType
      }), R;
    const a = this._def;
    a.minSize !== null && n.data.size < a.minSize.value && (y(n, {
      code: p.too_small,
      minimum: a.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: a.minSize.message
    }), r.dirty()), a.maxSize !== null && n.data.size > a.maxSize.value && (y(n, {
      code: p.too_big,
      maximum: a.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: a.maxSize.message
    }), r.dirty());
    const s = this._def.valueType;
    function i(c) {
      const l = /* @__PURE__ */ new Set();
      for (const h of c) {
        if (h.status === "aborted")
          return R;
        h.status === "dirty" && r.dirty(), l.add(h.value);
      }
      return { status: r.value, value: l };
    }
    const o = [...n.data.values()].map((c, l) => s._parse(new ye(n, c, n.path, l)));
    return n.common.async ? Promise.all(o).then((c) => i(c)) : i(o);
  }
  min(t, r) {
    return new Dt({
      ...this._def,
      minSize: { value: t, message: g.toString(r) }
    });
  }
  max(t, r) {
    return new Dt({
      ...this._def,
      maxSize: { value: t, message: g.toString(r) }
    });
  }
  size(t, r) {
    return this.min(t, r).max(t, r);
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
Dt.create = (e, t) => new Dt({
  valueType: e,
  minSize: null,
  maxSize: null,
  typeName: T.ZodSet,
  ...C(t)
});
class ur extends k {
  get schema() {
    return this._def.getter();
  }
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    return this._def.getter()._parse({ data: r.data, path: r.path, parent: r });
  }
}
ur.create = (e, t) => new ur({
  getter: e,
  typeName: T.ZodLazy,
  ...C(t)
});
class cr extends k {
  _parse(t) {
    if (t.data !== this._def.value) {
      const r = this._getOrReturnCtx(t);
      return y(r, {
        received: r.data,
        code: p.invalid_literal,
        expected: this._def.value
      }), R;
    }
    return { status: "valid", value: t.data };
  }
  get value() {
    return this._def.value;
  }
}
cr.create = (e, t) => new cr({
  value: e,
  typeName: T.ZodLiteral,
  ...C(t)
});
function xc(e, t) {
  return new Qe({
    values: e,
    typeName: T.ZodEnum,
    ...C(t)
  });
}
class Qe extends k {
  constructor() {
    super(...arguments), Vt.set(this, void 0);
  }
  _parse(t) {
    if (typeof t.data != "string") {
      const r = this._getOrReturnCtx(t), n = this._def.values;
      return y(r, {
        expected: V.joinValues(n),
        received: r.parsedType,
        code: p.invalid_type
      }), R;
    }
    if (nr(this, Vt, "f") || wc(this, Vt, new Set(this._def.values), "f"), !nr(this, Vt, "f").has(t.data)) {
      const r = this._getOrReturnCtx(t), n = this._def.values;
      return y(r, {
        received: r.data,
        code: p.invalid_enum_value,
        options: n
      }), R;
    }
    return le(t.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  get Values() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  get Enum() {
    const t = {};
    for (const r of this._def.values)
      t[r] = r;
    return t;
  }
  extract(t, r = this._def) {
    return Qe.create(t, {
      ...this._def,
      ...r
    });
  }
  exclude(t, r = this._def) {
    return Qe.create(this.options.filter((n) => !t.includes(n)), {
      ...this._def,
      ...r
    });
  }
}
Vt = /* @__PURE__ */ new WeakMap();
Qe.create = xc;
class ps extends k {
  constructor() {
    super(...arguments), Mt.set(this, void 0);
  }
  _parse(t) {
    const r = V.getValidEnumValues(this._def.values), n = this._getOrReturnCtx(t);
    if (n.parsedType !== v.string && n.parsedType !== v.number) {
      const a = V.objectValues(r);
      return y(n, {
        expected: V.joinValues(a),
        received: n.parsedType,
        code: p.invalid_type
      }), R;
    }
    if (nr(this, Mt, "f") || wc(this, Mt, new Set(V.getValidEnumValues(this._def.values)), "f"), !nr(this, Mt, "f").has(t.data)) {
      const a = V.objectValues(r);
      return y(n, {
        received: n.data,
        code: p.invalid_enum_value,
        options: a
      }), R;
    }
    return le(t.data);
  }
  get enum() {
    return this._def.values;
  }
}
Mt = /* @__PURE__ */ new WeakMap();
ps.create = (e, t) => new ps({
  values: e,
  typeName: T.ZodNativeEnum,
  ...C(t)
});
class lr extends k {
  unwrap() {
    return this._def.type;
  }
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    if (r.parsedType !== v.promise && r.common.async === !1)
      return y(r, {
        code: p.invalid_type,
        expected: v.promise,
        received: r.parsedType
      }), R;
    const n = r.parsedType === v.promise ? r.data : Promise.resolve(r.data);
    return le(n.then((a) => this._def.type.parseAsync(a, {
      path: r.path,
      errorMap: r.common.contextualErrorMap
    })));
  }
}
lr.create = (e, t) => new lr({
  type: e,
  typeName: T.ZodPromise,
  ...C(t)
});
class Ye extends k {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === T.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t), a = this._def.effect || null, s = {
      addIssue: (i) => {
        y(n, i), i.fatal ? r.abort() : r.dirty();
      },
      get path() {
        return n.path;
      }
    };
    if (s.addIssue = s.addIssue.bind(s), a.type === "preprocess") {
      const i = a.transform(n.data, s);
      if (n.common.async)
        return Promise.resolve(i).then(async (o) => {
          if (r.value === "aborted")
            return R;
          const c = await this._def.schema._parseAsync({
            data: o,
            path: n.path,
            parent: n
          });
          return c.status === "aborted" ? R : c.status === "dirty" || r.value === "dirty" ? qt(c.value) : c;
        });
      {
        if (r.value === "aborted")
          return R;
        const o = this._def.schema._parseSync({
          data: i,
          path: n.path,
          parent: n
        });
        return o.status === "aborted" ? R : o.status === "dirty" || r.value === "dirty" ? qt(o.value) : o;
      }
    }
    if (a.type === "refinement") {
      const i = (o) => {
        const c = a.refinement(o, s);
        if (n.common.async)
          return Promise.resolve(c);
        if (c instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return o;
      };
      if (n.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return o.status === "aborted" ? R : (o.status === "dirty" && r.dirty(), i(o.value), { status: r.value, value: o.value });
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((o) => o.status === "aborted" ? R : (o.status === "dirty" && r.dirty(), i(o.value).then(() => ({ status: r.value, value: o.value }))));
    }
    if (a.type === "transform")
      if (n.common.async === !1) {
        const i = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        if (!bt(i))
          return i;
        const o = a.transform(i.value, s);
        if (o instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: r.value, value: o };
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((i) => bt(i) ? Promise.resolve(a.transform(i.value, s)).then((o) => ({
          status: r.value,
          value: o
        })) : i);
    V.assertNever(a);
  }
}
Ye.create = (e, t, r) => new Ye({
  schema: e,
  typeName: T.ZodEffects,
  effect: t,
  ...C(r)
});
Ye.createWithPreprocess = (e, t, r) => new Ye({
  schema: t,
  effect: { type: "preprocess", transform: e },
  typeName: T.ZodEffects,
  ...C(r)
});
class Ce extends k {
  _parse(t) {
    return this._getType(t) === v.undefined ? le(void 0) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Ce.create = (e, t) => new Ce({
  innerType: e,
  typeName: T.ZodOptional,
  ...C(t)
});
class Xe extends k {
  _parse(t) {
    return this._getType(t) === v.null ? le(null) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Xe.create = (e, t) => new Xe({
  innerType: e,
  typeName: T.ZodNullable,
  ...C(t)
});
class dr extends k {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t);
    let n = r.data;
    return r.parsedType === v.undefined && (n = this._def.defaultValue()), this._def.innerType._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
dr.create = (e, t) => new dr({
  innerType: e,
  typeName: T.ZodDefault,
  defaultValue: typeof t.default == "function" ? t.default : () => t.default,
  ...C(t)
});
class fr extends k {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), n = {
      ...r,
      common: {
        ...r.common,
        issues: []
      }
    }, a = this._def.innerType._parse({
      data: n.data,
      path: n.path,
      parent: {
        ...n
      }
    });
    return rr(a) ? a.then((s) => ({
      status: "valid",
      value: s.status === "valid" ? s.value : this._def.catchValue({
        get error() {
          return new Ie(n.common.issues);
        },
        input: n.data
      })
    })) : {
      status: "valid",
      value: a.status === "valid" ? a.value : this._def.catchValue({
        get error() {
          return new Ie(n.common.issues);
        },
        input: n.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
fr.create = (e, t) => new fr({
  innerType: e,
  typeName: T.ZodCatch,
  catchValue: typeof t.catch == "function" ? t.catch : () => t.catch,
  ...C(t)
});
class wu extends k {
  _parse(t) {
    if (this._getType(t) !== v.nan) {
      const n = this._getOrReturnCtx(t);
      return y(n, {
        code: p.invalid_type,
        expected: v.nan,
        received: n.parsedType
      }), R;
    }
    return { status: "valid", value: t.data };
  }
}
wu.create = (e) => new wu({
  typeName: T.ZodNaN,
  ...C(e)
});
class Oc extends k {
  _parse(t) {
    const { ctx: r } = this._processInputParams(t), n = r.data;
    return this._def.type._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class Ps extends k {
  _parse(t) {
    const { status: r, ctx: n } = this._processInputParams(t);
    if (n.common.async)
      return (async () => {
        const s = await this._def.in._parseAsync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return s.status === "aborted" ? R : s.status === "dirty" ? (r.dirty(), qt(s.value)) : this._def.out._parseAsync({
          data: s.value,
          path: n.path,
          parent: n
        });
      })();
    {
      const a = this._def.in._parseSync({
        data: n.data,
        path: n.path,
        parent: n
      });
      return a.status === "aborted" ? R : a.status === "dirty" ? (r.dirty(), {
        status: "dirty",
        value: a.value
      }) : this._def.out._parseSync({
        data: a.value,
        path: n.path,
        parent: n
      });
    }
  }
  static create(t, r) {
    return new Ps({
      in: t,
      out: r,
      typeName: T.ZodPipeline
    });
  }
}
class hr extends k {
  _parse(t) {
    const r = this._def.innerType._parse(t), n = (a) => (bt(a) && (a.value = Object.freeze(a.value)), a);
    return rr(r) ? r.then((a) => n(a)) : n(r);
  }
  unwrap() {
    return this._def.innerType;
  }
}
hr.create = (e, t) => new hr({
  innerType: e,
  typeName: T.ZodReadonly,
  ...C(t)
});
function Cu(e, t) {
  const r = typeof e == "function" ? e(t) : typeof e == "string" ? { message: e } : e;
  return typeof r == "string" ? { message: r } : r;
}
function qs(e, t = {}, r) {
  return e ? Nt.create().superRefine((n, a) => {
    const s = e(n);
    if (s instanceof Promise)
      return s.then((i) => {
        if (!i) {
          const o = Cu(t, n), c = o.fatal ?? r ?? !0;
          a.addIssue({ code: "custom", ...o, fatal: c });
        }
      });
    if (!s) {
      const i = Cu(t, n), o = i.fatal ?? r ?? !0;
      a.addIssue({ code: "custom", ...i, fatal: o });
    }
  }) : Nt.create();
}
var T;
(function(e) {
  e.ZodString = "ZodString", e.ZodNumber = "ZodNumber", e.ZodNaN = "ZodNaN", e.ZodBigInt = "ZodBigInt", e.ZodBoolean = "ZodBoolean", e.ZodDate = "ZodDate", e.ZodSymbol = "ZodSymbol", e.ZodUndefined = "ZodUndefined", e.ZodNull = "ZodNull", e.ZodAny = "ZodAny", e.ZodUnknown = "ZodUnknown", e.ZodNever = "ZodNever", e.ZodVoid = "ZodVoid", e.ZodArray = "ZodArray", e.ZodObject = "ZodObject", e.ZodUnion = "ZodUnion", e.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", e.ZodIntersection = "ZodIntersection", e.ZodTuple = "ZodTuple", e.ZodRecord = "ZodRecord", e.ZodMap = "ZodMap", e.ZodSet = "ZodSet", e.ZodFunction = "ZodFunction", e.ZodLazy = "ZodLazy", e.ZodLiteral = "ZodLiteral", e.ZodEnum = "ZodEnum", e.ZodEffects = "ZodEffects", e.ZodNativeEnum = "ZodNativeEnum", e.ZodOptional = "ZodOptional", e.ZodNullable = "ZodNullable", e.ZodDefault = "ZodDefault", e.ZodCatch = "ZodCatch", e.ZodPromise = "ZodPromise", e.ZodBranded = "ZodBranded", e.ZodPipeline = "ZodPipeline", e.ZodReadonly = "ZodReadonly";
})(T || (T = {}));
const Cr = (e, t = {
  message: `Input not instance of ${e.name}`
}) => qs((r) => r instanceof e, t), u = we.create, tt = St.create, w = ls.create;
Nt.create;
Ne.create;
const A = pe.create, f = W.create, U = sr.create, K = ks.create;
ir.create;
ze.create;
const Wh = or.create, de = ur.create, d = cr.create, re = Qe.create;
lr.create;
const ce = Ce.create;
Xe.create;
var b = (e) => e, Jh = class {
  /**
   * @package
   */
  constructor(e, t, r) {
    this.versionMap = e, this.latestVersion = t, this.getVersion = r;
  }
  /**
   * Returns whether the given data is a valid entity of any version of the entity.
   * @param data The data to check
   * @returns Whether the given data is a valid entity of any version of the entity.
   */
  is(e) {
    let t = this.getVersion(e);
    if (t === null) return !1;
    const r = this.versionMap[t];
    return r ? r.schema.safeParse(e).success : !1;
  }
  /**
   * Returns whether the given data is a valid entity of the latest version of the entity.
   * @param data The data to check
   * @returns Whether the given data is a valid entity of the latest version of the entity.
   */
  isLatest(e) {
    return this.versionMap[this.latestVersion].schema.safeParse(e).success;
  }
  /**
   * Type guard that checks if data is valid for any version up to and including the specified version.
   * 
   * @param data The data to check
   * @param upToVersion The maximum version to check against (inclusive)
   * @returns true if the data is valid for any version from 1 to upToVersion,
   *          false if the data's version is higher than upToVersion or invalid
   * 
   * @example
   * ```ts
   * const entity = createVersionedEntity({ ... })
   * 
   * if (entity.isUpToVersion(data, 2)) {
   *   // data is guaranteed to be v1 or v2 (but not v3 or higher)
   * }
   * 
   * // Returns false for v3 data when checking up to v2
   * entity.isUpToVersion(v3Data, 2) // false
   * ```
   * 
   * Note: This is particularly useful for recursive entity definitions where you want to ensure
   * nested entities are at a specific version or lower.
   */
  isUpToVersion(e, t) {
    let r = this.getVersion(e);
    if (r === null || r > t) return !1;
    const n = this.versionMap[r];
    return n ? n.schema.safeParse(e).success : !1;
  }
  /**
   * Similar to Zod's `safeParse` method, but also migrates the data to the latest version.
   * @param data The data to parse
   * @returns The result from parsing data, if successful, older versions are migrated to the latest version
   */
  safeParse(e) {
    const t = this.getVersion(e);
    if (t === null)
      return { type: "err", error: { type: "VER_CHECK_FAIL" } };
    const r = this.versionMap[t];
    if (!r)
      return { type: "err", error: { type: "INVALID_VER" } };
    const n = r.schema.safeParse(e);
    if (!n.success)
      return {
        type: "err",
        error: {
          type: "GIVEN_VER_VALIDATION_FAIL",
          version: t,
          versionDef: r,
          error: n.error
        }
      };
    let a = n.data;
    for (let s = t + 1; s <= this.latestVersion; s++) {
      const i = this.versionMap[s];
      if (!i)
        return {
          type: "err",
          error: { type: "BUG_NO_INTERMEDIATE_FOUND", missingVer: s }
        };
      if (i.initial)
        return {
          type: "err",
          error: { type: "BUG_INTERMEDIATE_MARKED_INITIAL", ver: s }
        };
      a = i.up(a);
    }
    return { type: "ok", value: a };
  }
  /**
   * Returns the Zod schema for the latest version of the entity.
   * 
   * @example
   * ```ts
   * const UserEntity = createVersionedEntity({ ... })
   * const latestSchema = UserEntity.latestSchema
   * ```
   */
  get latestSchema() {
    return this.versionMap[this.latestVersion].schema;
  }
  /**
   * Parses data and migrates it up to a specific version (not beyond).
   * 
   * @param data The data to parse and potentially migrate
   * @param version The target version to migrate to (will not migrate beyond this)
   * @returns A ParseResult containing either the migrated data or an error.
   *          Returns { type: "err", error: { type: "INVALID_VER" } } if data version is higher than requested.
   * 
   * @example
   * ```ts
   * // If you have v1 data and versions up to v4 exist:
   * const result = entity.safeParseUpToVersion(v1Data, 2)
   * // result will contain v2 data (not v3 or v4)
   * 
   * // Trying to parse v3 data up to v2 returns an error
   * const result = entity.safeParseUpToVersion(v3Data, 2)
   * // result: { type: "err", error: { type: "INVALID_VER" } }
   * ```
   * 
   * Note: This is particularly useful for recursive entity definitions to prevent migration
   * functions from receiving future versions they weren't designed to handle.
   */
  safeParseUpToVersion(e, t) {
    const r = this.getVersion(e);
    if (r === null)
      return { type: "err", error: { type: "VER_CHECK_FAIL" } };
    if (r > t)
      return { type: "err", error: { type: "INVALID_VER" } };
    const n = this.versionMap[r];
    if (!n)
      return { type: "err", error: { type: "INVALID_VER" } };
    const a = n.schema.safeParse(e);
    if (!a.success)
      return {
        type: "err",
        error: {
          type: "GIVEN_VER_VALIDATION_FAIL",
          version: r,
          versionDef: n,
          error: a.error
        }
      };
    let s = a.data;
    for (let i = r + 1; i <= t; i++) {
      const o = this.versionMap[i];
      if (!o)
        return {
          type: "err",
          error: { type: "BUG_NO_INTERMEDIATE_FOUND", missingVer: i }
        };
      if (o.initial)
        return {
          type: "err",
          error: { type: "BUG_INTERMEDIATE_MARKED_INITIAL", ver: i }
        };
      s = o.up(s);
    }
    return { type: "ok", value: s };
  }
};
function rt(e) {
  return new Jh(e.versionMap, e.latestVersion, e.getVersion);
}
function At(e) {
  return qs((t) => e.is(t)).transform((t) => {
    const r = e.safeParse(t);
    if (r.type !== "ok")
      throw new Error(
        "Invalid entity definition. `entity.is` returned success, safeParse failed."
      );
    return r.value;
  });
}
function ge(e, t) {
  return qs((r) => e.isUpToVersion(r, t)).transform((r) => {
    const n = e.safeParseUpToVersion(r, t);
    if (n.type !== "ok")
      throw new Error(
        "Invalid entity definition. `entity.isUpToVersion` returned success, safeParse failed."
      );
    return n.value;
  });
}
var Ga, Iu;
function zh() {
  if (Iu) return Ga;
  Iu = 1;
  var e = "__lodash_hash_undefined__";
  function t(r) {
    return this.__data__.set(r, e), this;
  }
  return Ga = t, Ga;
}
var Fa, xu;
function Qh() {
  if (xu) return Fa;
  xu = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return Fa = e, Fa;
}
var Za, Ou;
function Yh() {
  if (Ou) return Za;
  Ou = 1;
  var e = lc(), t = zh(), r = Qh();
  function n(a) {
    var s = -1, i = a == null ? 0 : a.length;
    for (this.__data__ = new e(); ++s < i; )
      this.add(a[s]);
  }
  return n.prototype.add = n.prototype.push = t, n.prototype.has = r, Za = n, Za;
}
var Wa, ku;
function Xh() {
  if (ku) return Wa;
  ku = 1;
  function e(t, r) {
    for (var n = -1, a = t == null ? 0 : t.length; ++n < a; )
      if (r(t[n], n, t))
        return !0;
    return !1;
  }
  return Wa = e, Wa;
}
var Ja, Pu;
function ep() {
  if (Pu) return Ja;
  Pu = 1;
  function e(t, r) {
    return t.has(r);
  }
  return Ja = e, Ja;
}
var za, qu;
function kc() {
  if (qu) return za;
  qu = 1;
  var e = Yh(), t = Xh(), r = ep(), n = 1, a = 2;
  function s(i, o, c, l, h, m) {
    var E = c & n, D = i.length, Z = o.length;
    if (D != Z && !(E && Z > D))
      return !1;
    var j = m.get(i), $ = m.get(o);
    if (j && $)
      return j == o && $ == i;
    var M = -1, I = !0, B = c & a ? new e() : void 0;
    for (m.set(i, o), m.set(o, i); ++M < D; ) {
      var P = i[M], G = o[M];
      if (l)
        var q = E ? l(G, P, M, o, i, m) : l(P, G, M, i, o, m);
      if (q !== void 0) {
        if (q)
          continue;
        I = !1;
        break;
      }
      if (B) {
        if (!t(o, function(O, J) {
          if (!r(B, J) && (P === O || h(P, O, c, l, m)))
            return B.push(J);
        })) {
          I = !1;
          break;
        }
      } else if (!(P === G || h(P, G, c, l, m))) {
        I = !1;
        break;
      }
    }
    return m.delete(i), m.delete(o), I;
  }
  return za = s, za;
}
var Qa, Vu;
function tp() {
  if (Vu) return Qa;
  Vu = 1;
  function e(t) {
    var r = -1, n = Array(t.size);
    return t.forEach(function(a, s) {
      n[++r] = [s, a];
    }), n;
  }
  return Qa = e, Qa;
}
var Ya, Mu;
function rp() {
  if (Mu) return Ya;
  Mu = 1;
  function e(t) {
    var r = -1, n = Array(t.size);
    return t.forEach(function(a) {
      n[++r] = a;
    }), n;
  }
  return Ya = e, Ya;
}
var Xa, $u;
function np() {
  if ($u) return Xa;
  $u = 1;
  var e = br(), t = Rc(), r = Ss(), n = kc(), a = tp(), s = rp(), i = 1, o = 2, c = "[object Boolean]", l = "[object Date]", h = "[object Error]", m = "[object Map]", E = "[object Number]", D = "[object RegExp]", Z = "[object Set]", j = "[object String]", $ = "[object Symbol]", M = "[object ArrayBuffer]", I = "[object DataView]", B = e ? e.prototype : void 0, P = B ? B.valueOf : void 0;
  function G(q, O, J, H, ae, x, te) {
    switch (J) {
      case I:
        if (q.byteLength != O.byteLength || q.byteOffset != O.byteOffset)
          return !1;
        q = q.buffer, O = O.buffer;
      case M:
        return !(q.byteLength != O.byteLength || !x(new t(q), new t(O)));
      case c:
      case l:
      case E:
        return r(+q, +O);
      case h:
        return q.name == O.name && q.message == O.message;
      case D:
      case j:
        return q == O + "";
      case m:
        var ie = a;
      case Z:
        var it = H & i;
        if (ie || (ie = s), q.size != O.size && !it)
          return !1;
        var ot = te.get(q);
        if (ot)
          return ot == O;
        H |= o, te.set(q, O);
        var Br = n(ie(q), ie(O), H, ae, x, te);
        return te.delete(q), Br;
      case $:
        if (P)
          return P.call(q) == P.call(O);
    }
    return !1;
  }
  return Xa = G, Xa;
}
var es, Nu;
function ap() {
  if (Nu) return es;
  Nu = 1;
  var e = Ec(), t = 1, r = Object.prototype, n = r.hasOwnProperty;
  function a(s, i, o, c, l, h) {
    var m = o & t, E = e(s), D = E.length, Z = e(i), j = Z.length;
    if (D != j && !m)
      return !1;
    for (var $ = D; $--; ) {
      var M = E[$];
      if (!(m ? M in i : n.call(i, M)))
        return !1;
    }
    var I = h.get(s), B = h.get(i);
    if (I && B)
      return I == i && B == s;
    var P = !0;
    h.set(s, i), h.set(i, s);
    for (var G = m; ++$ < D; ) {
      M = E[$];
      var q = s[M], O = i[M];
      if (c)
        var J = m ? c(O, q, M, i, s, h) : c(q, O, M, s, i, h);
      if (!(J === void 0 ? q === O || l(q, O, o, c, h) : J)) {
        P = !1;
        break;
      }
      G || (G = M == "constructor");
    }
    if (P && !G) {
      var H = s.constructor, ae = i.constructor;
      H != ae && "constructor" in s && "constructor" in i && !(typeof H == "function" && H instanceof H && typeof ae == "function" && ae instanceof ae) && (P = !1);
    }
    return h.delete(s), h.delete(i), P;
  }
  return es = a, es;
}
var ts, Du;
function sp() {
  if (Du) return ts;
  Du = 1;
  var e = dc(), t = kc(), r = np(), n = ap(), a = wr(), s = Rr(), i = Ts(), o = yc(), c = 1, l = "[object Arguments]", h = "[object Array]", m = "[object Object]", E = Object.prototype, D = E.hasOwnProperty;
  function Z(j, $, M, I, B, P) {
    var G = s(j), q = s($), O = G ? h : a(j), J = q ? h : a($);
    O = O == l ? m : O, J = J == l ? m : J;
    var H = O == m, ae = J == m, x = O == J;
    if (x && i(j)) {
      if (!i($))
        return !1;
      G = !0, H = !1;
    }
    if (x && !H)
      return P || (P = new e()), G || o(j) ? t(j, $, M, I, B, P) : r(j, $, O, M, I, B, P);
    if (!(M & c)) {
      var te = H && D.call(j, "__wrapped__"), ie = ae && D.call($, "__wrapped__");
      if (te || ie) {
        var it = te ? j.value() : j, ot = ie ? $.value() : $;
        return P || (P = new e()), B(it, ot, M, I, P);
      }
    }
    return x ? (P || (P = new e()), n(j, $, M, I, B, P)) : !1;
  }
  return ts = Z, ts;
}
var rs, ju;
function ip() {
  if (ju) return rs;
  ju = 1;
  var e = sp(), t = Ct();
  function r(n, a, s, i, o) {
    return n === a ? !0 : n == null || a == null || !t(n) && !t(a) ? n !== n && a !== a : e(n, a, s, i, r, o);
  }
  return rs = r, rs;
}
var ns, Hu;
function op() {
  if (Hu) return ns;
  Hu = 1;
  var e = ip();
  function t(r, n) {
    return e(r, n);
  }
  return ns = t, ns;
}
var up = op();
const cp = /* @__PURE__ */ ic(up), Lu = (e) => ({
  equals(t, r) {
    return t !== void 0 && r !== void 0 ? e.equals(t, r) : t === void 0 && r === void 0;
  }
}), as = (e, t) => ({
  equals(r, n) {
    return t.equals(e(r), e(n));
  }
}), dt = {
  equals(e, t) {
    return cp(e, t);
  }
}, lp = f({
  id: ce(u()),
  // Firebase Firestore ID
  url: u(),
  path: u(),
  headers: A(
    f({
      key: u(),
      value: u(),
      active: w()
    })
  ),
  params: A(
    f({
      key: u(),
      value: u(),
      active: w()
    })
  ),
  name: u(),
  method: u(),
  preRequestScript: u(),
  testScript: u(),
  contentType: u(),
  body: u(),
  rawParams: ce(u()),
  auth: ce(u()),
  httpUser: ce(u()),
  httpPassword: ce(u()),
  bearerToken: ce(u())
}), Uu = b({
  initial: !0,
  schema: lp
}), Vs = f({
  key: u(),
  active: w()
}).and(
  U([
    f({
      isFile: d(!0),
      value: A(Cr(Blob).nullable())
    }),
    f({
      isFile: d(!1),
      value: u()
    })
  ])
);
f({
  contentType: d("multipart/form-data"),
  body: A(Vs)
});
const dp = U([
  f({
    contentType: d(null),
    body: d(null).catch(null)
  }),
  f({
    contentType: d("multipart/form-data"),
    body: A(Vs).catch([])
  }),
  f({
    contentType: U([
      d("application/json"),
      d("application/ld+json"),
      d("application/hal+json"),
      d("application/vnd.api+json"),
      d("application/xml"),
      d("application/x-www-form-urlencoded"),
      d("text/html"),
      d("text/plain")
    ]),
    body: u().catch("")
  })
]), _e = f({
  authType: d("none")
}), be = f({
  authType: d("basic"),
  username: u().catch(""),
  password: u().catch("")
}), Se = f({
  authType: d("bearer"),
  token: u().catch("")
}), fp = f({
  authType: d("oauth-2"),
  token: u().catch(""),
  oidcDiscoveryURL: u().catch(""),
  authURL: u().catch(""),
  accessTokenURL: u().catch(""),
  clientID: u().catch(""),
  scope: u().catch("")
}), Ms = f({
  authType: d("api-key"),
  key: u().catch(""),
  value: u().catch(""),
  addTo: u().catch("Headers")
}), Ae = f({
  authType: d("inherit")
}), hp = K("authType", [
  _e,
  Ae,
  be,
  Se,
  fp,
  Ms
]).and(
  f({
    authActive: w()
  })
), pp = A(
  f({
    key: u().catch(""),
    value: u().catch(""),
    active: w().catch(!0)
  })
), Pc = A(
  f({
    key: u().catch(""),
    value: u().catch(""),
    active: w().catch(!0)
  })
), qc = f({
  v: d("1"),
  id: ce(u()),
  // Firebase Firestore ID
  name: u(),
  method: u(),
  endpoint: u(),
  params: pp,
  headers: Pc,
  preRequestScript: u().catch(""),
  testScript: u().catch(""),
  auth: hp,
  body: dp
});
function yp(e) {
  return {
    contentType: "application/json",
    body: e.contentType === "application/json" ? e.rawParams ?? "" : ""
  };
}
function mp(e) {
  return !e.auth || e.auth === "None" ? {
    authType: "none",
    authActive: !0
  } : e.auth === "Basic Auth" ? {
    authType: "basic",
    authActive: !0,
    username: e.httpUser ?? "",
    password: e.httpPassword ?? ""
  } : e.auth === "Bearer Token" ? {
    authType: "bearer",
    authActive: !0,
    token: e.bearerToken ?? ""
  } : { authType: "none", authActive: !0 };
}
const vp = b({
  initial: !1,
  schema: qc,
  up(e) {
    const {
      url: t,
      path: r,
      headers: n,
      params: a,
      name: s,
      method: i,
      preRequestScript: o,
      testScript: c
    } = e, l = `${t}${r}`, h = yp(e), m = mp(e), E = {
      v: "1",
      endpoint: l,
      headers: n,
      params: a,
      name: s,
      method: i,
      preRequestScript: o,
      testScript: c,
      body: h,
      auth: m
    };
    return e.id && (E.id = e.id), E;
  }
}), $s = A(
  f({
    key: u().catch(""),
    value: u().catch(""),
    active: w().catch(!0)
  })
), Vc = qc.extend({
  v: d("2"),
  requestVariables: $s
}), gp = b({
  initial: !1,
  schema: Vc,
  up(e) {
    return {
      ...e,
      v: "2",
      requestVariables: []
    };
  }
}), Mc = f({
  grantType: d("AUTHORIZATION_CODE"),
  authEndpoint: u().trim(),
  tokenEndpoint: u().trim(),
  clientID: u().trim(),
  clientSecret: u().trim(),
  scopes: u().trim().optional(),
  token: u().catch(""),
  isPKCE: w(),
  codeVerifierMethod: U([d("plain"), d("S256")]).optional()
}), Ir = f({
  grantType: d("CLIENT_CREDENTIALS"),
  authEndpoint: u().trim(),
  clientID: u().trim(),
  clientSecret: u().trim(),
  scopes: u().trim().optional(),
  token: u().catch("")
}), xr = f({
  grantType: d("PASSWORD"),
  authEndpoint: u().trim(),
  clientID: u().trim(),
  clientSecret: u().trim(),
  scopes: u().trim().optional(),
  username: u().trim(),
  password: u().trim(),
  token: u().catch("")
}), It = f({
  grantType: d("IMPLICIT"),
  authEndpoint: u().trim(),
  clientID: u().trim(),
  scopes: u().trim().optional(),
  token: u().catch("")
}), Or = f({
  authType: d("oauth-2"),
  grantTypeInfo: K("grantType", [
    Mc,
    Ir,
    xr,
    It
  ]),
  addTo: re(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), _p = K("authType", [
  _e,
  Ae,
  be,
  Se,
  Or,
  Ms
]).and(
  f({
    authActive: w()
  })
), $c = Vc.extend({
  v: d("3"),
  auth: _p
}), bp = b({
  initial: !1,
  schema: $c,
  up(e) {
    if (e.auth.authType === "oauth-2") {
      const { token: t, accessTokenURL: r, scope: n, clientID: a, authURL: s } = e.auth;
      return {
        ...e,
        v: "3",
        auth: {
          ...e.auth,
          authType: "oauth-2",
          grantTypeInfo: {
            grantType: "AUTHORIZATION_CODE",
            authEndpoint: s,
            tokenEndpoint: r,
            clientID: a,
            clientSecret: "",
            scopes: n,
            isPKCE: !1,
            token: t
          },
          addTo: "HEADERS"
        }
      };
    }
    return {
      ...e,
      v: "3",
      auth: {
        ...e.auth
      }
    };
  }
}), He = Ms.extend({
  addTo: re(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), Sp = K("authType", [
  _e,
  Ae,
  be,
  Se,
  Or,
  He
]).and(
  f({
    authActive: w()
  })
), Nc = $c.extend({
  v: d("4"),
  auth: Sp
}), Ap = b({
  schema: Nc,
  initial: !1,
  up(e) {
    return e.auth.authType === "api-key" ? {
      ...e,
      v: "4",
      auth: {
        ...e.auth,
        addTo: e.auth.addTo === "Query params" ? "QUERY_PARAMS" : "HEADERS"
      }
    } : {
      ...e,
      auth: {
        ...e.auth
      },
      v: "4"
    };
  }
}), Dc = Mc.extend({
  clientSecret: u().optional()
}), kr = Or.extend({
  grantTypeInfo: K("grantType", [
    Dc,
    Ir,
    xr,
    It
  ])
}), jc = K("authType", [
  _e,
  Ae,
  be,
  Se,
  kr,
  He
]).and(
  f({
    authActive: w()
  })
), Hc = Nc.extend({
  v: d("5"),
  auth: jc
}), Tp = b({
  schema: Hc,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "5"
    };
  }
}), Lc = U([
  f({
    contentType: d(null),
    body: d(null).catch(null)
  }),
  f({
    contentType: d("multipart/form-data"),
    body: A(Vs).catch([])
  }),
  f({
    contentType: U([
      d("application/json"),
      d("application/ld+json"),
      d("application/hal+json"),
      d("application/vnd.api+json"),
      d("application/xml"),
      d("text/xml"),
      d("application/x-www-form-urlencoded"),
      d("text/html"),
      d("text/plain")
    ]),
    body: u().catch("")
  })
]), Uc = Hc.extend({
  v: d("6"),
  body: Lc
}), Ep = b({
  schema: Uc,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "6"
    };
  }
}), Pr = Dc.extend({
  refreshToken: u().optional()
}), Kc = f({
  authType: d("oauth-2"),
  grantTypeInfo: K("grantType", [
    Pr,
    Ir,
    xr,
    It
  ]),
  addTo: re(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), Ns = A(
  f({
    key: u().catch(""),
    value: u().catch(""),
    active: w().catch(!0),
    description: u().catch("")
  })
), qr = A(
  f({
    key: u().catch(""),
    value: u().catch(""),
    active: w().catch(!0),
    description: u().catch("")
  })
), nt = f({
  authType: d("aws-signature"),
  accessKey: u().catch(""),
  secretKey: u().catch(""),
  region: u().catch(""),
  serviceName: u().catch(""),
  serviceToken: u().optional(),
  signature: f({}).optional(),
  addTo: re(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), Bc = K("authType", [
  _e,
  Ae,
  be,
  Se,
  Kc,
  He,
  nt
]).and(
  f({
    authActive: w()
  })
), Gc = Uc.extend({
  v: d("7"),
  params: Ns,
  headers: qr,
  auth: Bc
}), Rp = b({
  schema: Gc,
  initial: !1,
  up(e) {
    const t = e.params.map((n) => ({
      ...n,
      description: ""
    })), r = e.headers.map((n) => ({
      ...n,
      description: ""
    }));
    return {
      ...e,
      v: "7",
      params: t,
      headers: r
      // no need to update anything for HoppRESTAuth, because the newly added refreshToken is optional
    };
  }
}), Fc = Ir.extend({
  clientSecret: u().optional()
}), Ds = xr.extend({
  clientSecret: u().optional()
}), wp = f({
  authType: d("oauth-2"),
  grantTypeInfo: K("grantType", [
    Pr,
    Fc,
    Ds,
    It
  ]),
  addTo: re(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), Ut = f({
  authType: d("digest"),
  username: u().catch(""),
  password: u().catch(""),
  realm: u().catch(""),
  nonce: u().catch(""),
  algorithm: re(["MD5", "MD5-sess"]).catch("MD5"),
  qop: re(["auth", "auth-int"]).catch("auth"),
  nc: u().catch(""),
  cnonce: u().catch(""),
  opaque: u().catch(""),
  disableRetry: w().catch(!1)
}), js = K("authType", [
  _e,
  Ae,
  be,
  Se,
  wp,
  He,
  nt,
  Ut
]).and(
  f({
    authActive: w()
  })
), Zc = f({
  v: d("1"),
  name: u(),
  method: u(),
  endpoint: u(),
  headers: qr,
  params: Ns,
  body: Lc,
  auth: js,
  requestVariables: $s
}), Ku = b({
  initial: !0,
  schema: Zc
}), Wc = f({
  key: u(),
  active: w(),
  contentType: u().optional().catch(void 0)
}).and(
  U([
    f({
      isFile: d(!0),
      value: A(Cr(Blob).nullable()).catch([])
    }),
    f({
      isFile: d(!1),
      value: u()
    })
  ])
).transform((e) => e.isFile && Array.isArray(e.value) && e.value.length === 0 ? {
  ...e,
  isFile: !1,
  value: ""
} : e), Jc = U([
  f({
    contentType: d(null),
    body: d(null).catch(null)
  }),
  f({
    contentType: d("multipart/form-data"),
    body: A(Wc).catch([]),
    showIndividualContentType: w().optional().catch(!1)
  }),
  f({
    contentType: d("application/octet-stream"),
    body: Cr(File).nullable().catch(null)
  }),
  f({
    contentType: U([
      d("application/json"),
      d("application/ld+json"),
      d("application/hal+json"),
      d("application/vnd.api+json"),
      d("application/xml"),
      d("text/xml"),
      d("application/x-www-form-urlencoded"),
      d("binary"),
      d("text/html"),
      d("text/plain")
    ]),
    body: u().catch("")
  })
]), zc = Zc.extend({
  v: d("2"),
  body: Jc
}), Cp = b({
  initial: !1,
  schema: zc,
  up(e) {
    return {
      ...e,
      v: "2"
    };
  }
}), Qc = Fc.extend({
  clientAuthentication: re(["AS_BASIC_AUTH_HEADERS", "IN_BODY"])
}), Vr = f({
  authType: d("oauth-2"),
  grantTypeInfo: K("grantType", [
    Pr,
    Qc,
    Ds,
    It
  ]),
  addTo: re(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), Hs = K("authType", [
  _e,
  Ae,
  be,
  Se,
  Vr,
  He,
  nt,
  Ut
]).and(
  f({
    authActive: w()
  })
), Ls = U([
  f({
    contentType: d(null),
    body: d(null).catch(null)
  }),
  f({
    contentType: d("multipart/form-data"),
    body: A(Wc).catch([]),
    showIndividualContentType: w().optional().catch(!1),
    isBulkEditing: w().optional().catch(!1)
  }),
  f({
    contentType: d("application/octet-stream"),
    body: Cr(File).nullable().catch(null)
  }),
  f({
    contentType: d("application/x-www-form-urlencoded"),
    body: u().catch(""),
    isBulkEditing: w().optional().catch(!1)
  }),
  f({
    contentType: U([
      d("application/json"),
      d("application/ld+json"),
      d("application/hal+json"),
      d("application/vnd.api+json"),
      d("application/xml"),
      d("text/xml"),
      d("binary"),
      d("text/html"),
      d("text/plain")
    ]),
    body: u().catch("")
  })
]), Yc = zc.extend({
  v: d("3"),
  auth: Hs,
  body: Ls
}), Ip = b({
  initial: !1,
  schema: Yc,
  up(e) {
    const t = e.auth;
    return {
      ...e,
      v: "3",
      auth: t.authType === "oauth-2" ? {
        ...t,
        grantTypeInfo: t.grantTypeInfo.grantType === "CLIENT_CREDENTIALS" ? {
          ...t.grantTypeInfo,
          clientAuthentication: "IN_BODY"
        } : t.grantTypeInfo
      } : t
    };
  }
}), Us = f({
  authType: d("hawk"),
  authId: u().catch(""),
  authKey: u().catch(""),
  algorithm: re(["sha256", "sha1"]).catch("sha256"),
  includePayloadHash: w().catch(!1),
  // Optional fields
  user: u().optional(),
  nonce: u().optional(),
  ext: u().optional(),
  app: u().optional(),
  dlg: u().optional(),
  timestamp: u().optional()
}), Ks = f({
  authType: d("akamai-eg"),
  accessToken: u().catch(""),
  clientToken: u().catch(""),
  clientSecret: u().catch(""),
  // Optional fields
  nonce: u().optional(),
  timestamp: u().optional(),
  host: u().optional(),
  headersToSign: u().optional(),
  maxBodySize: u().optional()
}), Bs = K("authType", [
  _e,
  Ae,
  be,
  Se,
  Vr,
  He,
  nt,
  Ut,
  Us,
  Ks
]).and(
  f({
    authActive: w()
  })
), Xc = Yc.extend({
  v: d("4"),
  auth: Bs
}), xp = b({
  initial: !1,
  schema: Xc,
  up(e) {
    return {
      ...e,
      v: "4"
    };
  }
}), el = f({
  authType: d("jwt"),
  secret: u().catch(""),
  privateKey: u().catch(""),
  // For RSA/ECDSA algorithms
  algorithm: re([
    "HS256",
    "HS384",
    "HS512",
    "RS256",
    "RS384",
    "RS512",
    "PS256",
    "PS384",
    "PS512",
    "ES256",
    "ES384",
    "ES512"
  ]).catch("HS256"),
  payload: u().catch("{}"),
  addTo: re(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS"),
  isSecretBase64Encoded: w().catch(!1),
  headerPrefix: u().catch("Bearer "),
  paramName: u().catch("token"),
  jwtHeaders: u().catch("{}")
}), Gs = K("authType", [
  _e,
  Ae,
  be,
  Se,
  Vr,
  He,
  nt,
  Ut,
  Us,
  Ks,
  el
]).and(
  f({
    authActive: w()
  })
), tl = Xc.extend({
  v: d("5"),
  auth: Gs
}), Op = b({
  initial: !1,
  schema: tl,
  up(e) {
    return {
      ...e,
      v: "5"
    };
  }
}), De = f({
  id: tt(),
  key: u(),
  value: u(),
  active: w(),
  sendIn: re(["headers", "url", "body"]).catch("headers")
}), rl = De.omit({ sendIn: !0 }), kp = Pr.extend({
  authRequestParams: A(rl).optional().default([]),
  tokenRequestParams: A(De).optional().default([]),
  refreshRequestParams: A(De).optional().default([])
}), Pp = Qc.extend({
  tokenRequestParams: A(De).optional().default([]),
  refreshRequestParams: A(De).optional().default([])
}), qp = Ds.extend({
  tokenRequestParams: A(De).optional().default([]),
  refreshRequestParams: A(De).optional().default([])
}), Vp = It.extend({
  authRequestParams: A(rl).optional().default([]),
  refreshRequestParams: A(De).optional().default([])
}), nl = f({
  authType: d("oauth-2"),
  grantTypeInfo: K("grantType", [
    kp,
    Pp,
    qp,
    Vp
  ]),
  addTo: re(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), Mr = K("authType", [
  _e,
  Ae,
  be,
  Se,
  nl,
  He,
  nt,
  Ut,
  Us,
  Ks,
  el
]).and(
  f({
    authActive: w()
  })
), Mp = tl.extend({
  v: d("6"),
  auth: Mr
}), $p = b({
  initial: !1,
  schema: Mp,
  up(e) {
    let t;
    if (e.auth.authType === "oauth-2") {
      const r = e.auth.grantTypeInfo;
      let n;
      r.grantType === "AUTHORIZATION_CODE" ? n = {
        ...r,
        authRequestParams: [],
        tokenRequestParams: [],
        refreshRequestParams: []
      } : r.grantType === "CLIENT_CREDENTIALS" ? n = {
        ...r,
        tokenRequestParams: [],
        refreshRequestParams: []
      } : r.grantType === "PASSWORD" ? n = {
        ...r,
        tokenRequestParams: [],
        refreshRequestParams: []
      } : r.grantType === "IMPLICIT" ? n = {
        ...r,
        authRequestParams: [],
        refreshRequestParams: []
      } : n = r, t = {
        ...e.auth,
        grantTypeInfo: n
      };
    } else
      t = e.auth;
    return {
      ...e,
      v: "6",
      auth: t
    };
  }
}), Np = f({
  // v is a stringified number
  v: u().regex(/^\d+$/).transform(Number)
}), Dp = rt({
  latestVersion: 6,
  versionMap: {
    1: Ku,
    2: Cp,
    3: Ip,
    4: xp,
    5: Op,
    6: $p
  },
  getVersion(e) {
    const t = Np.safeParse(e);
    return t.success ? t.data.v : Ku.schema.safeParse(e).success ? 1 : null;
  }
}), jp = "6", Hp = {
  // 1xx Informational
  // Request received, continuing process.[2]
  // This class of status code indicates a provisional response, consisting only of the Status-Line and optional headers, and is terminated by an empty line. Since HTTP/1.0 did not define any 1xx status codes, servers must not send a 1xx response to an HTTP/1.0 client except under experimental conditions.
  100: "Continue",
  // This means that the server has received the request headers, and that the client should proceed to send the request body (in the case of a request for which a body needs to be sent; for example, a POST request). If the request body is large, sending it to a server when a request has already been rejected based upon inappropriate headers is inefficient. To have a server check if the request could be accepted based on the request's headers alone, a client must send Expect: 100-continue as a header in its initial request[2] and check if a 100 Continue status code is received in response before continuing (or receive 417 Expectation Failed and not continue).[2]
  101: "Switching Protocols",
  // This means the requester has asked the server to switch protocols and the server is acknowledging that it will do so.[2]
  102: "Processing",
  // (WebDAV; RFC 2518) As a WebDAV request may contain many sub-requests involving file operations, it may take a long time to complete the request. This code indicates that the server has received and is processing the request, but no response is available yet.[3] This prevents the client from timing out and assuming the request was lost.
  // 2xx Success
  // This class of status codes indicates the action requested by the client was received, understood, accepted and processed successfully.
  200: "OK",
  // Standard response for successful HTTP requests. The actual response will depend on the request method used. In a GET request, the response will contain an entity corresponding to the requested resource. In a POST request the response will contain an entity describing or containing the result of the action.[2]
  201: "Created",
  // The request has been fulfilled and resulted in a new resource being created.[2]
  202: "Accepted",
  // The request has been accepted for processing, but the processing has not been completed. The request might or might not eventually be acted upon, as it might be disallowed when processing actually takes place.[2]
  203: "Non-Authoritative Information",
  // (since HTTP/1.1) The server successfully processed the request, but is returning information that may be from another source.[2]
  204: "No Content",
  // The server successfully processed the request, but is not returning any content.[2]
  205: "Reset Content",
  // The server successfully processed the request, but is not returning any content. Unlike a 204 response, this response requires that the requester reset the document view.[2]
  206: "Partial Content",
  // The server is delivering only part of the resource due to a range header sent by the client. The range header is used by tools like wget to enable resuming of interrupted downloads, or split a download into multiple simultaneous streams.[2]
  207: "Multi-Status",
  // (WebDAV; RFC 4918) The message body that follows is an XML message and can contain a number of separate response codes, depending on how many sub-requests were made.[4]
  208: "Already Reported",
  // (WebDAV; RFC 5842) The members of a DAV binding have already been enumerated in a previous reply to this request, and are not being included again.
  226: "IM Used",
  // (RFC 3229) The server has fulfilled a GET request for the resource, and the response is a representation of the result of one or more instance-manipulations applied to the current instance. [5]
  // 3xx Redirection
  // The client must take additional action to complete the request.[2]
  // This class of status code indicates that further action needs to be taken by the user agent in order to fulfil the request. The action required may be carried out by the user agent without interaction with the user if and only if the method used in the second request is GET or HEAD. A user agent should not automatically redirect a request more than five times, since such redirections usually indicate an infinite loop.
  300: "Multiple Choices",
  // Indicates multiple options for the resource that the client may follow. It, for instance, could be used to present different format options for video, list files with different extensions, or word sense disambiguation.[2]
  301: "Moved Permanently",
  // This and all future requests should be directed to the given URI.[2]
  302: "Found",
  // This is an example of industry practice contradicting the standard.[2] The HTTP/1.0 specification (RFC 1945) required the client to perform a temporary redirect (the original describing phrase was "Moved Temporarily"),[6] but popular browsers implemented 302 with the functionality of a 303 See Other. Therefore, HTTP/1.1 added status codes 303 and 307 to distinguish between the two behaviours.[7] However, some Web applications and frameworks use the 302 status code as if it were the 303.[citation needed]
  303: "See Other",
  // (since HTTP/1.1) The response to the request can be found under another URI using a GET method. When received in response to a POST (or PUT/DELETE), it should be assumed that the server has received the data and the redirect should be issued with a separate GET message.[2]
  304: "Not Modified",
  // Indicates the resource has not been modified since last requested.[2] Typically, the HTTP client provides a header like the If-Modified-Since header to provide a time against which to compare. Using this saves bandwidth and reprocessing on both the server and client, as only the header data must be sent and received in comparison to the entirety of the page being re-processed by the server, then sent again using more bandwidth of the server and client.
  305: "Use Proxy",
  // (since HTTP/1.1) Many HTTP clients (such as Mozilla[8] and Internet Explorer) do not correctly handle responses with this status code, primarily for security reasons.[2]
  306: "Switch Proxy",
  // No longer used.[2] Originally meant "Subsequent requests should use the specified proxy."[9]
  307: "Temporary Redirect",
  // (since HTTP/1.1) In this case, the request should be repeated with another URI; however, future requests can still use the original URI.[2] In contrast to 302, the request method should not be changed when reissuing the original request. For instance, a POST request must be repeated using another POST request.
  308: "Permanent Redirect",
  // (experimental Internet-Draft)[10] The request, and all future requests should be repeated using another URI. 307 and 308 (as proposed) parallel the behaviours of 302 and 301, but do not require the HTTP method to change. So, for example, submitting a form to a permanently redirected resource may continue smoothly.
  // 4xx Client Error
  // The 4xx class of status code is intended for cases in which the client seems to have erred. Except when responding to a HEAD request, the server should include an entity containing an explanation of the error situation, and whether it is a temporary or permanent condition. These status codes are applicable to any request method. User agents should display any included entity to the user.
  400: "Bad Request",
  // The request cannot be fulfilled due to bad syntax.[2]
  401: "Unauthorized",
  // Similar to 403 Forbidden, but specifically for use when authentication is possible but has failed or not yet been provided.[2] The response must include a WWW-Authenticate header field containing a challenge applicable to the requested resource. See Basic access authentication and Digest access authentication.
  402: "Payment Required",
  // Reserved for future use.[2] The original intention was that this code might be used as part of some form of digital cash or micropayment scheme, but that has not happened, and this code is not usually used. As an example of its use, however, Apple's MobileMe service generates a 402 error ("httpStatusCode:402" in the Mac OS X Console log) if the MobileMe account is delinquent.[citation needed]
  403: "Forbidden",
  // The request was a legal request, but the server is refusing to respond to it.[2] Unlike a 401 Unauthorized response, authenticating will make no difference.[2]
  404: "Not Found",
  // The requested resource could not be found but may be available again in the future.[2] Subsequent requests by the client are permissible.
  405: "Method Not Allowed",
  // A request was made of a resource using a request method not supported by that resource;[2] for example, using GET on a form which requires data to be presented via POST, or using PUT on a read-only resource.
  406: "Not Acceptable",
  // The requested resource is only capable of generating content not acceptable according to the Accept headers sent in the request.[2]
  407: "Proxy Authentication Required",
  // The client must first authenticate itself with the proxy.[2]
  408: "Request Timeout",
  // The server timed out waiting for the request.[2] According to W3 HTTP specifications: "The client did not produce a request within the time that the server was prepared to wait. The client MAY repeat the request without modifications at any later time."
  409: "Conflict",
  // Indicates that the request could not be processed because of conflict in the request, such as an edit conflict.[2]
  410: "Gone",
  // Indicates that the resource requested is no longer available and will not be available again.[2] This should be used when a resource has been intentionally removed and the resource should be purged. Upon receiving a 410 status code, the client should not request the resource again in the future. Clients such as search engines should remove the resource from their indices. Most use cases do not require clients and search engines to purge the resource, and a "404 Not Found" may be used instead.
  411: "Length Required",
  // The request did not specify the length of its content, which is required by the requested resource.[2]
  412: "Precondition Failed",
  // The server does not meet one of the preconditions that the requester put on the request.[2]
  413: "Request Entity Too Large",
  // The request is larger than the server is willing or able to process.[2]
  414: "Request-URI Too Long",
  // The URI provided was too long for the server to process.[2]
  415: "Unsupported Media Type",
  // The request entity has a media type which the server or resource does not support.[2] For example, the client uploads an image as image/svg+xml, but the server requires that images use a different format.
  416: "Requested Range Not Satisfiable",
  // The client has asked for a portion of the file, but the server cannot supply that portion.[2] For example, if the client asked for a part of the file that lies beyond the end of the file.[2]
  417: "Expectation Failed",
  // The server cannot meet the requirements of the Expect request-header field.[2]
  418: "I'm a teapot",
  // (RFC 2324) This code was defined in 1998 as one of the traditional IETF April Fools' jokes, in RFC 2324, Hyper Text Coffee Pot Control Protocol, and is not expected to be implemented by actual HTTP servers. However, known implementations do exist.[11]
  420: "Enhance Your Calm",
  // (Twitter) Returned by the Twitter Search and Trends API when the client is being rate limited.[12] Likely a reference to this number's association with marijuana. Other services may wish to implement the 429 Too Many Requests response code instead. The phrase "Enhance Your Calm" is a reference to Demolition Man (film). In the film, Sylvester Stallone's character John Spartan is a hot-head in a generally more subdued future, and is regularly told to "Enhance your calm" rather than a more common phrase like "calm down".
  422: "Unprocessable Entity",
  // (WebDAV; RFC 4918) The request was well-formed but was unable to be followed due to semantic errors.[4]
  423: "Locked",
  // (WebDAV; RFC 4918) The resource that is being accessed is locked.[4]
  424: "Failed Dependency",
  // (WebDAV; RFC 4918) The request failed due to failure of a previous request (e.g. a PROPPATCH).[4]
  425: "Unordered Collection",
  // (Internet draft) Defined in drafts of "WebDAV Advanced Collections Protocol",[14] but not present in "Web Distributed Authoring and Versioning (WebDAV) Ordered Collections Protocol".[15]
  426: "Upgrade Required",
  // (RFC 2817) The client should switch to a different protocol such as TLS/1.0.[16]
  428: "Precondition Required",
  // (RFC 6585) The origin server requires the request to be conditional. Intended to prevent "the 'lost update' problem, where a client GETs a resource's state, modifies it, and PUTs it back to the server, when meanwhile a third party has modified the state on the server, leading to a conflict."[17]
  429: "Too Many Requests",
  // (RFC 6585) The user has sent too many requests in a given amount of time. Intended for use with rate limiting schemes.[17]
  431: "Request Header Fields Too Large",
  // (RFC 6585) The server is unwilling to process the request because either an individual header field, or all the header fields collectively, are too large.[17]
  444: "No Response",
  // (Nginx) Used in Nginx logs to indicate that the server has returned no information to the client and closed the connection (useful as a deterrent for malware).
  449: "Retry With",
  // (Microsoft) A Microsoft extension. The request should be retried after performing the appropriate action.[18] Often search-engines or custom applications will ignore required parameters. Where no default action is appropriate, the Aviongoo website sends a "HTTP/1.1 449 Retry with valid parameters: param1, param2, . . ." response. The applications may choose to learn, or not.
  450: "Blocked by Windows Parental Controls",
  // (Microsoft) A Microsoft extension. This error is given when Windows Parental Controls are turned on and are blocking access to the given webpage.[19]
  451: "Unavailable For Legal Reasons",
  // (Internet draft) Defined in the internet draft "A New HTTP Status Code for Legally-restricted Resources",[20]. Intended to be used when resource access is denied for legal reasons, e.g. censorship or government-mandated blocked access. Likely a reference to the 1953 dystopian novel Fahrenheit 451, where books are outlawed.
  499: "Client Closed Request",
  // (Nginx) Used in Nginx logs to indicate when the connection has been closed by client while the server is still processing its request, making server unable to send a status code back.[21]
  // 5xx Server Error
  // The server failed to fulfill an apparently valid request.[2]
  // Response status codes beginning with the digit "5" indicate cases in which the server is aware that it has encountered an error or is otherwise incapable of performing the request. Except when responding to a HEAD request, the server should include an entity containing an explanation of the error situation, and indicate whether it is a temporary or permanent condition. Likewise, user agents should display any included entity to the user. These response codes are applicable to any request method.
  500: "Internal Server Error",
  // A generic error message, given when no more specific message is suitable.[2]
  501: "Not Implemented",
  // The server either does not recognise the request method, or it lacks the ability to fulfill the request.[2]
  502: "Bad Gateway",
  // The server was acting as a gateway or proxy and received an invalid response from the upstream server.[2]
  503: "Service Unavailable",
  // The server is currently unavailable (because it is overloaded or down for maintenance).[2] Generally, this is a temporary state.
  504: "Gateway Timeout",
  // The server was acting as a gateway or proxy and did not receive a timely response from the upstream server.[2]
  505: "HTTP Version Not Supported",
  // The server does not support the HTTP protocol version used in the request.[2]
  506: "Variant Also Negotiates",
  // (RFC 2295) Transparent content negotiation for the request results in a circular reference.[22]
  507: "Insufficient Storage",
  // (WebDAV; RFC 4918) The server is unable to store the representation needed to complete the request.[4]
  508: "Loop Detected",
  // (WebDAV; RFC 5842) The server detected an infinite loop while processing the request (sent in lieu of 208).
  509: "Bandwidth Limit Exceeded",
  // (Apache bw/limited extension) This status code, while used by many servers, is not specified in any RFCs.
  510: "Not Extended",
  // (RFC 2774) Further extensions to the request are required for the server to fulfill it.[23]
  511: "Network Authentication Required",
  // (RFC 6585) The client needs to authenticate to gain network access. Intended for use by intercepting proxies used to control access to the network (e.g. "captive portals" used to require agreement to Terms of Service before granting full Internet access via a Wi-Fi hotspot).[17]
  598: "Network read timeout error",
  // (Unknown) This status code is not specified in any RFCs, but is used by Microsoft Corp. HTTP proxies to signal a network read timeout behind the proxy to a client in front of the proxy.
  599: "Network connect timeout error"
  // (Unknown) This status code is not specified in any RFCs, but is used by Microsoft Corp. HTTP proxies to signal a network connect timeout behind the proxy to a client in front of the proxy.
}, Lp = U(
  Object.keys(Hp).map((e) => d(parseInt(e)))
), Up = A(
  f({
    key: u(),
    value: u()
  })
), Kp = f({
  name: u(),
  originalRequest: At(Dp),
  status: u(),
  code: ce(Lp).nullable().catch(null),
  headers: Up,
  body: u()
}), Bu = b({
  initial: !0,
  schema: Kp
}), Bp = f({
  v: tt()
}), Gp = rt({
  latestVersion: 0,
  versionMap: {
    0: Bu
  },
  getVersion(e) {
    const t = Bp.safeParse(e);
    return t.success ? t.data.v : Bu.schema.safeParse(e).success ? 0 : null;
  }
}), al = Wh(
  u(),
  At(Gp)
);
function cg(e) {
  return {
    v: jp,
    ...e
  };
}
const sl = Gc.extend({
  v: d("8"),
  auth: js,
  responses: al
}), Fp = b({
  schema: sl,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "8",
      // no need to update anything for HoppRESTAuth, because we loosened the previous schema by making `clientSecret` optional
      responses: {}
    };
  }
}), il = sl.extend({
  v: d("9"),
  body: Jc
}), Zp = b({
  schema: il,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "9"
    };
  }
}), ol = il.extend({
  v: d("10"),
  body: Ls
}), Wp = b({
  schema: ol,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "10"
    };
  }
}), ul = ol.extend({
  v: d("11"),
  auth: Hs
}), Jp = b({
  schema: ul,
  initial: !1,
  up(e) {
    const t = e.auth;
    return {
      ...e,
      v: "11",
      auth: t.authType === "oauth-2" ? {
        ...t,
        grantTypeInfo: t.grantTypeInfo.grantType === "CLIENT_CREDENTIALS" ? {
          ...t.grantTypeInfo,
          clientAuthentication: "IN_BODY"
        } : t.grantTypeInfo
      } : t
    };
  }
}), cl = ul.extend({
  v: d("12"),
  auth: Bs
}), zp = b({
  schema: cl,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "12"
    };
  }
}), ll = cl.extend({
  v: d("13"),
  auth: Gs
}), Qp = b({
  schema: ll,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "13"
    };
  }
}), dl = ll.extend({
  v: d("14")
}), Yp = b({
  schema: dl,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "14"
    };
  }
}), fl = dl.extend({
  v: d("15"),
  auth: Mr
}), Xp = b({
  schema: fl,
  initial: !1,
  up(e) {
    let t;
    if (e.auth.authType === "oauth-2") {
      const r = e.auth.grantTypeInfo;
      let n;
      r.grantType === "AUTHORIZATION_CODE" ? n = {
        ...r,
        authRequestParams: [],
        tokenRequestParams: [],
        refreshRequestParams: []
      } : r.grantType === "CLIENT_CREDENTIALS" ? n = {
        ...r,
        tokenRequestParams: [],
        refreshRequestParams: []
      } : r.grantType === "PASSWORD" ? n = {
        ...r,
        tokenRequestParams: [],
        refreshRequestParams: []
      } : r.grantType === "IMPLICIT" ? n = {
        ...r,
        authRequestParams: [],
        refreshRequestParams: []
      } : n = r, t = {
        ...e.auth,
        grantTypeInfo: n
      };
    } else
      t = e.auth;
    return {
      ...e,
      v: "15",
      auth: t
    };
  }
}), ee = [];
for (let e = 0; e < 256; ++e)
  ee.push((e + 256).toString(16).slice(1));
function ey(e, t = 0) {
  return (ee[e[t + 0]] + ee[e[t + 1]] + ee[e[t + 2]] + ee[e[t + 3]] + "-" + ee[e[t + 4]] + ee[e[t + 5]] + "-" + ee[e[t + 6]] + ee[e[t + 7]] + "-" + ee[e[t + 8]] + ee[e[t + 9]] + "-" + ee[e[t + 10]] + ee[e[t + 11]] + ee[e[t + 12]] + ee[e[t + 13]] + ee[e[t + 14]] + ee[e[t + 15]]).toLowerCase();
}
let ss;
const ty = new Uint8Array(16);
function ry() {
  if (!ss) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    ss = crypto.getRandomValues.bind(crypto);
  }
  return ss(ty);
}
const ny = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), Gu = { randomUUID: ny };
function ay(e, t, r) {
  var a;
  if (Gu.randomUUID && !e)
    return Gu.randomUUID();
  e = e || {};
  const n = e.random ?? ((a = e.rng) == null ? void 0 : a.call(e)) ?? ry();
  if (n.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return n[6] = n[6] & 15 | 64, n[8] = n[8] & 63 | 128, ey(n);
}
const Kt = (e = "") => {
  const t = Date.now().toString(36), r = ay();
  return `${e}_${t}_${r}`;
}, sy = fl.extend({
  v: d("16"),
  _ref_id: u().optional()
}), iy = b({
  schema: sy,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: "16",
      _ref_id: e._ref_id ?? Kt("req")
    };
  }
}), oy = {
  "application/json": "json",
  "application/ld+json": "json",
  "application/hal+json": "json",
  "application/vnd.api+json": "json",
  "application/xml": "xml",
  "text/xml": "xml",
  "application/x-www-form-urlencoded": "multipart",
  "multipart/form-data": "multipart",
  "application/octet-stream": "binary",
  "text/html": "html",
  "text/plain": "plain"
}, lg = Object.keys(
  oy
), uy = f({
  // v is a stringified number
  v: u().regex(/^\d+$/).transform(Number)
}), $r = rt({
  latestVersion: 16,
  versionMap: {
    0: Uu,
    1: vp,
    2: gp,
    3: bp,
    4: Ap,
    5: Tp,
    6: Ep,
    7: Rp,
    8: Fp,
    9: Zp,
    10: Wp,
    11: Jp,
    12: zp,
    13: Qp,
    14: Yp,
    15: Xp,
    16: iy
  },
  getVersion(e) {
    const t = uy.safeParse(e);
    return t.success ? t.data.v : Uu.schema.safeParse(e).success ? 0 : null;
  }
}), cy = Kd({
  id: Lu(Ee),
  v: Ee,
  auth: dt,
  body: dt,
  endpoint: Ee,
  headers: as(
    (e) => e.filter((t) => t.key !== "" && t.value !== ""),
    dt
  ),
  params: as(
    (e) => e.filter((t) => t.key !== "" && t.value !== ""),
    dt
  ),
  method: Ee,
  name: Ee,
  preRequestScript: Ee,
  testScript: Ee,
  requestVariables: as(
    (e) => e.filter((t) => t.key !== "" && t.value !== ""),
    dt
  ),
  responses: dt,
  _ref_id: Lu(Ee)
}), hl = "16", dg = cy.equals;
function fg(e, t) {
  const r = Ah(t);
  if (e && typeof e == "object") {
    if ("id" in e && typeof e.id == "string" && (r.id = e.id), "_ref_id" in e && typeof e._ref_id == "string" && (r._ref_id = e._ref_id), "name" in e && typeof e.name == "string" && (r.name = e.name), "method" in e && typeof e.method == "string" && (r.method = e.method), "endpoint" in e && typeof e.endpoint == "string" && (r.endpoint = e.endpoint), "preRequestScript" in e && typeof e.preRequestScript == "string" && (r.preRequestScript = e.preRequestScript), "testScript" in e && typeof e.testScript == "string" && (r.testScript = e.testScript), "body" in e) {
      const n = Ls.safeParse(e.body);
      n.success && (r.body = n.data);
    }
    if ("auth" in e) {
      const n = Mr.safeParse(e.auth);
      n.success && (r.auth = n.data);
    }
    if ("params" in e) {
      const n = Ns.safeParse(e.params);
      n.success && (r.params = n.data);
    }
    if ("headers" in e) {
      const n = qr.safeParse(e.headers);
      n.success && (r.headers = n.data);
    }
    if ("requestVariables" in e) {
      const n = $s.safeParse(e.requestVariables);
      n.success && (r.requestVariables = n.data);
    }
    if ("responses" in e) {
      const n = al.safeParse(e.responses);
      n.success && (r.responses = n.data);
    }
  }
  return r;
}
function hg(e) {
  return {
    v: hl,
    _ref_id: e._ref_id ?? Kt("req"),
    ...e
  };
}
function ly() {
  return {
    v: hl,
    endpoint: "https://echo.hoppscotch.io",
    name: "Untitled",
    params: [],
    headers: [],
    method: "GET",
    auth: {
      authType: "inherit",
      authActive: !0
    },
    preRequestScript: "",
    testScript: "",
    body: {
      contentType: null,
      body: null
    },
    requestVariables: [],
    responses: {},
    _ref_id: Kt("req")
  };
}
function pg(e) {
  return $r.isLatest(e);
}
function dy(e) {
  const t = $r.safeParse(e);
  return t.type === "ok" ? t.value : ly();
}
const Fs = f({
  key: u().catch(""),
  value: u().catch(""),
  active: w().catch(!0)
}), fy = f({
  v: d(1),
  name: u(),
  url: u(),
  headers: A(Fs).catch([]),
  query: u(),
  variables: u()
}), hy = b({
  initial: !0,
  schema: fy
}), Le = f({
  authType: d("none")
}), Ue = f({
  authType: d("basic"),
  username: u().catch(""),
  password: u().catch("")
}), Ke = f({
  authType: d("bearer"),
  token: u().catch("")
}), py = f({
  authType: d("oauth-2"),
  token: u().catch(""),
  oidcDiscoveryURL: u().catch(""),
  authURL: u().catch(""),
  accessTokenURL: u().catch(""),
  clientID: u().catch(""),
  scope: u().catch("")
}), Zs = f({
  authType: d("api-key"),
  key: u().catch(""),
  value: u().catch(""),
  addTo: u().catch("Headers")
}), Be = f({
  authType: d("inherit")
}), yy = K("authType", [
  Le,
  Ue,
  Ke,
  py,
  Zs,
  Be
]).and(
  f({
    authActive: w()
  })
), pl = f({
  id: ce(u()),
  v: d(2),
  name: u(),
  url: u(),
  headers: A(Fs).catch([]),
  query: u(),
  variables: u(),
  auth: yy
}), my = b({
  initial: !1,
  schema: pl,
  up(e) {
    return {
      ...e,
      v: 2,
      auth: {
        authActive: !0,
        authType: "none"
      }
    };
  }
}), vy = K("authType", [
  Le,
  Be,
  Ue,
  Ke,
  Zs,
  Or
  // both rest and gql have the same auth type for oauth2
]).and(
  f({
    authActive: w()
  })
), yl = pl.extend({
  v: d(3),
  auth: vy
}), gy = b({
  initial: !1,
  schema: yl,
  up(e) {
    if (e.auth.authType === "oauth-2") {
      const { token: t, accessTokenURL: r, scope: n, clientID: a, authURL: s } = e.auth;
      return {
        ...e,
        v: 3,
        auth: {
          ...e.auth,
          authType: "oauth-2",
          grantTypeInfo: {
            grantType: "AUTHORIZATION_CODE",
            authEndpoint: s,
            tokenEndpoint: r,
            clientID: a,
            clientSecret: "",
            scopes: n,
            isPKCE: !1,
            token: t
          },
          addTo: "HEADERS"
        }
      };
    }
    return {
      ...e,
      v: 3,
      auth: {
        ...e.auth
      }
    };
  }
}), xt = Zs.extend({
  addTo: re(["HEADERS", "QUERY_PARAMS"]).catch("HEADERS")
}), _y = K("authType", [
  Le,
  Be,
  Ue,
  Ke,
  xt,
  kr
  // both rest and gql have the same auth type for oauth2
]).and(
  f({
    authActive: w()
  })
), ml = yl.extend({
  v: d(4),
  auth: _y
}), by = b({
  initial: !1,
  schema: ml,
  up(e) {
    return e.auth.authType === "api-key" ? {
      ...e,
      v: 4,
      auth: {
        ...e.auth,
        addTo: e.auth.addTo === "Query params" ? "QUERY_PARAMS" : "HEADERS"
      }
    } : {
      ...e,
      v: 4,
      auth: {
        ...e.auth
      }
    };
  }
}), vl = K("authType", [
  Le,
  Be,
  Ue,
  Ke,
  xt,
  kr
  // both rest and gql have the same auth type for oauth2
]).and(
  f({
    authActive: w()
  })
), gl = ml.extend({
  v: d(5),
  auth: vl
}), Sy = b({
  initial: !1,
  schema: gl,
  up(e) {
    return {
      ...e,
      v: 5
    };
  }
}), Nr = nt, _l = f({
  key: u().catch(""),
  value: u().catch(""),
  active: w().catch(!0),
  description: u().catch("")
}), bl = K("authType", [
  Le,
  Be,
  Ue,
  Ke,
  kr,
  xt,
  Nr
]).and(
  f({
    authActive: w()
  })
), Sl = gl.extend({
  v: d(6),
  auth: bl,
  headers: A(_l).catch([])
}), Ay = b({
  schema: Sl,
  initial: !1,
  up(e) {
    const t = e.headers.map((r) => ({
      ...r,
      description: ""
    }));
    return {
      ...e,
      v: 6,
      headers: t
    };
  }
}), Al = K("authType", [
  Le,
  Be,
  Ue,
  Ke,
  Kc,
  xt,
  Nr
]).and(
  f({
    authActive: w()
  })
), Tl = Sl.extend({
  v: d(7),
  auth: Al
}), Ty = b({
  schema: Tl,
  initial: !1,
  up(e) {
    return {
      ...e,
      v: 7
      // no need to update anything for HoppGQLAuth, because we loosened the previous schema by making `clientSecret` optional
    };
  }
}), Dr = K("authType", [
  Le,
  Be,
  Ue,
  Ke,
  Vr,
  xt,
  Nr
]).and(
  f({
    authActive: w()
  })
), El = Tl.extend({
  v: d(8),
  auth: Dr
}), Ey = b({
  schema: El,
  initial: !1,
  up(e) {
    const t = e.auth;
    return {
      ...e,
      v: 8,
      auth: t.authType === "oauth-2" ? {
        ...t,
        grantTypeInfo: t.grantTypeInfo.grantType === "CLIENT_CREDENTIALS" ? {
          ...t.grantTypeInfo,
          clientAuthentication: "IN_BODY"
        } : t.grantTypeInfo
      } : t
    };
  }
}), Rl = K("authType", [
  Le,
  Be,
  Ue,
  Ke,
  nl,
  xt,
  Nr
]).and(
  f({
    authActive: w()
  })
), Ry = El.extend({
  v: d(9),
  auth: Rl
}), wy = b({
  schema: Ry,
  initial: !1,
  up(e) {
    let t;
    if (e.auth.authType === "oauth-2") {
      const r = e.auth.grantTypeInfo;
      let n;
      r.grantType === "AUTHORIZATION_CODE" ? n = {
        ...r,
        authRequestParams: [],
        tokenRequestParams: [],
        refreshRequestParams: []
      } : r.grantType === "CLIENT_CREDENTIALS" ? n = {
        ...r,
        tokenRequestParams: [],
        refreshRequestParams: []
      } : r.grantType === "PASSWORD" ? n = {
        ...r,
        tokenRequestParams: [],
        refreshRequestParams: []
      } : r.grantType === "IMPLICIT" ? n = {
        ...r,
        authRequestParams: [],
        refreshRequestParams: []
      } : n = r, t = {
        ...e.auth,
        grantTypeInfo: n
      };
    } else
      t = e.auth;
    return {
      ...e,
      v: 9,
      auth: t
    };
  }
}), wl = 9, Cy = f({
  v: tt()
}), Ws = rt({
  latestVersion: 9,
  versionMap: {
    1: hy,
    2: my,
    3: gy,
    4: by,
    5: Sy,
    6: Ay,
    7: Ty,
    8: Ey,
    9: wy
  },
  getVersion(e) {
    const t = Cy.safeParse(e);
    return t.success ? t.data.v : null;
  }
}), Iy = `
query Request {
  method
  url
  headers {
    key
    value
  }
}`.trim();
function xy() {
  return {
    v: wl,
    name: "Untitled",
    url: "https://echo.hoppscotch.io/graphql",
    headers: [],
    variables: `
{
  "id": "1"
}`.trim(),
    query: Iy,
    auth: {
      authType: "inherit",
      authActive: !0
    }
  };
}
function Oy(e) {
  const t = Ws.safeParse(e);
  return t.type === "ok" ? t.value : xy();
}
function yg(e) {
  return {
    v: wl,
    ...e
  };
}
const ky = f({
  v: d(1),
  id: ce(u()),
  // For Firestore ID data
  name: u(),
  requests: A(
    de(
      () => U([
        At($r),
        At(Ws)
      ])
    )
  )
}), Py = ky.extend({
  folders: de(() => A(ge(Q, 1)))
}), Fu = b({
  initial: !0,
  schema: Py
}), Cl = f({
  v: d(2),
  id: ce(u()),
  // For Firestore ID data
  name: u(),
  requests: A(
    de(
      () => U([
        At($r),
        At(Ws)
      ])
    )
  ),
  auth: U([jc, vl]),
  headers: U([Pc, A(Fs)])
}), qy = Cl.extend({
  folders: de(() => A(ge(Q, 2)))
}), Vy = b({
  initial: !1,
  schema: qy,
  up(e) {
    const t = {
      ...e,
      v: 2,
      auth: {
        authActive: !0,
        authType: "inherit"
      },
      headers: [],
      folders: e.folders.map((r) => {
        const n = Q.safeParseUpToVersion(r, 2);
        if (n.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return n.value;
      })
    };
    return e.id && (t.id = e.id), t;
  }
}), Il = Cl.extend({
  v: d(3),
  // AWS Signature Authorization type addition
  auth: U([Bc, bl]),
  // `description` field addition under `headers`
  headers: U([qr, A(_l)])
}), My = Il.extend({
  folders: de(() => A(ge(Q, 3)))
}), $y = b({
  initial: !1,
  schema: My,
  up(e) {
    const t = e.headers.map(
      (n) => ({
        ...n,
        description: ""
      })
    );
    return {
      ...e,
      v: 3,
      headers: t,
      folders: e.folders.map((n) => {
        const a = Q.safeParseUpToVersion(n, 3);
        if (a.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return a.value;
      })
    };
  }
}), xl = Il.extend({
  v: d(4),
  auth: U([js, Al])
}), Ny = xl.extend({
  folders: de(() => A(ge(Q, 4)))
}), Dy = b({
  initial: !1,
  schema: Ny,
  up(e) {
    return {
      ...e,
      v: 4,
      folders: e.folders.map((r) => {
        const n = Q.safeParseUpToVersion(r, 4);
        if (n.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return n.value;
      })
    };
  }
}), Ol = xl.extend({
  v: d(5),
  _ref_id: u().optional()
}), jy = Ol.extend({
  folders: de(() => A(ge(Q, 5)))
}), Hy = b({
  initial: !1,
  schema: jy,
  up(e) {
    return {
      ...e,
      v: 5,
      _ref_id: Kt("coll"),
      folders: e.folders.map((r) => {
        const n = Q.safeParseUpToVersion(r, 5);
        if (n.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return n.value;
      })
    };
  }
}), kl = Ol.extend({
  v: d(6),
  auth: U([Hs, Dr])
}), Ly = kl.extend({
  folders: de(() => A(ge(Q, 6)))
}), Uy = b({
  initial: !1,
  schema: Ly,
  up(e) {
    const t = e.auth, r = t.authType === "oauth-2" ? {
      ...t,
      grantTypeInfo: t.grantTypeInfo.grantType === "CLIENT_CREDENTIALS" ? {
        ...t.grantTypeInfo,
        clientAuthentication: "IN_BODY"
      } : t.grantTypeInfo
    } : t;
    return {
      ...e,
      auth: r,
      v: 6,
      folders: e.folders.map((a) => {
        const s = Q.safeParseUpToVersion(a, 6);
        if (s.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return s.value;
      })
    };
  }
}), Pl = kl.extend({
  v: d(7),
  auth: U([Bs, Dr])
}), Ky = Pl.extend({
  folders: de(() => A(ge(Q, 7)))
}), By = b({
  initial: !1,
  schema: Ky,
  up(e) {
    return {
      ...e,
      v: 7,
      folders: e.folders.map((r) => {
        const n = Q.safeParseUpToVersion(r, 7);
        if (n.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return n.value;
      })
    };
  }
}), ql = Pl.extend({
  v: d(8),
  auth: U([Gs, Dr])
}), Gy = ql.extend({
  folders: de(() => A(ge(Q, 8)))
}), Fy = b({
  initial: !1,
  schema: Gy,
  up(e) {
    return {
      ...e,
      v: 8,
      folders: e.folders.map((r) => {
        const n = Q.safeParseUpToVersion(r, 8);
        if (n.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return n.value;
      })
    };
  }
}), Vl = ql.extend({
  v: d(9),
  auth: U([Mr, Rl])
}), Zy = Vl.extend({
  folders: de(() => A(ge(Q, 9)))
}), Wy = b({
  initial: !1,
  schema: Zy,
  up(e) {
    let t;
    if (e.auth.authType === "oauth-2") {
      const n = e.auth.grantTypeInfo;
      let a;
      n.grantType === "AUTHORIZATION_CODE" ? a = {
        ...n,
        authRequestParams: [],
        tokenRequestParams: [],
        refreshRequestParams: []
      } : n.grantType === "CLIENT_CREDENTIALS" ? a = {
        ...n,
        tokenRequestParams: [],
        refreshRequestParams: []
      } : n.grantType === "PASSWORD" ? a = {
        ...n,
        tokenRequestParams: [],
        refreshRequestParams: []
      } : n.grantType === "IMPLICIT" ? a = {
        ...n,
        authRequestParams: [],
        refreshRequestParams: []
      } : a = n, t = {
        ...e.auth,
        grantTypeInfo: a
      };
    } else
      t = e.auth;
    return {
      ...e,
      v: 9,
      auth: t,
      folders: e.folders.map((n) => {
        const a = Q.safeParseUpToVersion(n, 9);
        if (a.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return a.value;
      })
    };
  }
}), Jy = f({
  key: u(),
  initialValue: u(),
  currentValue: u(),
  secret: w()
}), zy = Vl.extend({
  v: d(10),
  variables: A(Jy)
}), Qy = zy.extend({
  folders: de(() => A(ge(Q, 10)))
}), Yy = b({
  initial: !1,
  schema: Qy,
  up(e) {
    return {
      ...e,
      v: 10,
      variables: [],
      folders: e.folders.map((r) => {
        const n = Q.safeParseUpToVersion(r, 10);
        if (n.type !== "ok")
          throw new Error("Failed to migrate child collections");
        return n.value;
      })
    };
  }
}), Xy = f({
  v: tt()
}), Q = rt({
  latestVersion: 10,
  versionMap: {
    1: Fu,
    2: Vy,
    3: $y,
    4: Dy,
    5: Hy,
    6: Uy,
    7: By,
    8: Fy,
    9: Wy,
    10: Yy
  },
  getVersion(e) {
    const t = Xy.safeParse(e);
    return t.success ? t.data.v : Fu.schema.safeParse(e).success ? 1 : null;
  }
}), em = 10;
function Ml(e) {
  return {
    v: em,
    ...e,
    _ref_id: e._ref_id ? e._ref_id : Kt("coll")
  };
}
function tm(e) {
  const t = e.name ?? "Untitled", r = (e.folders ?? []).map(tm), n = (e.requests ?? []).map(dy), a = e.auth ?? { authType: "inherit", authActive: !0 }, s = e.headers ?? [], i = e.variables ?? [], o = Ml({
    name: t,
    folders: r,
    requests: n,
    auth: a,
    headers: s,
    variables: i
  });
  return e.id && (o.id = e.id), e._ref_id && (o._ref_id = e._ref_id), o;
}
function rm(e) {
  const t = e.name ?? "Untitled", r = (e.folders ?? []).map(rm), n = (e.requests ?? []).map(Oy), a = e.auth ?? { authType: "inherit", authActive: !0 }, s = e.headers ?? [], i = e.variables ?? [], o = Ml({
    name: t,
    folders: r,
    requests: n,
    auth: a,
    headers: s,
    variables: i
  });
  return e.id && (o.id = e.id), e._ref_id && (o._ref_id = e._ref_id), o;
}
var Ge = function(e) {
  return function(t) {
    return !e(t);
  };
}, nm = af, am = rf;
function $l(e, t) {
  return t === void 0 ? function(r) {
    return $l(e, r);
  } : am(e, t) ? rc : nc(t[e]);
}
var Nl = function(e) {
  return function(t) {
    return t.map(function(r) {
      return e(r);
    });
  };
}, sm = function(e) {
  return function(t) {
    for (var r = [], n = 0; n < t.length; n++) {
      var a = e(n, t[n]);
      tc(a) && r.push(a.value);
    }
    return r;
  };
}, im = function(e) {
  return sm(function(t, r) {
    return e(r);
  });
}, Dl = function(e) {
  return e.slice();
}, om = tf, Zu = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, a = t.length, s; n < a; n++)
    (s || !(n in t)) && (s || (s = Array.prototype.slice.call(t, 0, n)), s[n] = t[n]);
  return e.concat(s || Array.prototype.slice.call(t));
}, um = function(e) {
  return function(t) {
    return Zu(Zu([], t, !0), [e], !1);
  };
}, cm = um, lm = function(e) {
  return [e];
}, dm = cm, fm = $l, hm = function(e) {
  return function(t) {
    return t.map(function(r) {
      return e(r);
    });
  };
}, pm = function() {
  return {
    concat: function(e, t) {
      return e.concat(t);
    }
  };
}, ym = function() {
  return {
    concat: pm().concat,
    empty: []
  };
}, jr = rc, Bt = nc;
function jl(e) {
  return function(t) {
    return e(t) ? Bt(t) : jr;
  };
}
var ys = function(e) {
  return function(t) {
    return Hl(t) ? jr : Bt(e(t.value));
  };
}, mm = tc, Hl = function(e) {
  return e._tag === "None";
}, vm = function(e, t) {
  return function(r) {
    return Hl(r) ? e() : t(r.value);
  };
}, gm = vm, Js = gm, _m = function(e, t) {
  for (var r = t(e); r._tag === "Left"; )
    r = t(r.left);
  return r.right;
}, Fe = Fd, me = Zd, bm = /* @__PURE__ */ Ld(2, function(e, t) {
  return Tt(e) ? e : t(e.right);
}), Gt = function(e) {
  return function(t) {
    return Tt(t) ? t : me(e(t.right));
  };
}, Hr = function(e) {
  return function(t) {
    return Tt(t) ? Fe(e(t.left)) : t;
  };
}, Tt = Bd, Sm = Gd, Am = function(e) {
  return function(t) {
    return Tt(t) ? e(t.left) : t.right;
  };
}, zs = Am, Wu = bm, pr = function() {
  return pr = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var a in t) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, pr.apply(this, arguments);
}, Ft = function(e, t, r) {
  return me({
    value: e,
    next: t,
    start: r
  });
}, Zt = function(e, t, r) {
  return t === void 0 && (t = []), r === void 0 && (r = !1), Fe({
    input: e,
    expected: t,
    fatal: r
  });
}, Tm = function(e, t) {
  return pr(pr({}, e), { expected: t });
}, Em = function(e, t) {
  return Rm().concat(e, t);
}, Rm = function() {
  return {
    concat: function(e, t) {
      return e.input.cursor < t.input.cursor ? Xd().concat(e, t) : e.input.cursor > t.input.cursor ? Gr().concat(e, t) : Yd({
        input: Gr(),
        fatal: Gr(),
        expected: ym()
      }).concat(e, t);
    }
  };
}, wm = function(e, t) {
  return t === void 0 && (t = 0), {
    buffer: e,
    cursor: t
  };
}, Cm = function(e) {
  return fm(e.cursor, e.buffer);
}, Im = function(e) {
  return e.cursor >= e.buffer.length;
}, xm = function(e) {
  return S(Cm(e), ys(function(t) {
    return { value: t, next: { buffer: e.buffer, cursor: e.cursor + 1 } };
  }));
}, je = function() {
  return je = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var a in t) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, je.apply(this, arguments);
}, Qs = function(e) {
  return function(t) {
    return Ft(e, t, t);
  };
}, Om = function() {
  return function(e) {
    return Zt(e);
  };
}, km = function(e) {
  return function() {
    return Zt(e);
  };
}, X = function(e) {
  return S(Vm(Pm()), at(function(t) {
    var r = t[0], n = t[1];
    return e(r) ? Et(r) : km(n);
  }));
}, Y = function(e, t) {
  return function(r) {
    return S(e(r), Hr(function(n) {
      return Tm(n, [t]);
    }));
  };
}, Pm = function() {
  return function(e) {
    return S(xm(e), Js(function() {
      return Zt(e);
    }, function(t) {
      var r = t.value, n = t.next;
      return Ft(r, n, e);
    }));
  };
}, qm = function(e, t) {
  return function(r) {
    return S(e(r), Wu(function(n) {
      return S(t(n.value)(n.next), Wu(function(a) {
        return Ft(a.value, a.next, r);
      }));
    }));
  };
}, Lr = function(e, t) {
  return function(r) {
    var n = e(r);
    return Sm(n) || n.left.fatal ? n : S(t()(r), Hr(function(a) {
      return Em(n.left, a);
    }));
  };
}, Vm = function(e) {
  return function(t) {
    return S(e(t), Gt(function(r) {
      return je(je({}, r), { value: [r.value, t] });
    }));
  };
}, Ll = function(e) {
  return st(function() {
    return Et(e.empty);
  });
}, Ys = function() {
  return Y(function(e) {
    return Im(e) ? Ft(void 0, e, e) : Zt(e);
  }, "end of file");
}, Mm = function(e) {
  return S(Xs(e), st(function() {
    return Et([]);
  }));
}, Xs = function(e) {
  return S(e, at(function(t) {
    return ti(lm(t), function(r) {
      return S(e, z(function(n) {
        return Fe(dm(n)(r));
      }), st(function() {
        return Et(me(r));
      }));
    });
  }));
}, $m = function(e, t) {
  return function(r) {
    return S(e, at(function() {
      return r;
    }), ri(function() {
      return t;
    }));
  };
}, Ul = function(e) {
  return $m(e, e);
}, Nm = function(e) {
  return Mm(X(Ge(e)));
}, ei = function(e, t) {
  return S(t, z(function() {
    return om;
  }), st(function() {
    return Dm(e, t);
  }));
}, Dm = function(e, t) {
  return S(e, at(function(r) {
    return ti(sf(r), function(n) {
      return S(t, z(function() {
        return me(n);
      }), st(function() {
        return S(e, z(function(a) {
          return Fe(nm(a)(n));
        }));
      }));
    });
  }));
}, Wt = function(e, t) {
  return function(r) {
    return S(e(r), Gt(function(n) {
      return je(je({}, n), { value: t(n.value) });
    }));
  };
}, Kl = function(e, t) {
  return Ur(e, function(r) {
    return Wt(t, r);
  });
}, Ur = function(e, t) {
  return qm(e, t);
}, ti = function(e, t) {
  var r = function(n) {
    return function(a) {
      return Tt(a.value) ? Fe({ value: a.value.left, stream: a.next }) : me(Ft(a.value.right, a.next, n));
    };
  };
  return function(n) {
    return _m({ value: e, stream: n }, function(a) {
      var s = t(a.value)(a.stream);
      return Tt(s) ? me(Zt(a.stream, s.left.expected, s.left.fatal)) : r(n)(s.right);
    });
  };
}, jm = function(e, t) {
  return Lr(e, t);
}, z = function(e) {
  return function(t) {
    return Wt(t, e);
  };
}, Et = Qs, at = function(e) {
  return function(t) {
    return Ur(t, e);
  };
}, ri = function(e) {
  return function(t) {
    return Ur(t, function(r) {
      return Wt(e(r), function() {
        return r;
      });
    });
  };
}, st = function(e) {
  return function(t) {
    return jm(t, e);
  };
}, Hm = "Parser", Lm = function(e) {
  return {
    concat: function(t, r) {
      return Kl(Wt(t, function(n) {
        return function(a) {
          return e.concat(n, a);
        };
      }), r);
    }
  };
}, Um = function(e) {
  return je(je({}, Lm(e)), { empty: Qs(e.empty) });
}, Km = {
  URI: Hm,
  map: Wt,
  ap: Kl,
  chain: Ur,
  chainRec: ti
}, Bl = function(e, t, r) {
  var n;
  return Object.assign({}, e, (n = {}, n[t] = r, n));
}, Gl = function(e) {
  return function(t) {
    return S(t, z(function(r) {
      return Bl({}, e, r);
    }));
  };
}, ms = function(e, t) {
  return function(r) {
    return S(r, at(function(n) {
      return S(t(n), z(function(a) {
        return Bl(n, e, a);
      }));
    }));
  };
}, Bm = function(e) {
  return ef(e)(e.empty);
}, Gm = Ll(bs), Rt = function(e) {
  return Y(X(function(t) {
    return t === e;
  }), '"'.concat(e, '"'));
}, Fm = function(e) {
  return Y(X(function(t) {
    return t !== e;
  }), 'anything but "'.concat(e, '"'));
}, ni = function(e) {
  return Gm(Jt(e));
}, Jt = function(e) {
  return S(Xs(e), z(function(t) {
    return t.join("");
  }));
}, ai = function(e) {
  return "0123456789".indexOf(e) !== -1;
}, vs = Y(X(ai), "a digit"), Zm = /^\s$/, Fl = function(e) {
  return Zm.test(e);
}, Zl = Y(X(Fl), "a whitespace"), Wm = function(e) {
  return e === "_";
}, zt = function(e) {
  return /[a-z]/.test(e.toLowerCase());
}, Wl = function(e) {
  return zt(e) || ai(e) || Wm(e);
};
Y(X(Wl), "a word character");
Y(X(zt), "a letter");
var Jm = function(e) {
  return e.toLowerCase() !== e.toUpperCase();
};
Y(X(Jm), "an unicode letter");
var Jl = function(e) {
  return zt(e) && e === e.toUpperCase();
};
Y(X(Jl), "an upper case letter");
var zl = function(e) {
  return zt(e) && e === e.toLowerCase();
};
Y(X(zl), "a lower case letter");
Y(X(Ge(ai)), "a non-digit");
var Ql = Y(X(Ge(Fl)), "a non-whitespace character");
Y(X(Ge(Wl)), "a non-word character");
Y(X(Ge(zt)), "a non-letter character");
Y(X(Ge(Jl)), "anything but an upper case letter");
Y(X(Ge(zl)), "anything but a lower case letter");
var Yl = function(e) {
  return Y(Km.chainRec(e, function(t) {
    return S(Ym(0, t), Js(function() {
      return Et(me(e));
    }, function(r) {
      return S(Rt(r), at(function() {
        return Et(Fe(t.slice(1)));
      }));
    }));
  }), JSON.stringify(e));
}, gs = Bm(Um(bs)), jt = Ll(bs), zm = function(e) {
  return jt(Qm(e));
}, Qm = function(e) {
  return S(Xs(e), z(function(t) {
    return t.join("");
  }));
}, Ym = function(e, t) {
  return e >= 0 && e < t.length ? Bt(t.charAt(e)) : jr;
}, Xm = ni(Zl);
Jt(Zl);
ni(Ql);
Jt(Ql);
var ev = function(e) {
  var t = +e;
  return isNaN(t) || e === "" ? jr : Bt(t);
};
Y(S(gs([jt(Rt("-")), Jt(vs)]), z(function(e) {
  return +e;
})), "an integer");
Y(S(gs([jt(Rt("-")), ni(vs), jt(gs([Rt("."), Jt(vs)]))]), at(function(e) {
  return S(ev(e), Js(function() {
    return Om();
  }, Qs));
})), "a float");
var tv = Ul(Rt('"'))(zm(Lr(Yl('\\"'), function() {
  return Fm('"');
})));
function Xl(e) {
  return function(t) {
    return t(wm(e.split("")));
  };
}
const Ju = (e, t) => (r) => ({
  ...r,
  [e]: t(r[e])
}), rv = ["#", ":"], wt = Ul(Xm), si = (e) => (t) => t.join(e), ii = (e) => S(
  Nm((t) => e.includes(t)),
  z(si(""))
), nv = $e(
  ii,
  ri(() => X(() => !0))
), ed = S(
  tv,
  z((e) => JSON.parse(`"${e}"`))
), av = S(
  wt(ed),
  st(
    () => S(
      ii([":", `
`]),
      z(ac)
    )
  )
), sv = S(
  wt(ed),
  st(
    () => S(
      ii([`
`]),
      z(ac)
    )
  )
), td = S(
  jt(Yl("#")),
  z(Ge(sc))
), rd = S(
  wt(td),
  Gl("commented"),
  ms("key", () => wt(av)),
  ri(() => Rt(":")),
  ms("value", () => sv)
), iv = S(
  wt(td),
  Gl("commented"),
  ms("key", () => Lr(
    nv([`
`]),
    () => S(
      ei(X((e) => !0), Ys()),
      z($e(
        Dl,
        si("")
      ))
    )
  )),
  z($e(
    jl(({ key: e }) => !sc(e))
  ))
), ov = S(
  ei(wt(rd), Ys())
), uv = S(
  ei(
    Lr(
      S(rd, z(Bt)),
      () => S(
        iv,
        z($e(
          ys((e) => ({ ...e, value: "" }))
        ))
      )
    ),
    Ys()
  ),
  z($e(
    im($e(
      jl(mm),
      ys((e) => e.value)
    ))
  ))
), cv = (e) => {
  if (rv.some((n) => e.includes(n)))
    return !0;
  const t = JSON.stringify(e);
  return t.substring(1, t.length - 1).trim() !== e;
}, zu = (e) => cv(e) ? JSON.stringify(e) : e, mg = (e) => S(
  e,
  hm(
    $e(
      Ju("key", zu),
      Ju("value", zu),
      ({ key: t, value: r, active: n }) => n ? `${t}: ${r}` : `# ${t}: ${r}`
    )
  ),
  si(`
`)
), lv = (e) => S(
  uv,
  Xl(e),
  Hr((t) => ({
    message: `Expected ${t.expected.map((r) => `'${r}'`).join(", ")}`,
    expected: t.expected,
    pos: t.input.cursor
  })),
  Gt(
    ({ value: t }) => S(
      t,
      Nl(
        ({ key: r, value: n, commented: a }) => ({
          active: !a,
          key: r,
          value: n
        })
      )
    )
  )
), vg = (e) => S(
  ov,
  Xl(e),
  Hr((t) => ({
    message: `Expected ${t.expected.map((r) => `'${r}'`).join(", ")}`,
    expected: t.expected,
    pos: t.input.cursor
  })),
  Gt(
    ({ value: t }) => S(
      t,
      Nl(
        ({ key: r, value: n, commented: a }) => ({
          active: !a,
          key: r,
          value: n
        })
      )
    )
  )
), gg = $e(
  lv,
  Gt(Dl),
  zs(() => [])
), dv = f({
  id: ce(u()),
  name: u(),
  variables: A(
    f({
      key: u(),
      value: u()
    })
  )
}), Qu = b({
  initial: !0,
  schema: dv
}), nd = () => Math.random().toString(36).substring(2, 16), ad = f({
  v: d(1),
  id: u(),
  name: u(),
  variables: A(
    U([
      f({
        key: u(),
        secret: d(!0)
      }),
      f({
        key: u(),
        value: u(),
        secret: d(!1).catch(!1)
      })
    ])
  )
}), fv = b({
  initial: !1,
  schema: ad,
  up(e) {
    return {
      ...e,
      v: 1,
      id: e.id || nd(),
      variables: e.variables.map((r) => ({
        ...r,
        secret: !1
      }))
    };
  }
}), hv = ad.extend({
  v: d(2),
  variables: A(
    f({
      key: u(),
      initialValue: u(),
      currentValue: u(),
      secret: w()
    })
  )
}), pv = b({
  initial: !1,
  schema: hv,
  up(e) {
    return {
      ...e,
      v: 2,
      variables: e.variables.map((r) => {
        const { key: n, secret: a } = r;
        return {
          key: n,
          secret: a,
          initialValue: a ? "" : r.value,
          currentValue: a ? "" : r.value
        };
      })
    };
  }
}), sd = [
  // Common
  {
    key: "$guid",
    description: "A v4 style GUID.",
    getValue: () => {
      const e = "0123456789abcdef";
      let t = "";
      for (let r = 0; r < 36; r++)
        r === 8 || r === 13 || r === 18 || r === 23 ? t += "-" : r === 14 ? t += "4" : r === 19 ? t += e.charAt(8 + Math.floor(Math.random() * 4)) : t += e.charAt(
          Math.floor(Math.random() * e.length)
        );
      return t;
    }
  },
  {
    key: "$timestamp",
    description: "The current UNIX timestamp in seconds.",
    getValue: () => Math.floor(Date.now() / 1e3).toString()
  },
  {
    key: "$isoTimestamp",
    description: "The current ISO timestamp at zero UTC.",
    getValue: () => (/* @__PURE__ */ new Date()).toISOString()
  },
  {
    key: "$randomUUID",
    description: "A random 36-character UUID.",
    getValue: () => {
      const e = "0123456789abcdef";
      let t = "";
      for (let r = 0; r < 36; r++)
        r === 8 || r === 13 || r === 18 || r === 23 ? t += "-" : t += e.charAt(
          Math.floor(Math.random() * e.length)
        );
      return t;
    }
  },
  // Text, numbers, and colors
  {
    key: "$randomAlphaNumeric",
    description: "A random alphanumeric character.",
    getValue: () => {
      const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      return e.charAt(Math.floor(Math.random() * e.length));
    }
  },
  {
    key: "$randomBoolean",
    description: "A random boolean value.",
    getValue: () => Math.random() < 0.5 ? "true" : "false"
  },
  {
    key: "$randomInt",
    description: "A random integer between 0 and 1000.",
    getValue: () => Math.floor(Math.random() * 1e3).toString()
  },
  {
    key: "$randomColor",
    description: "A random color.",
    getValue: () => {
      const e = ["red", "green", "blue", "yellow", "purple", "orange"];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomHexColor",
    description: "A random hex value.",
    getValue: () => {
      const e = "0123456789abcdef";
      let t = "#";
      for (let r = 0; r < 6; r++)
        t += e.charAt(
          Math.floor(Math.random() * e.length)
        );
      return t;
    }
  },
  {
    key: "$randomAbbreviation",
    description: "A random abbreviation.",
    getValue: () => {
      const e = [
        "SQL",
        "PCI",
        "JSON",
        "HTML",
        "CSS",
        "JS",
        "TS",
        "API"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  // Internet and IP addresses
  {
    key: "$randomIP",
    description: "A random IPv4 address.",
    getValue: () => Array.from(
      { length: 4 },
      () => Math.floor(Math.random() * 256)
    ).join(".")
  },
  {
    key: "$randomIPV6",
    description: "A random IPv6 address.",
    getValue: () => Array.from(
      { length: 8 },
      () => Math.floor(Math.random() * 65536).toString(16)
    ).join(":")
  },
  {
    key: "$randomMACAddress",
    description: "A random MAC address.",
    getValue: () => Array.from(
      { length: 6 },
      () => Math.floor(Math.random() * 256).toString(16)
    ).join(":")
  },
  {
    key: "$randomPassword",
    description: "A random 15-character alphanumeric password.",
    getValue: () => {
      const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      let t = "";
      for (let r = 0; r < 15; r++)
        t += e.charAt(
          Math.floor(Math.random() * e.length)
        );
      return t;
    }
  },
  {
    key: "$randomLocale",
    description: "A random two-letter language code (ISO 639-1).",
    getValue: () => {
      const e = ["ny", "sr", "si"];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomUserAgent",
    description: "A random user agent.",
    getValue: () => {
      const e = [
        "Mozilla/5.0 (Macintosh; U; Intel Mac OS X 10.9.8; rv:15.6) Gecko/20100101 Firefox/15.6.6",
        "Mozilla/5.0 (Windows NT 6.1; WOW64; rv:15.6) Gecko/20100101 Firefox/15.6.6",
        "Mozilla/5.0 (Windows NT 6.1; WOW64; rv:15.6) Gecko/20100101 Firefox/15.6.6"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomProtocol",
    description: "A random internet protocol.",
    getValue: () => {
      const e = ["http", "https"];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomSemver",
    description: "A random semantic version number.",
    getValue: () => Array.from(
      { length: 3 },
      () => Math.floor(Math.random() * 10)
    ).join(".")
  },
  // Names
  {
    key: "$randomFirstName",
    description: "A random first name.",
    getValue: () => {
      const e = [
        "Ethan",
        "Chandler",
        "Megane",
        "John",
        "Jane",
        "Alice",
        "Bob"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomLastName",
    description: "A random last name.",
    getValue: () => {
      const e = [
        "Schaden",
        "Schneider",
        "Willms",
        "Doe",
        "Smith",
        "Johnson"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomFullName",
    description: "A random first and last name.",
    getValue: () => {
      const e = [
        "Ethan",
        "Chandler",
        "Megane",
        "John",
        "Jane",
        "Alice",
        "Bob"
      ], t = [
        "Schaden",
        "Schneider",
        "Willms",
        "Doe",
        "Smith",
        "Johnson"
      ];
      return `${e[Math.floor(Math.random() * e.length)]} ${t[Math.floor(Math.random() * t.length)]}`;
    }
  },
  {
    key: "$randomNamePrefix",
    description: "A random name prefix.",
    getValue: () => {
      const e = ["Dr.", "Ms.", "Mr.", "Mrs.", "Miss", "Prof."];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomNameSuffix",
    description: "A random name suffix.",
    getValue: () => {
      const e = ["I", "MD", "DDS", "PhD", "Esq.", "Jr."];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  // Company names
  {
    key: "$randomCompanyName",
    description: "A random company name.",
    getValue: () => {
      const e = [
        "Nexora",
        "CodeLoom",
        "BitHaven",
        "SynapseWorks",
        "VoltEdge",
        "Elevoria",
        "Bridgent",
        "Verniq",
        "Corevia",
        "Stratigen",
        "Lunova Studio",
        "Pixelora",
        "MuseMind",
        "BrightNest",
        "Auralis",
        "VerdaFlow",
        "BloomShift",
        "PureTrek",
        "EcoVerse",
        "ReLeaf Labs"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  // Addresses
  {
    key: "$randomCity",
    description: "A random city name.",
    getValue: () => {
      const e = [
        "New York",
        "Los Angeles",
        "Chicago",
        "Houston",
        "Phoenix",
        "Philadelphia"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  // profession
  {
    key: "$randomJobArea",
    description: "A random job area.",
    getValue: () => {
      const e = [
        "Mobility",
        "Intranet",
        "Configuration",
        "Development",
        "Design",
        "Testing"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomJobDescriptor",
    description: "A random job descriptor.",
    getValue: () => {
      const e = [
        "Forward",
        "Corporate",
        "Senior",
        "Junior",
        "Lead",
        "Principal"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomJobTitle",
    description: "A random job title.",
    getValue: () => {
      const e = [
        "International Creative Liaison",
        "Global Branding Officer",
        "Dynamic Data Specialist",
        "Internal Communications Consultant",
        "Productivity Analyst",
        "Regional Applications Developer"
      ];
      return e[Math.floor(Math.random() * e.length)];
    }
  },
  {
    key: "$randomJobType",
    description: "A random job type.",
    getValue: () => {
      const e = ["Supervisor", "Manager", "Coordinator", "Director"];
      return e[Math.floor(Math.random() * e.length)];
    }
  }
  // TODO: Support various other predefined variables
], yv = f({
  v: tt()
}), _g = rt({
  latestVersion: 2,
  versionMap: {
    0: Qu,
    1: fv,
    2: pv
  },
  getVersion(e) {
    const t = yv.safeParse(e);
    return t.success ? t.data.v : Qu.schema.safeParse(e).success ? 0 : null;
  }
}), yr = /<<([^>]*)>>/g, mr = 10, id = "ENV_EXPAND_LOOP", Yu = 2;
function mv(e, t) {
  let r = e, n = 0;
  for (; r.match(yr) != null && n <= mr; )
    r = r.replace(yr, (a) => {
      const s = a.replace(/[<>]/g, ""), i = sd.find(
        (c) => c.key === s
      );
      if (i)
        return i.getValue();
      const o = t.find((c) => c.key === s);
      return o && "currentValue" in o ? o.currentValue : a;
    }), n++;
  return n > mr ? Fe(id) : me(r);
}
const bg = (e, t) => S(
  mv(e, t),
  zs(() => e)
);
function vv(e, t, r = !1, n = !1) {
  if (!t || !e)
    return me(e);
  let a = e, s = 0, i = !1;
  for (; a.match(yr) != null && s <= mr && !i; )
    a = decodeURI(encodeURI(a)).replace(yr, (o, c) => {
      const l = sd.find(
        (m) => m.key === c
      );
      if (l)
        return l.getValue();
      const h = t.find((m) => m && m.key === c);
      return h && "currentValue" in h ? h.secret && n ? (i = !0, `<<${c}>>`) : h.secret && r ? "*".repeat(
        h.currentValue.length
      ) : h.currentValue : "";
    }), s++;
  return s > mr ? Fe(id) : me(a);
}
const Sg = (e, t, r = !1, n = !1) => S(
  vv(e, t, r, n),
  zs(() => e)
), gv = (e) => ({
  key: e.key,
  initialValue: e.initialValue ?? e.value ?? "",
  currentValue: e.currentValue ?? e.value ?? "",
  secret: e.secret ?? !1
}), Ag = (e) => {
  if (e.v && e.v === Yu) return e;
  const t = e.id || nd(), r = e.name ?? "Untitled", n = (e.variables ?? []).map(gv);
  return {
    v: Yu,
    id: t,
    name: r,
    variables: n
  };
}, _v = A(
  U([
    f({
      key: u(),
      value: u(),
      secret: d(!1)
    }),
    f({
      key: u(),
      secret: d(!0)
    }),
    f({
      key: u(),
      value: u()
    })
  ])
), Xu = b({
  initial: !0,
  schema: _v
}), od = f({
  v: d(1),
  variables: A(
    U([
      f({
        key: u(),
        secret: d(!0)
      }),
      f({
        key: u(),
        value: u(),
        secret: d(!1)
      })
    ])
  )
}), bv = b({
  initial: !1,
  schema: od,
  up(e) {
    return {
      v: 1,
      variables: e.map((r) => "value" in r ? {
        key: r.key,
        value: r.value,
        secret: !1
      } : {
        key: r.key,
        secret: !0
      })
    };
  }
}), Sv = od.extend({
  v: d(2),
  variables: A(
    f({
      key: u(),
      initialValue: u(),
      currentValue: u(),
      secret: w()
    })
  )
}), Av = b({
  initial: !1,
  schema: Sv,
  up(e) {
    return {
      ...e,
      v: 2,
      variables: e.variables.map((r) => {
        const { key: n, secret: a } = r;
        return {
          key: n,
          secret: a ?? !1,
          initialValue: r.secret ? "" : r.value,
          currentValue: r.secret ? "" : r.value
        };
      })
    };
  }
}), Tv = f({
  v: tt()
}), Tg = rt({
  latestVersion: 2,
  versionMap: {
    0: Xu,
    1: bv,
    2: Av
  },
  getVersion(e) {
    const t = Tv.safeParse(e);
    return t.success ? t.data.v : Xu.schema.safeParse(e).success ? 0 : null;
  }
});
async function Ev(e = 6) {
  const t = new Uint8Array(e);
  return crypto.getRandomValues(t), Array.from(t).map((r) => r.toString(16).padStart(2, "0")).join("").substring(0, e);
}
function Rv(e) {
  const r = new TextEncoder().encode(e);
  return crypto.subtle.digest("SHA-256", r);
}
function wv(e) {
  const r = new TextEncoder().encode(e);
  return crypto.subtle.digest("SHA-1", r);
}
async function Cv(e, t) {
  return t === "sha256" ? Rv(e) : wv(e);
}
async function Iv(e, t, r) {
  const n = new TextEncoder(), a = n.encode(e), s = n.encode(t), i = r === "sha256" ? "SHA-256" : "SHA-1", o = await crypto.subtle.importKey(
    "raw",
    a,
    {
      name: "HMAC",
      hash: { name: i }
    },
    !1,
    ["sign"]
  ), c = await crypto.subtle.sign("HMAC", o, s);
  return btoa(String.fromCharCode.apply(null, [...new Uint8Array(c)]));
}
function ft(e) {
  return e.replace(/\r\n/g, `
`).replace(/\r/g, `
`);
}
async function xv(e, t) {
  if (!e) return "";
  if (e instanceof FormData)
    if (t === "multipart/form-data") {
      const r = [];
      return e.forEach((n, a) => {
        typeof n == "string" ? r.push(`${a}=${n}`) : r.push(`${a}=${n instanceof File ? n.name : "blob"}`);
      }), ft(r.join("&"));
    } else {
      const r = [];
      return e.forEach((n, a) => {
        typeof n == "string" && r.push(`${a}=${encodeURIComponent(n)}`);
      }), ft(r.join("&"));
    }
  if (e instanceof Blob)
    try {
      const r = await e.text();
      return ft(r);
    } catch (r) {
      return console.error("Failed to read blob content", r), "";
    }
  if (t.includes("application/json") && typeof e == "string")
    try {
      const r = JSON.parse(e);
      return ft(JSON.stringify(r));
    } catch {
      return ft(e.toString());
    }
  return ft(e.toString());
}
async function Eg(e) {
  const t = e.timestamp !== void 0 && e.timestamp !== null ? e.timestamp : Math.floor(Date.now() / 1e3), r = e.nonce && e.nonce !== "" ? e.nonce : await Ev(), n = new URL(e.url), a = n.hostname, s = n.port || (n.protocol === "https:" ? "443" : "80"), i = n.pathname + n.search, o = {
    ts: t,
    nonce: r,
    method: e.method.toUpperCase(),
    resource: i,
    host: a,
    port: s,
    hash: "",
    ext: e.ext || ""
  };
  if (e.includePayloadHash && e.payload)
    try {
      const m = e.contentType || "text/plain", E = await xv(e.payload, m), D = `hawk.1.payload
${m}
${E}
`, Z = await Cv(D, e.algorithm);
      o.hash = btoa(
        String.fromCharCode.apply(null, [...new Uint8Array(Z)])
      );
    } catch (m) {
      console.error("Error calculating payload hash:", m);
    }
  const c = `hawk.1.header
${o.ts}
${o.nonce}
${o.method}
${o.resource}
${o.host}
${o.port}
${o.hash}
${o.ext}
`, l = await Iv(e.key, c, e.algorithm), h = [
    `Hawk id="${e.id}"`,
    `ts="${o.ts}"`,
    `nonce="${o.nonce}"`,
    `mac="${l}"`
  ];
  return e.ext && e.ext !== "" && h.push(`ext="${e.ext}"`), e.app && e.app !== "" && h.push(`app="${e.app}"`), e.dlg && e.dlg !== "" && h.push(`dlg="${e.dlg}"`), o.hash !== "" && h.push(`hash="${o.hash}"`), h.join(", ");
}
async function Rg(e) {
  const t = new TextEncoder();
  new TextDecoder();
  const r = e.timestamp || Math.floor(Date.now() / 1e3).toString(), n = e.nonce || crypto.randomUUID(), a = e.host || new URL(e.url).host, s = await crypto.subtle.importKey(
    "raw",
    t.encode(e.clientSecret),
    { name: "HMAC", hash: "SHA-256" },
    !1,
    ["sign"]
  );
  await crypto.subtle.sign(
    "HMAC",
    s,
    t.encode(r)
  );
  let i = "";
  if (e.body) {
    const m = await crypto.subtle.digest(
      "SHA-256",
      t.encode(e.body)
    );
    i = Array.from(new Uint8Array(m)).map((E) => E.toString(16).padStart(2, "0")).join("");
  }
  const o = `${e.method} ${e.url} ${a} ${r} ${n} ${i}`, c = await crypto.subtle.sign(
    "HMAC",
    s,
    t.encode(o)
  ), l = btoa(
    String.fromCharCode(...new Uint8Array(c))
  );
  return `EG1-HMAC-SHA256 client_token=${e.clientToken};access_token=${e.accessToken};timestamp=${r};nonce=${n};signature=${l}`;
}
const vt = new TextEncoder(), vr = new TextDecoder();
function Ov(...e) {
  const t = e.reduce((a, { length: s }) => a + s, 0), r = new Uint8Array(t);
  let n = 0;
  for (const a of e)
    r.set(a, n), n += a.length;
  return r;
}
function kv(e) {
  if (Uint8Array.prototype.toBase64)
    return e.toBase64();
  const t = 32768, r = [];
  for (let n = 0; n < e.length; n += t)
    r.push(String.fromCharCode.apply(null, e.subarray(n, n + t)));
  return btoa(r.join(""));
}
function Pv(e) {
  if (Uint8Array.fromBase64)
    return Uint8Array.fromBase64(e);
  const t = atob(e), r = new Uint8Array(t.length);
  for (let n = 0; n < t.length; n++)
    r[n] = t.charCodeAt(n);
  return r;
}
function qv(e) {
  if (Uint8Array.fromBase64)
    return Uint8Array.fromBase64(typeof e == "string" ? e : vr.decode(e), {
      alphabet: "base64url"
    });
  let t = e;
  t instanceof Uint8Array && (t = vr.decode(t)), t = t.replace(/-/g, "+").replace(/_/g, "/").replace(/\s/g, "");
  try {
    return Pv(t);
  } catch {
    throw new TypeError("The input to be decoded is not correctly encoded.");
  }
}
function is(e) {
  let t = e;
  return typeof t == "string" && (t = vt.encode(t)), Uint8Array.prototype.toBase64 ? t.toBase64({ alphabet: "base64url", omitPadding: !0 }) : kv(t).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}
class Kr extends Error {
  constructor(r, n) {
    var a;
    super(r, n);
    Te(this, "code", "ERR_JOSE_GENERIC");
    this.name = this.constructor.name, (a = Error.captureStackTrace) == null || a.call(Error, this, this.constructor);
  }
}
Te(Kr, "code", "ERR_JOSE_GENERIC");
class Ve extends Kr {
  constructor() {
    super(...arguments);
    Te(this, "code", "ERR_JOSE_NOT_SUPPORTED");
  }
}
Te(Ve, "code", "ERR_JOSE_NOT_SUPPORTED");
class yt extends Kr {
  constructor() {
    super(...arguments);
    Te(this, "code", "ERR_JWS_INVALID");
  }
}
Te(yt, "code", "ERR_JWS_INVALID");
class ud extends Kr {
  constructor() {
    super(...arguments);
    Te(this, "code", "ERR_JWT_INVALID");
  }
}
Te(ud, "code", "ERR_JWT_INVALID");
function fe(e, t = "algorithm.name") {
  return new TypeError(`CryptoKey does not support this operation, its ${t} must be ${e}`);
}
function ht(e, t) {
  return e.name === t;
}
function os(e) {
  return parseInt(e.name.slice(4), 10);
}
function Vv(e) {
  switch (e) {
    case "ES256":
      return "P-256";
    case "ES384":
      return "P-384";
    case "ES512":
      return "P-521";
    default:
      throw new Error("unreachable");
  }
}
function Mv(e, t) {
  if (!e.usages.includes(t))
    throw new TypeError(`CryptoKey does not support this operation, its usages must include ${t}.`);
}
function $v(e, t, r) {
  switch (t) {
    case "HS256":
    case "HS384":
    case "HS512": {
      if (!ht(e.algorithm, "HMAC"))
        throw fe("HMAC");
      const n = parseInt(t.slice(2), 10);
      if (os(e.algorithm.hash) !== n)
        throw fe(`SHA-${n}`, "algorithm.hash");
      break;
    }
    case "RS256":
    case "RS384":
    case "RS512": {
      if (!ht(e.algorithm, "RSASSA-PKCS1-v1_5"))
        throw fe("RSASSA-PKCS1-v1_5");
      const n = parseInt(t.slice(2), 10);
      if (os(e.algorithm.hash) !== n)
        throw fe(`SHA-${n}`, "algorithm.hash");
      break;
    }
    case "PS256":
    case "PS384":
    case "PS512": {
      if (!ht(e.algorithm, "RSA-PSS"))
        throw fe("RSA-PSS");
      const n = parseInt(t.slice(2), 10);
      if (os(e.algorithm.hash) !== n)
        throw fe(`SHA-${n}`, "algorithm.hash");
      break;
    }
    case "Ed25519":
    case "EdDSA": {
      if (!ht(e.algorithm, "Ed25519"))
        throw fe("Ed25519");
      break;
    }
    case "ML-DSA-44":
    case "ML-DSA-65":
    case "ML-DSA-87": {
      if (!ht(e.algorithm, t))
        throw fe(t);
      break;
    }
    case "ES256":
    case "ES384":
    case "ES512": {
      if (!ht(e.algorithm, "ECDSA"))
        throw fe("ECDSA");
      const n = Vv(t);
      if (e.algorithm.namedCurve !== n)
        throw fe(n, "algorithm.namedCurve");
      break;
    }
    default:
      throw new TypeError("CryptoKey does not support this operation");
  }
  Mv(e, r);
}
function cd(e, t, ...r) {
  var n;
  if (r = r.filter(Boolean), r.length > 2) {
    const a = r.pop();
    e += `one of type ${r.join(", ")}, or ${a}.`;
  } else r.length === 2 ? e += `one of type ${r[0]} or ${r[1]}.` : e += `of type ${r[0]}.`;
  return t == null ? e += ` Received ${t}` : typeof t == "function" && t.name ? e += ` Received function ${t.name}` : typeof t == "object" && t != null && (n = t.constructor) != null && n.name && (e += ` Received an instance of ${t.constructor.name}`), e;
}
const Nv = (e, ...t) => cd("Key must be ", e, ...t);
function ld(e, t, ...r) {
  return cd(`Key for the ${e} algorithm must be `, t, ...r);
}
function dd(e) {
  return (e == null ? void 0 : e[Symbol.toStringTag]) === "CryptoKey";
}
function fd(e) {
  return (e == null ? void 0 : e[Symbol.toStringTag]) === "KeyObject";
}
const hd = (e) => dd(e) || fd(e), Dv = (...e) => {
  const t = e.filter(Boolean);
  if (t.length === 0 || t.length === 1)
    return !0;
  let r;
  for (const n of t) {
    const a = Object.keys(n);
    if (!r || r.size === 0) {
      r = new Set(a);
      continue;
    }
    for (const s of a) {
      if (r.has(s))
        return !1;
      r.add(s);
    }
  }
  return !0;
};
function jv(e) {
  return typeof e == "object" && e !== null;
}
const pd = (e) => {
  if (!jv(e) || Object.prototype.toString.call(e) !== "[object Object]")
    return !1;
  if (Object.getPrototypeOf(e) === null)
    return !0;
  let t = e;
  for (; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t;
}, Hv = (e, t) => {
  if (e.startsWith("RS") || e.startsWith("PS")) {
    const { modulusLength: r } = t.algorithm;
    if (typeof r != "number" || r < 2048)
      throw new TypeError(`${e} requires key modulusLength to be 2048 bits or larger`);
  }
};
function Lv(e) {
  let t, r;
  switch (e.kty) {
    case "AKP": {
      switch (e.alg) {
        case "ML-DSA-44":
        case "ML-DSA-65":
        case "ML-DSA-87":
          t = { name: e.alg }, r = e.priv ? ["sign"] : ["verify"];
          break;
        default:
          throw new Ve('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
      }
      break;
    }
    case "RSA": {
      switch (e.alg) {
        case "PS256":
        case "PS384":
        case "PS512":
          t = { name: "RSA-PSS", hash: `SHA-${e.alg.slice(-3)}` }, r = e.d ? ["sign"] : ["verify"];
          break;
        case "RS256":
        case "RS384":
        case "RS512":
          t = { name: "RSASSA-PKCS1-v1_5", hash: `SHA-${e.alg.slice(-3)}` }, r = e.d ? ["sign"] : ["verify"];
          break;
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
          t = {
            name: "RSA-OAEP",
            hash: `SHA-${parseInt(e.alg.slice(-3), 10) || 1}`
          }, r = e.d ? ["decrypt", "unwrapKey"] : ["encrypt", "wrapKey"];
          break;
        default:
          throw new Ve('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
      }
      break;
    }
    case "EC": {
      switch (e.alg) {
        case "ES256":
          t = { name: "ECDSA", namedCurve: "P-256" }, r = e.d ? ["sign"] : ["verify"];
          break;
        case "ES384":
          t = { name: "ECDSA", namedCurve: "P-384" }, r = e.d ? ["sign"] : ["verify"];
          break;
        case "ES512":
          t = { name: "ECDSA", namedCurve: "P-521" }, r = e.d ? ["sign"] : ["verify"];
          break;
        case "ECDH-ES":
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
          t = { name: "ECDH", namedCurve: e.crv }, r = e.d ? ["deriveBits"] : [];
          break;
        default:
          throw new Ve('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
      }
      break;
    }
    case "OKP": {
      switch (e.alg) {
        case "Ed25519":
        case "EdDSA":
          t = { name: "Ed25519" }, r = e.d ? ["sign"] : ["verify"];
          break;
        case "ECDH-ES":
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
          t = { name: e.crv }, r = e.d ? ["deriveBits"] : [];
          break;
        default:
          throw new Ve('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
      }
      break;
    }
    default:
      throw new Ve('Invalid or unsupported JWK "kty" (Key Type) Parameter value');
  }
  return { algorithm: t, keyUsages: r };
}
const Uv = async (e) => {
  if (!e.alg)
    throw new TypeError('"alg" argument is required when "jwk.alg" is not present');
  const { algorithm: t, keyUsages: r } = Lv(e), n = { ...e };
  return n.kty !== "AKP" && delete n.alg, delete n.use, crypto.subtle.importKey("jwk", n, t, e.ext ?? !(e.d || e.priv), e.key_ops ?? r);
}, Kv = (e, t, r, n, a) => {
  if (a.crit !== void 0 && (n == null ? void 0 : n.crit) === void 0)
    throw new e('"crit" (Critical) Header Parameter MUST be integrity protected');
  if (!n || n.crit === void 0)
    return /* @__PURE__ */ new Set();
  if (!Array.isArray(n.crit) || n.crit.length === 0 || n.crit.some((i) => typeof i != "string" || i.length === 0))
    throw new e('"crit" (Critical) Header Parameter MUST be an array of non-empty strings when present');
  let s;
  r !== void 0 ? s = new Map([...Object.entries(r), ...t.entries()]) : s = t;
  for (const i of n.crit) {
    if (!s.has(i))
      throw new Ve(`Extension Header Parameter "${i}" is not recognized`);
    if (a[i] === void 0)
      throw new e(`Extension Header Parameter "${i}" is missing`);
    if (s.get(i) && n[i] === void 0)
      throw new e(`Extension Header Parameter "${i}" MUST be integrity protected`);
  }
  return new Set(n.crit);
};
function oi(e) {
  return pd(e) && typeof e.kty == "string";
}
function Bv(e) {
  return e.kty !== "oct" && (e.kty === "AKP" && typeof e.priv == "string" || typeof e.d == "string");
}
function Gv(e) {
  return e.kty !== "oct" && typeof e.d > "u" && typeof e.priv > "u";
}
function Fv(e) {
  return e.kty === "oct" && typeof e.k == "string";
}
let gt;
const ec = async (e, t, r, n = !1) => {
  gt || (gt = /* @__PURE__ */ new WeakMap());
  let a = gt.get(e);
  if (a != null && a[r])
    return a[r];
  const s = await Uv({ ...t, alg: r });
  return n && Object.freeze(e), a ? a[r] = s : gt.set(e, { [r]: s }), s;
}, Zv = (e, t) => {
  var i;
  gt || (gt = /* @__PURE__ */ new WeakMap());
  let r = gt.get(e);
  if (r != null && r[t])
    return r[t];
  const n = e.type === "public", a = !!n;
  let s;
  if (e.asymmetricKeyType === "x25519") {
    switch (t) {
      case "ECDH-ES":
      case "ECDH-ES+A128KW":
      case "ECDH-ES+A192KW":
      case "ECDH-ES+A256KW":
        break;
      default:
        throw new TypeError("given KeyObject instance cannot be used for this algorithm");
    }
    s = e.toCryptoKey(e.asymmetricKeyType, a, n ? [] : ["deriveBits"]);
  }
  if (e.asymmetricKeyType === "ed25519") {
    if (t !== "EdDSA" && t !== "Ed25519")
      throw new TypeError("given KeyObject instance cannot be used for this algorithm");
    s = e.toCryptoKey(e.asymmetricKeyType, a, [
      n ? "verify" : "sign"
    ]);
  }
  switch (e.asymmetricKeyType) {
    case "ml-dsa-44":
    case "ml-dsa-65":
    case "ml-dsa-87": {
      if (t !== e.asymmetricKeyType.toUpperCase())
        throw new TypeError("given KeyObject instance cannot be used for this algorithm");
      s = e.toCryptoKey(e.asymmetricKeyType, a, [
        n ? "verify" : "sign"
      ]);
    }
  }
  if (e.asymmetricKeyType === "rsa") {
    let o;
    switch (t) {
      case "RSA-OAEP":
        o = "SHA-1";
        break;
      case "RS256":
      case "PS256":
      case "RSA-OAEP-256":
        o = "SHA-256";
        break;
      case "RS384":
      case "PS384":
      case "RSA-OAEP-384":
        o = "SHA-384";
        break;
      case "RS512":
      case "PS512":
      case "RSA-OAEP-512":
        o = "SHA-512";
        break;
      default:
        throw new TypeError("given KeyObject instance cannot be used for this algorithm");
    }
    if (t.startsWith("RSA-OAEP"))
      return e.toCryptoKey({
        name: "RSA-OAEP",
        hash: o
      }, a, n ? ["encrypt"] : ["decrypt"]);
    s = e.toCryptoKey({
      name: t.startsWith("PS") ? "RSA-PSS" : "RSASSA-PKCS1-v1_5",
      hash: o
    }, a, [n ? "verify" : "sign"]);
  }
  if (e.asymmetricKeyType === "ec") {
    const c = (/* @__PURE__ */ new Map([
      ["prime256v1", "P-256"],
      ["secp384r1", "P-384"],
      ["secp521r1", "P-521"]
    ])).get((i = e.asymmetricKeyDetails) == null ? void 0 : i.namedCurve);
    if (!c)
      throw new TypeError("given KeyObject instance cannot be used for this algorithm");
    t === "ES256" && c === "P-256" && (s = e.toCryptoKey({
      name: "ECDSA",
      namedCurve: c
    }, a, [n ? "verify" : "sign"])), t === "ES384" && c === "P-384" && (s = e.toCryptoKey({
      name: "ECDSA",
      namedCurve: c
    }, a, [n ? "verify" : "sign"])), t === "ES512" && c === "P-521" && (s = e.toCryptoKey({
      name: "ECDSA",
      namedCurve: c
    }, a, [n ? "verify" : "sign"])), t.startsWith("ECDH-ES") && (s = e.toCryptoKey({
      name: "ECDH",
      namedCurve: c
    }, a, n ? [] : ["deriveBits"]));
  }
  if (!s)
    throw new TypeError("given KeyObject instance cannot be used for this algorithm");
  return r ? r[t] = s : gt.set(e, { [t]: s }), s;
}, Wv = async (e, t) => {
  if (e instanceof Uint8Array || dd(e))
    return e;
  if (fd(e)) {
    if (e.type === "secret")
      return e.export();
    if ("toCryptoKey" in e && typeof e.toCryptoKey == "function")
      try {
        return Zv(e, t);
      } catch (n) {
        if (n instanceof TypeError)
          throw n;
      }
    let r = e.export({ format: "jwk" });
    return ec(e, r, t);
  }
  if (oi(e))
    return e.k ? qv(e.k) : ec(e, e, t, !0);
  throw new Error("unreachable");
}, mt = (e) => e == null ? void 0 : e[Symbol.toStringTag], _s = (e, t, r) => {
  var n, a;
  if (t.use !== void 0) {
    let s;
    switch (r) {
      case "sign":
      case "verify":
        s = "sig";
        break;
      case "encrypt":
      case "decrypt":
        s = "enc";
        break;
    }
    if (t.use !== s)
      throw new TypeError(`Invalid key for this operation, its "use" must be "${s}" when present`);
  }
  if (t.alg !== void 0 && t.alg !== e)
    throw new TypeError(`Invalid key for this operation, its "alg" must be "${e}" when present`);
  if (Array.isArray(t.key_ops)) {
    let s;
    switch (!0) {
      case r === "sign":
      case e === "dir":
      case e.includes("CBC-HS"):
        s = r;
        break;
      case e.startsWith("PBES2"):
        s = "deriveBits";
        break;
      case /^A\d{3}(?:GCM)?(?:KW)?$/.test(e):
        !e.includes("GCM") && e.endsWith("KW") ? s = "unwrapKey" : s = r;
        break;
      case r === "encrypt":
        s = "wrapKey";
        break;
      case r === "decrypt":
        s = e.startsWith("RSA") ? "unwrapKey" : "deriveBits";
        break;
    }
    if (s && ((a = (n = t.key_ops) == null ? void 0 : n.includes) == null ? void 0 : a.call(n, s)) === !1)
      throw new TypeError(`Invalid key for this operation, its "key_ops" must include "${s}" when present`);
  }
  return !0;
}, Jv = (e, t, r) => {
  if (!(t instanceof Uint8Array)) {
    if (oi(t)) {
      if (Fv(t) && _s(e, t, r))
        return;
      throw new TypeError('JSON Web Key for symmetric algorithms must have JWK "kty" (Key Type) equal to "oct" and the JWK "k" (Key Value) present');
    }
    if (!hd(t))
      throw new TypeError(ld(e, t, "CryptoKey", "KeyObject", "JSON Web Key", "Uint8Array"));
    if (t.type !== "secret")
      throw new TypeError(`${mt(t)} instances for symmetric algorithms must be of type "secret"`);
  }
}, zv = (e, t, r) => {
  if (oi(t))
    switch (r) {
      case "decrypt":
      case "sign":
        if (Bv(t) && _s(e, t, r))
          return;
        throw new TypeError("JSON Web Key for this operation be a private JWK");
      case "encrypt":
      case "verify":
        if (Gv(t) && _s(e, t, r))
          return;
        throw new TypeError("JSON Web Key for this operation be a public JWK");
    }
  if (!hd(t))
    throw new TypeError(ld(e, t, "CryptoKey", "KeyObject", "JSON Web Key"));
  if (t.type === "secret")
    throw new TypeError(`${mt(t)} instances for asymmetric algorithms must not be of type "secret"`);
  if (t.type === "public")
    switch (r) {
      case "sign":
        throw new TypeError(`${mt(t)} instances for asymmetric algorithm signing must be of type "private"`);
      case "decrypt":
        throw new TypeError(`${mt(t)} instances for asymmetric algorithm decryption must be of type "private"`);
    }
  if (t.type === "private")
    switch (r) {
      case "verify":
        throw new TypeError(`${mt(t)} instances for asymmetric algorithm verifying must be of type "public"`);
      case "encrypt":
        throw new TypeError(`${mt(t)} instances for asymmetric algorithm encryption must be of type "public"`);
    }
}, Qv = (e, t, r) => {
  e.startsWith("HS") || e === "dir" || e.startsWith("PBES2") || /^A(?:128|192|256)(?:GCM)?(?:KW)?$/.test(e) || /^A(?:128|192|256)CBC-HS(?:256|384|512)$/.test(e) ? Jv(e, t, r) : zv(e, t, r);
}, Yv = (e, t) => {
  const r = `SHA-${e.slice(-3)}`;
  switch (e) {
    case "HS256":
    case "HS384":
    case "HS512":
      return { hash: r, name: "HMAC" };
    case "PS256":
    case "PS384":
    case "PS512":
      return { hash: r, name: "RSA-PSS", saltLength: parseInt(e.slice(-3), 10) >> 3 };
    case "RS256":
    case "RS384":
    case "RS512":
      return { hash: r, name: "RSASSA-PKCS1-v1_5" };
    case "ES256":
    case "ES384":
    case "ES512":
      return { hash: r, name: "ECDSA", namedCurve: t.namedCurve };
    case "Ed25519":
    case "EdDSA":
      return { name: "Ed25519" };
    case "ML-DSA-44":
    case "ML-DSA-65":
    case "ML-DSA-87":
      return { name: e };
    default:
      throw new Ve(`alg ${e} is not supported either by JOSE or your javascript runtime`);
  }
}, Xv = async (e, t, r) => {
  if (t instanceof Uint8Array) {
    if (!e.startsWith("HS"))
      throw new TypeError(Nv(t, "CryptoKey", "KeyObject", "JSON Web Key"));
    return crypto.subtle.importKey("raw", t, { hash: `SHA-${e.slice(-3)}`, name: "HMAC" }, !1, [r]);
  }
  return $v(t, e, r), t;
}, We = (e) => Math.floor(e.getTime() / 1e3), yd = 60, md = yd * 60, ui = md * 24, eg = ui * 7, tg = ui * 365.25, rg = /^(\+|\-)? ?(\d+|\d+\.\d+) ?(seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)(?: (ago|from now))?$/i, us = (e) => {
  const t = rg.exec(e);
  if (!t || t[4] && t[1])
    throw new TypeError("Invalid time period format");
  const r = parseFloat(t[2]), n = t[3].toLowerCase();
  let a;
  switch (n) {
    case "sec":
    case "secs":
    case "second":
    case "seconds":
    case "s":
      a = Math.round(r);
      break;
    case "minute":
    case "minutes":
    case "min":
    case "mins":
    case "m":
      a = Math.round(r * yd);
      break;
    case "hour":
    case "hours":
    case "hr":
    case "hrs":
    case "h":
      a = Math.round(r * md);
      break;
    case "day":
    case "days":
    case "d":
      a = Math.round(r * ui);
      break;
    case "week":
    case "weeks":
    case "w":
      a = Math.round(r * eg);
      break;
    default:
      a = Math.round(r * tg);
      break;
  }
  return t[1] === "-" || t[4] === "ago" ? -a : a;
};
function Je(e, t) {
  if (!Number.isFinite(t))
    throw new TypeError(`Invalid ${e} input`);
  return t;
}
var F;
class ng {
  constructor(t) {
    ke(this, F);
    if (!pd(t))
      throw new TypeError("JWT Claims Set MUST be an object");
    Pe(this, F, structuredClone(t));
  }
  data() {
    return vt.encode(JSON.stringify(_(this, F)));
  }
  get iss() {
    return _(this, F).iss;
  }
  set iss(t) {
    _(this, F).iss = t;
  }
  get sub() {
    return _(this, F).sub;
  }
  set sub(t) {
    _(this, F).sub = t;
  }
  get aud() {
    return _(this, F).aud;
  }
  set aud(t) {
    _(this, F).aud = t;
  }
  set jti(t) {
    _(this, F).jti = t;
  }
  set nbf(t) {
    typeof t == "number" ? _(this, F).nbf = Je("setNotBefore", t) : t instanceof Date ? _(this, F).nbf = Je("setNotBefore", We(t)) : _(this, F).nbf = We(/* @__PURE__ */ new Date()) + us(t);
  }
  set exp(t) {
    typeof t == "number" ? _(this, F).exp = Je("setExpirationTime", t) : t instanceof Date ? _(this, F).exp = Je("setExpirationTime", We(t)) : _(this, F).exp = We(/* @__PURE__ */ new Date()) + us(t);
  }
  set iat(t) {
    typeof t > "u" ? _(this, F).iat = We(/* @__PURE__ */ new Date()) : t instanceof Date ? _(this, F).iat = Je("setIssuedAt", We(t)) : typeof t == "string" ? _(this, F).iat = Je("setIssuedAt", We(/* @__PURE__ */ new Date()) + us(t)) : _(this, F).iat = Je("setIssuedAt", t);
  }
}
F = new WeakMap();
const ag = async (e, t, r) => {
  const n = await Xv(e, t, "sign");
  Hv(e, n);
  const a = await crypto.subtle.sign(Yv(e, n.algorithm), n, r);
  return new Uint8Array(a);
};
var Ht, oe, he;
class sg {
  constructor(t) {
    ke(this, Ht);
    ke(this, oe);
    ke(this, he);
    if (!(t instanceof Uint8Array))
      throw new TypeError("payload must be an instance of Uint8Array");
    Pe(this, Ht, t);
  }
  setProtectedHeader(t) {
    if (_(this, oe))
      throw new TypeError("setProtectedHeader can only be called once");
    return Pe(this, oe, t), this;
  }
  setUnprotectedHeader(t) {
    if (_(this, he))
      throw new TypeError("setUnprotectedHeader can only be called once");
    return Pe(this, he, t), this;
  }
  async sign(t, r) {
    if (!_(this, oe) && !_(this, he))
      throw new yt("either setProtectedHeader or setUnprotectedHeader must be called before #sign()");
    if (!Dv(_(this, oe), _(this, he)))
      throw new yt("JWS Protected and JWS Unprotected Header Parameter names must be disjoint");
    const n = {
      ..._(this, oe),
      ..._(this, he)
    }, a = Kv(yt, /* @__PURE__ */ new Map([["b64", !0]]), r == null ? void 0 : r.crit, _(this, oe), n);
    let s = !0;
    if (a.has("b64") && (s = _(this, oe).b64, typeof s != "boolean"))
      throw new yt('The "b64" (base64url-encode payload) Header Parameter must be a boolean');
    const { alg: i } = n;
    if (typeof i != "string" || !i)
      throw new yt('JWS "alg" (Algorithm) Header Parameter missing or invalid');
    Qv(i, t, "sign");
    let o = _(this, Ht);
    s && (o = vt.encode(is(o)));
    let c;
    _(this, oe) ? c = vt.encode(is(JSON.stringify(_(this, oe)))) : c = vt.encode("");
    const l = Ov(c, vt.encode("."), o), h = await Wv(t, i), m = await ag(i, h, l), E = {
      signature: is(m),
      payload: ""
    };
    return s && (E.payload = vr.decode(o)), _(this, he) && (E.header = _(this, he)), _(this, oe) && (E.protected = vr.decode(c)), E;
  }
}
Ht = new WeakMap(), oe = new WeakMap(), he = new WeakMap();
var _t;
class ig {
  constructor(t) {
    ke(this, _t);
    Pe(this, _t, new sg(t));
  }
  setProtectedHeader(t) {
    return _(this, _t).setProtectedHeader(t), this;
  }
  async sign(t, r) {
    const n = await _(this, _t).sign(t, r);
    if (n.payload === void 0)
      throw new TypeError("use the flattened module for creating JWS with b64: false");
    return `${n.protected}.${n.payload}.${n.signature}`;
  }
}
_t = new WeakMap();
var Me, ue;
class og {
  constructor(t = {}) {
    ke(this, Me);
    ke(this, ue);
    Pe(this, ue, new ng(t));
  }
  setIssuer(t) {
    return _(this, ue).iss = t, this;
  }
  setSubject(t) {
    return _(this, ue).sub = t, this;
  }
  setAudience(t) {
    return _(this, ue).aud = t, this;
  }
  setJti(t) {
    return _(this, ue).jti = t, this;
  }
  setNotBefore(t) {
    return _(this, ue).nbf = t, this;
  }
  setExpirationTime(t) {
    return _(this, ue).exp = t, this;
  }
  setIssuedAt(t) {
    return _(this, ue).iat = t, this;
  }
  setProtectedHeader(t) {
    return Pe(this, Me, t), this;
  }
  async sign(t, r) {
    var a;
    const n = new ig(_(this, ue).data());
    if (n.setProtectedHeader(_(this, Me)), Array.isArray((a = _(this, Me)) == null ? void 0 : a.crit) && _(this, Me).crit.includes("b64") && _(this, Me).b64 === !1)
      throw new ud("JWTs MUST NOT use unencoded payload");
    return n.sign(t, r);
  }
}
Me = new WeakMap(), ue = new WeakMap();
async function wg(e) {
  const {
    algorithm: t,
    secret: r,
    privateKey: n,
    payload: a,
    jwtHeaders: s,
    isSecretBase64Encoded: i
  } = e;
  let o = {}, c = {};
  try {
    const l = (a == null ? void 0 : a.trim()) || "{}";
    l === "" ? o = {} : o = JSON.parse(l);
  } catch (l) {
    return console.error("Failed to parse JWT payload JSON:", l), console.error("Payload value:", a), null;
  }
  try {
    const l = (s == null ? void 0 : s.trim()) || "{}";
    l === "" ? c = {} : c = JSON.parse(l);
  } catch (l) {
    return console.error("Failed to parse JWT headers JSON:", l), console.error("Headers value:", s), null;
  }
  try {
    let l;
    if (t.startsWith("RS") || t.startsWith("ES") || t.startsWith("PS")) {
      if (!n)
        return console.error("Private key is required for RSA/ECDSA algorithms"), null;
      l = new TextEncoder().encode(n);
    } else {
      if (!r)
        return console.error("Secret is required for HMAC algorithms"), null;
      l = i ? Uint8Array.from(Buffer.from(r, "base64")) : new TextEncoder().encode(r);
    }
    return await new og(o).setProtectedHeader({
      alg: t,
      ...c
    }).sign(l);
  } catch (l) {
    return console.error("Error generating JWT token:", l), null;
  }
}
const Cg = f({
  name: u(),
  // Cookie name
  value: u(),
  // Cookie value
  domain: u(),
  // Domain the cookie belongs to
  path: u(),
  // Path scope of the cookie (default: "/")
  expires: u().optional(),
  // Expiration date in ISO format, null for session cookies
  maxAge: tt().optional(),
  // Maximum age in seconds, null if not set
  httpOnly: w(),
  // Whether cookie is HTTP-only (not accessible via JavaScript)
  secure: w(),
  // Whether cookie should only be sent over HTTPS
  sameSite: re(["None", "Lax", "Strict"])
  // SameSite attribute for CSRF protection
});
export {
  kp as AuthCodeGrantTypeParams,
  Pp as ClientCredentialsGrantTypeParams,
  em as CollectionSchemaVersion,
  Jy as CollectionVariable,
  Cg as CookieSchema,
  _g as Environment,
  Yu as EnvironmentSchemaVersion,
  Wc as FormDataKeyValue,
  _l as GQLHeader,
  wl as GQL_REQ_SCHEMA_VERSION,
  Tg as GlobalEnvironment,
  sd as HOPP_SUPPORTED_PREDEFINED_VARIABLES,
  Q as HoppCollection,
  Rl as HoppGQLAuth,
  xt as HoppGQLAuthAPIKey,
  Nr as HoppGQLAuthAWSSignature,
  Ue as HoppGQLAuthBasic,
  Ke as HoppGQLAuthBearer,
  Be as HoppGQLAuthInherit,
  Le as HoppGQLAuthNone,
  nl as HoppGQLAuthOAuth2,
  Ws as HoppGQLRequest,
  Mr as HoppRESTAuth,
  He as HoppRESTAuthAPIKey,
  nt as HoppRESTAuthAWSSignature,
  Ks as HoppRESTAuthAkamaiEdgeGrid,
  be as HoppRESTAuthBasic,
  Se as HoppRESTAuthBearer,
  Ut as HoppRESTAuthDigest,
  Us as HoppRESTAuthHAWK,
  Ae as HoppRESTAuthInherit,
  el as HoppRESTAuthJWT,
  _e as HoppRESTAuthNone,
  nl as HoppRESTAuthOAuth2,
  qr as HoppRESTHeaders,
  Ns as HoppRESTParams,
  Ls as HoppRESTReqBody,
  $r as HoppRESTRequest,
  Gp as HoppRESTRequestResponse,
  al as HoppRESTRequestResponses,
  $s as HoppRESTRequestVariables,
  Dp as HoppRESTResponseOriginalRequest,
  Vp as ImplicitOauthFlowParams,
  De as OAuth2AdvancedParam,
  rl as OAuth2AuthRequestParam,
  qp as PasswordGrantTypeParams,
  hl as RESTReqSchemaVersion,
  lg as ValidContentTypesList,
  Rg as calculateAkamaiEdgeGridHeader,
  Eg as calculateHawkHeader,
  wg as generateJWTToken,
  Kt as generateUniqueRefId,
  xy as getDefaultGQLRequest,
  ly as getDefaultRESTRequest,
  dg as isEqualHoppRESTRequest,
  pg as isHoppRESTRequest,
  oy as knownContentTypes,
  Ml as makeCollection,
  yg as makeGQLRequest,
  cg as makeHoppRESTResponseOriginalRequest,
  hg as makeRESTRequest,
  bg as parseBodyEnvVariables,
  mv as parseBodyEnvVariablesE,
  gg as parseRawKeyValueEntries,
  lv as parseRawKeyValueEntriesE,
  Sg as parseTemplateString,
  vv as parseTemplateStringE,
  mg as rawKeyValueEntriesToString,
  fg as safelyExtractRESTRequest,
  vg as strictParseRawKeyValueEntriesE,
  Oy as translateToGQLRequest,
  Ag as translateToNewEnvironment,
  gv as translateToNewEnvironmentVariables,
  rm as translateToNewGQLCollection,
  tm as translateToNewRESTCollection,
  dy as translateToNewRequest
};
